// import React from 'react';
// import './userprofile.css';

// const OrderDetailsView = ({ order, onCancel }) => {
//   if (!order) {
//     return <p>No order details available.</p>;
//   }

//    // Function to update the order status to "Cancelled"
//    const handleCancelClick = async () => {
//     try {
//       // Determine the appropriate endpoint based on order type.
//       // Adjust the logic as needed to suit your order object.
//       let endpoint = "";
//       if (order.bed !== undefined) {
//         // Homeclean order
//         endpoint = `${URL}/homeclean/${order.Id}`;
//       } else if (order.Fan_in_un !== undefined) {
//         // Electrician order
//         endpoint = `${URL}/electrician/${order.Id}`;
//       } else {
//         // Assume Plumber order
//         endpoint = `${URL}/plumber/${order.Id}`;
//       }

//       // Make a PATCH request to update the status to "Cancelled"
//       const response = await fetch(endpoint, {
//         method: 'PATCH',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ status: "Cancelled" })
//       });

//       if (response.ok) {
//         alert("Order has been cancelled.");
//         onCancel(); // Return to order history or refresh as needed
//       } else {
//         const errorData = await response.json();
//         console.error("Failed to cancel order:", errorData);
//         alert("Failed to cancel order.");
//       }
//     } catch (err) {
//       console.error("Error cancelling order:", err);
//       alert("Error cancelling order.");
//     }
//   };

//   return (
//     <div className="order-details-view">
//       <h4>HelpNao - Order Details</h4>
//       <hr />
//       <div className="invoice-header">
//         <div className="invoice-left">
//           <p>
//             <strong>Placed Order Date:</strong> {new Date(order.created_at).toLocaleDateString()}
//           </p>
//           <p>
//             <strong>Service Delivered Date:</strong> {order.date ? new Date(order.date).toLocaleDateString() : 'TBD'}
//           </p>
//         </div>
//         <div className="invoice-right">
//           <p>
//             <strong>Invoice Order#:</strong> {order.Id}
//           </p>
//         </div>
//       </div>

//       {/* Display order status */}
//       {/* <div className="order-status">
//         <p>
//           <strong>Status:</strong> {order.status ? order.status : 'Pending'}
//         </p>
//       </div> */}

//       <div className="invoice-card">
//         <div className="invoice-info">
//           <div className="invoice-left">
//             <p>
//               <strong>User Name:</strong> {order.User ? `${order.User.FirstName} ${order.User.LastName}` : 'Unknown'}
//             </p>
//             <p>
//               <strong>Mobile:</strong> {order.User ? `0${order.User.mobile}` : 'Unknown'}
//             </p>
//             <p>
//               <strong>City:</strong> {order.usercity || order.City}
//             </p>
//             <p>
//               <strong>Address:</strong> {order.useraddress || order.Address}
//             </p>
//           </div>
//           <div className="invoice-right">
//             {order.status === 'Accepted' ? (
//               <>
//                 <p>
//                   <strong>Name:</strong> {order.Servitor ? `${order.Servitor.FirstName} ${order.Servitor.LastName}` : 'N/A'}
//                 </p>
//                 <p>
//                   <strong>Mobile:</strong> {order.Servitor ? order.Servitor.mobile : 'N/A'}
//                 </p>
//                 <p>
//                   <strong>Email:</strong> {order.Servitor ? order.Servitor.email : 'N/A'}
//                 </p>
//                 <p>
//                   <strong>Address:</strong> {order.Servitor ? order.Servitor.Address : 'N/A'}
//                 </p>
//                 <p>
//                   <strong>City:</strong> {order.Servitor ? order.Servitor.city : 'N/A'}
//                 </p>
//                 <p>
//                   <strong>NID:</strong> {order.Servitor ? order.Servitor.NID : 'N/A'}
//                 </p>
//               </>
//             ) : (
//               <p style={{ fontStyle: 'italic', color: '#888' }}>
//                 Servitor has not accepted the order yet.
//               </p>
//             )}
//           </div>
//         </div>
//       </div>

//       <div className="invoice-details">
//         <table>
//           <thead>
//             <tr>
//               <th>Service</th>
//               <th>Details</th>
//               <th>Amount</th>
//             </tr>
//           </thead>
//           <tbody>
//             <tr>
//               <td>{order.Service ? order.Service.services_name : 'Unknown'}</td>
//               <td>
//                 {order.bed !== undefined ? (
//                   <>
//                     <div>
//                       Bedroom: {order.bed}, Bathroom: {order.bath}, Drawing-Dinning: {order.dra_din}
//                     </div>
//                     <div>
//                       Kitchen: {order.kitchen}, Cloths: {order.cloth}, Dishes: {order.dish}
//                     </div>
//                   </>
//                 ) : order.Fan_in_un !== undefined ? (
//                   <>
//                     <div>
//                       Fan Install: {order.Fan_in_un}, Light Install: {order.Light_in_un}, Fan Repair: {order.Fan_repair}, Light Repair: {order.Light_repair}
//                     </div>
//                     <div>
//                       Switch Repair: {order.Switch_repair}, MCB Service: {order.MCB_service}, MDB Service: {order.MDB_service}
//                     </div>
//                   </>
//                 ) : (
//                   <>
//                     <div>
//                       Toilet Install: {order.Toilet_in}, Faucet Install: {order.Faucet_in}, Sink Install: {order.Sink_in}, Dishwasher Install: {order.Dishwasher_in}
//                     </div>
//                     <div>
//                       Leak Repair: {order.Leak_repair}, Faucet Repair: {order.Faucet_repair}, Toilet Repair: {order.Toilet_repair}, Shower Repair: {order.Shower_repair}
//                     </div>
//                     <div>Drain Cleaning: {order.Drain_cleaning}</div>
//                   </>
//                 )}
//               </td>
//               <td>{order.price} tk</td>
//             </tr>
//           </tbody>
//         </table>
//       </div>

//       {/* If order is not accepted, show Cancel button */}
//       {order.status !== 'Accepted' && (
//         <div className="print-button-container" style={{ display: 'flex', justifyContent: 'flex-start' }}>
//           <button className="manage-button" onClick={handleCancelClick} style={{ background: 'red' }}>
//             Cancel Order
//           </button>
//         </div>
//       )}
//     </div>
//   );
// };

// export default OrderDetailsView;

// import React, { useState } from 'react';
// import { URL } from '../../../config';
// import { Modal, Button } from 'react-bootstrap';
// import './userprofile.css';

// const OrderDetailsView = ({ order, onCancel }) => {
//   const [showCancelConfirm, setShowCancelConfirm] = useState(false);

//   if (!order) {
//     return <p>No order details available.</p>;
//   }

//   // Function to update the order status to "Cancelled"
//   const cancelOrder = async () => {
//     try {
//       // Determine the appropriate endpoint based on order type.
//       let endpoint = "";
//       if (order.bed !== undefined) {
//         // Homeclean order
//         endpoint = `${URL}/homeclean/${order.Id}`;
//       } else if (order.Fan_in_un !== undefined) {
//         // Electrician order
//         endpoint = `${URL}/electrician/${order.Id}`;
//       } else {
//         // Assume Plumber order
//         endpoint = `${URL}/plumber/${order.Id}`;
//       }

//       // Make a PATCH request to update the status to "Cancelled"
//       const response = await fetch(endpoint, {
//         method: 'PATCH',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ status: "Cancelled" })
//       });

//       if (response.ok) {
//         // alert("Order has been cancelled.");
//         setShowCancelConfirm(false);
//         onCancel();
//       } else {
//         const text = await response.text();
//         let errorData;
//         try {
//           errorData = text ? JSON.parse(text) : { message: text };
//         } catch (e) {
//           errorData = { message: text };
//         }
//         console.error("Failed to cancel order:", errorData);
//         alert("Failed to cancel order.");
//       }
//     } catch (err) {
//       console.error("Error cancelling order:", err);
//       alert("Error cancelling order.");
//     }
//   };

//   // Handler when the Cancel Order button is clicked: show the confirmation modal.
//   const handleCancelClick = () => {
//     setShowCancelConfirm(true);
//   };

//   // Handler for the "No" button in the confirm modal.
//   const handleCancelNo = () => {
//     setShowCancelConfirm(false);
//   };

//   return (
//     <div className="order-details-view">
//       <h4>HelpNao - Order Details</h4>
//       <hr />
//       <div className="invoice-header">
//         <div className="invoice-left">
//           <p>
//             <strong>Placed Order Date:</strong> {new Date(order.created_at).toLocaleDateString()}
//           </p>
//           <p>
//             <strong>Service Delivered Date:</strong> {order.date ? new Date(order.date).toLocaleDateString() : 'TBD'}
//           </p>
//         </div>
//         <div className="invoice-right">
//           <p>
//             <strong>Invoice Order#:</strong> {order.Id}
//           </p>
//         </div>
//       </div>

//       <div className="invoice-card">
//         <div className="invoice-info">
//           <div className="invoice-left">
//             <p>
//               <strong>User Name:</strong> {order.User ? `${order.User.FirstName} ${order.User.LastName}` : 'Unknown'}
//             </p>
//             <p>
//               <strong>Mobile:</strong> {order.User ? `0${order.User.mobile}` : 'Unknown'}
//             </p>
//             <p>
//               <strong>City:</strong> {order.usercity || order.City}
//             </p>
//             <p>
//               <strong>Address:</strong> {order.useraddress || order.Address}
//             </p>
//           </div>
//           <div className="invoice-right">
//             {order.status === 'Accepted' ? (
//               <>
//                 <p>
//                   <strong>Name:</strong> {order.Servitor ? `${order.Servitor.FirstName} ${order.Servitor.LastName}` : 'N/A'}
//                 </p>
//                 <p>
//                   <strong>Mobile:</strong> {order.Servitor ? order.Servitor.mobile : 'N/A'}
//                 </p>
//                 <p>
//                   <strong>Email:</strong> {order.Servitor ? order.Servitor.email : 'N/A'}
//                 </p>
//                 <p>
//                   <strong>Address:</strong> {order.Servitor ? order.Servitor.Address : 'N/A'}
//                 </p>
//                 <p>
//                   <strong>City:</strong> {order.Servitor ? order.Servitor.city : 'N/A'}
//                 </p>
//                 <p>
//                   <strong>NID:</strong> {order.Servitor ? order.Servitor.NID : 'N/A'}
//                 </p>
//               </>
//             ) : (
//               <p style={{ fontStyle: 'italic', color: '#888' }}>
//                 Servitor has not accepted the order yet.
//               </p>
//             )}
//           </div>
//         </div>
//       </div>

//       <div className="invoice-details">
//         <table>
//           <thead>
//             <tr>
//               <th>Service</th>
//               <th>Details</th>
//               <th>Amount</th>
//             </tr>
//           </thead>
//           <tbody>
//             <tr>
//               <td>{order.Service ? order.Service.services_name : 'Unknown'}</td>
//               <td>
//                 {order.bed !== undefined ? (
//                   <>
//                     <div>
//                       Bedroom: {order.bed}, Bathroom: {order.bath}, Drawing-Dinning: {order.dra_din}
//                     </div>
//                     <div>
//                       Kitchen: {order.kitchen}, Cloths: {order.cloth}, Dishes: {order.dish}
//                     </div>
//                   </>
//                 ) : order.Fan_in_un !== undefined ? (
//                   <>
//                     <div>
//                       Fan Install: {order.Fan_in_un}, Light Install: {order.Light_in_un}, Fan Repair: {order.Fan_repair}, Light Repair: {order.Light_repair}
//                     </div>
//                     <div>
//                       Switch Repair: {order.Switch_repair}, MCB Service: {order.MCB_service}, MDB Service: {order.MDB_service}
//                     </div>
//                   </>
//                 ) : (
//                   <>
//                     <div>
//                       Toilet Install: {order.Toilet_in}, Faucet Install: {order.Faucet_in}, Sink Install: {order.Sink_in}, Dishwasher Install: {order.Dishwasher_in}
//                     </div>
//                     <div>
//                       Leak Repair: {order.Leak_repair}, Faucet Repair: {order.Faucet_repair}, Toilet Repair: {order.Toilet_repair}, Shower Repair: {order.Shower_repair}
//                     </div>
//                     <div>Drain Cleaning: {order.Drain_cleaning}</div>
//                   </>
//                 )}
//               </td>
//               <td>{order.price} tk</td>
//             </tr>
//           </tbody>
//         </table>
//       </div>

//       {/* If order is not accepted, show Cancel button */}
//       {order.status !== 'Accepted' && (
//         <div className="print-button-container" style={{ display: 'flex', justifyContent: 'flex-start' }}>
//           <button className="manage-button" onClick={handleCancelClick} style={{ background: 'red' }}>
//             Cancel Order
//           </button>
//         </div>
//       )}

//       {/* Confirmation Modal for Cancellation */}
//       <Modal show={showCancelConfirm} onHide={handleCancelNo} centered>
//         <Modal.Header closeButton>
//           <Modal.Title>Confirm Cancellation</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <p>Are you sure you want to cancel this order?</p>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={handleCancelNo}>
//             No
//           </Button>
//           <Button variant="danger" onClick={cancelOrder}>
//             Yes, Cancel Order
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </div>
//   );
// };

// export default OrderDetailsView;

// import React, { useState } from 'react';
// import { URL } from '../../../config';
// import { Modal, Button, Form } from 'react-bootstrap';
// import './userprofile.css';

// const OrderDetailsView = ({ order, onCancel }) => {
//   // State to control each modal's visibility.
//   const [showCancelConfirm, setShowCancelConfirm] = useState(false);
//   const [showCancelFeedback, setShowCancelFeedback] = useState(false);
//   const [showCancelSuccess, setShowCancelSuccess] = useState(false);
//   const [cancellationReason, setCancellationReason] = useState("");
//   const [showServitorModal, setShowServitorModal] = useState(false);

//   if (!order) {
//     return <p>No order details available.</p>;
//   }

//   // Function to perform the cancellation API call with reason.
//   const performCancelOrder = async (reason) => {
//     try {
//       let endpoint = "";
//       if (order.bed !== undefined) {
//         // Homeclean order
//         endpoint = `${URL}/homeclean/${order.Id}`;
//       } else if (order.Fan_in_un !== undefined) {
//         // Electrician order
//         endpoint = `${URL}/electrician/${order.Id}`;
//       } else {
//         // Assume Plumber order
//         endpoint = `${URL}/plumber/${order.Id}`;
//       }

//       // Build payload with cancellation feedback.
//       const payload = {
//         status: "Cancelled",
//         cancellation_feedback: reason
//       };

//       const response = await fetch(endpoint, {
//         method: 'PATCH',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(payload)
//       });

//       if (response.ok) {
//         return true;
//       } else {
//         const text = await response.text();
//         let errorData;
//         try {
//           errorData = text ? JSON.parse(text) : { message: text };
//         } catch (e) {
//           errorData = { message: text };
//         }
//         console.error("Failed to cancel order:", errorData);
//         alert("Failed to cancel order.");
//         return false;
//       }
//     } catch (err) {
//       console.error("Error cancelling order:", err);
//       alert("Error cancelling order.");
//       return false;
//     }
//   };

//   // When the user clicks "Cancel Order"
//   const handleCancelClick = () => {
//     setShowCancelConfirm(true);
//   };

//   // In the confirmation modal, if the user clicks "No"
//   const handleCancelNo = () => {
//     setShowCancelConfirm(false);
//   };

//   // In the confirmation modal, if the user clicks "Yes, Cancel Order"
//   // Hide confirmation modal and show the feedback modal.
//   const handleCancelConfirmYes = () => {
//     setShowCancelConfirm(false);
//     setShowCancelFeedback(true);
//   };

//   // When the user submits the feedback modal
//   const handleFeedbackSubmit = async () => {
//     // Validate that a reason is selected.
//     if (!cancellationReason) {
//       alert("Please select a reason for cancellation.");
//       return;
//     }
//     const reason = cancellationReason;
//     // Proceed with cancellation API call.
//     const success = await performCancelOrder(reason);
//     if (success) {
//       setShowCancelFeedback(false);
//       setShowCancelSuccess(true);
//     }
//   };

//   // If the user cancels out of the feedback modal.
//   const handleFeedbackCancel = () => {
//     setShowCancelFeedback(false);
//   };

//   // After a successful cancellation, handle closing the success modal.
//   const handleSuccessOk = () => {
//     setShowCancelSuccess(false);
//     onCancel();
//   };

//    //Open Servitor Details Modal
//    const handleViewServitor = () => {
//     setShowServitorModal(true);
//   };

//   //Close Servitor Details Modal
//   const handleCloseServitorModal = () => {
//     setShowServitorModal(false);
//   };

//   return (
//     <div className="order-details-view">
//       <h4>HelpNao - Order Details</h4>
//       <hr />
//       <div className="invoice-header">
//         <div className="invoice-left">
//           <p>
//             <strong>Placed Order Date:</strong>{" "}
//             {new Date(order.created_at).toLocaleDateString()}
//           </p>
//           <p>
//             <strong>Service Delivered Date:</strong>{" "}
//             {order.date ? new Date(order.date).toLocaleDateString() : "TBD"}
//           </p>
//         </div>
//         <div className="invoice-right">
//           <p>
//             <strong>Invoice Order#:</strong> {order.Id}
//           </p>
//         </div>
//       </div>

//       <div className="invoice-card">
//         <div className="invoice-info">
//           <div className="invoice-left">
//           <h3 >User Details</h3>
//           <hr />
//             <p>
//               <strong>User Name:</strong>{" "}
//               {order.User
//                 ? `${order.User.FirstName} ${order.User.LastName}`
//                 : "Unknown"}
//             </p>
//             <p>
//               <strong>Mobile:</strong>{" "}
//               {order.User ? `0${order.User.mobile}` : "Unknown"}
//             </p>
//             <p>
//               <strong>City:</strong> {order.usercity || order.City}
//             </p>
//             <p>
//               <strong>Address:</strong> {order.useraddress || order.Address}
//             </p>
//           </div>
//           {/* <div className="invoice-right">
//             {order.status === "Accepted" ? (
//               <>
//                 <p>
//                   <strong>Name:</strong>{" "}
//                   {order.Servitor
//                     ? `${order.Servitor.FirstName} ${order.Servitor.LastName}`
//                     : "N/A"}
//                 </p>
//                 <p>
//                   <strong>Mobile:</strong>{" "}
//                   {order.Servitor ? `0${order.Servitor.mobile}` : "N/A"}
//                 </p>
//                 <p>
//                   <strong>Email:</strong>{" "}
//                   {order.Servitor ? order.Servitor.email : "N/A"}
//                 </p>
//                 <p>
//                   <strong>Address:</strong>{" "}
//                   {order.Servitor ? order.Servitor.Address : "N/A"}
//                 </p>
//                 <p>
//                   <strong>City:</strong>{" "}
//                   {order.Servitor ? order.Servitor.city : "N/A"}
//                 </p>
//                 <p>
//                   <strong>NID:</strong>{" "}
//                   {order.Servitor ? order.Servitor.NID : "N/A"}
//                 </p>

//                 {order.Servitor && (
//                   <Button
//                     variant="info"
//                     onClick={handleViewServitor}
//                     className="mt-2"
//                   >
//                     View Servitor Details
//                   </Button>
//                 )}
//               </>
//             ) : (
//               <p style={{ fontStyle: "italic", color: "#888" }}>
//                 Servitor has not accepted the order yet.
//               </p>
//             )}
//           </div> */}
//         </div>
//       </div>

//       <div className="invoice-card">
//         <div className="invoice-info">
//           <div className="invoice-left">
//           {order.status === "Accepted" ? (
//               <>
//                 <p>
//                   <strong>Name:</strong>{" "}
//                   {order.Servitor
//                     ? `${order.Servitor.FirstName} ${order.Servitor.LastName}`
//                     : "N/A"}
//                 </p>
//                 <p>
//                   <strong>Mobile:</strong>{" "}
//                   {order.Servitor ? `0${order.Servitor.mobile}` : "N/A"}
//                 </p>
//                 <p>
//                   <strong>Email:</strong>{" "}
//                   {order.Servitor ? order.Servitor.email : "N/A"}
//                 </p>
//                 <p>
//                   <strong>Address:</strong>{" "}
//                   {order.Servitor ? order.Servitor.Address : "N/A"}
//                 </p>
//                 <p>
//                   <strong>City:</strong>{" "}
//                   {order.Servitor ? order.Servitor.city : "N/A"}
//                 </p>
//                 <p>
//                   <strong>NID:</strong>{" "}
//                   {order.Servitor ? order.Servitor.NID : "N/A"}
//                 </p>

//                 {order.Servitor && (
//                   <Button
//                     variant="info"
//                     onClick={handleViewServitor}
//                     className="mt-2"
//                   >
//                     View Servitor Details
//                   </Button>
//                 )}
//               </>
//             ) : (
//               <p style={{ fontStyle: "italic", color: "#888" }}>
//                 Servitor has not accepted the order yet.
//               </p>
//             )}

//           </div>
//           <div className="invoice-right">
//             {order.status === "Accepted" ? (
//               <>
//                 <img
//                 src={
//                   order.Servitor.image
//                     ? `${URL}/uploads/${order.Servitor.image}`
//                     : "placeholder.jpg"
//                 }
//                 alt="Servitor"
//                 className="img-fluid rounded-circle mb-3"
//                 style={{
//                   width: "350px",
//                   height: "350px",
//                   objectFit: "cover",
//                   margin: "0 auto",
//                 }}
//               />
//               </>
//             ) : (
//               <p style={{ fontStyle: "italic", color: "#888" }}>

//               </p>
//             )}
//           </div>
//         </div>
//       </div>

//       <div className="invoice-details">
//         <table>
//           <thead>
//             <tr>
//               <th>Service</th>
//               <th>Details</th>
//               <th>Amount</th>
//             </tr>
//           </thead>
//           <tbody>
//             <tr>
//               <td>{order.Service ? order.Service.services_name : "Unknown"}</td>
//               <td>
//                 {order.bed !== undefined ? (
//                   <>
//                     <div>
//                       Bedroom: {order.bed}, Bathroom: {order.bath},
//                       Drawing-Dinning: {order.dra_din}
//                     </div>
//                     <div>
//                       Kitchen: {order.kitchen}, Cloths: {order.cloth}, Dishes:{" "}
//                       {order.dish}
//                     </div>
//                   </>
//                 ) : order.Fan_in_un !== undefined ? (
//                   <>
//                     <div>
//                       Fan Install: {order.Fan_in_un}, Light Install:{" "}
//                       {order.Light_in_un}, Fan Repair: {order.Fan_repair}, Light
//                       Repair: {order.Light_repair}
//                     </div>
//                     <div>
//                       Switch Repair: {order.Switch_repair}, MCB Service:{" "}
//                       {order.MCB_service}, MDB Service: {order.MDB_service}
//                     </div>
//                   </>
//                 ) : (
//                   <>
//                     <div>
//                       Toilet Install: {order.Toilet_in}, Faucet Install:{" "}
//                       {order.Faucet_in}, Sink Install: {order.Sink_in},
//                       Dishwasher Install: {order.Dishwasher_in}
//                     </div>
//                     <div>
//                       Leak Repair: {order.Leak_repair}, Faucet Repair:{" "}
//                       {order.Faucet_repair}, Toilet Repair:{" "}
//                       {order.Toilet_repair}, Shower Repair:{" "}
//                       {order.Shower_repair}
//                     </div>
//                     <div>Drain Cleaning: {order.Drain_cleaning}</div>
//                   </>
//                 )}
//               </td>
//               <td>{order.price} tk</td>
//             </tr>
//           </tbody>
//         </table>
//       </div>

//       {/* Show Cancel button only if the order is not accepted */}
//       {order.status !== "Accepted" && (
//         <div
//           className="print-button-container"
//           style={{ display: "flex", justifyContent: "flex-start" }}
//         >
//           <button
//             className="manage-button"
//             onClick={handleCancelClick}
//             style={{ background: "red" }}
//           >
//             Cancel Order
//           </button>
//         </div>
//       )}

//       {/* Cancel Confirmation Modal */}
//       <Modal show={showCancelConfirm} onHide={handleCancelNo} centered>
//         <Modal.Header closeButton>
//           <Modal.Title>Confirm Cancellation</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <p>Are you sure you want to cancel this order?</p>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={handleCancelNo}>
//             No
//           </Button>
//           <Button variant="danger" onClick={handleCancelConfirmYes}>
//             Yes, Cancel Order
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Cancellation Feedback Modal */}
//       <Modal show={showCancelFeedback} onHide={handleFeedbackCancel} centered>
//         <Modal.Header closeButton>
//           <Modal.Title>Cancellation Feedback</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <p>Please let us know why you are canceling your order:</p>
//           <Form>
//             <Form.Check
//               type="radio"
//               label="Service is taking too long"
//               name="cancellationReason"
//               value="Service is taking too long"
//               checked={cancellationReason === "Service is taking too long"}
//               onChange={(e) => setCancellationReason(e.target.value)}
//             />
//             <Form.Check
//               type="radio"
//               label="Found another provider"
//               name="cancellationReason"
//               value="Found another provider"
//               checked={cancellationReason === "Found another provider"}
//               onChange={(e) => setCancellationReason(e.target.value)}
//             />
//             <Form.Check
//               type="radio"
//               label="No longer need the service"
//               name="cancellationReason"
//               value="No longer need the service"
//               checked={cancellationReason === "No longer need the service"}
//               onChange={(e) => setCancellationReason(e.target.value)}
//             />
//             <Form.Check
//               type="radio"
//               label="Other"
//               name="cancellationReason"
//               value="Other"
//               checked={cancellationReason === "Other"}
//               onChange={(e) => setCancellationReason(e.target.value)}
//             />
//           </Form>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={handleFeedbackCancel}>
//             Cancel
//           </Button>
//           <Button variant="primary" onClick={handleFeedbackSubmit}>
//             Submit
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Cancellation Success Modal */}
//       <Modal show={showCancelSuccess} onHide={handleSuccessOk} centered>
//         <Modal.Header closeButton>
//           <Modal.Title>Order Cancelled</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <p>Your order has been cancelled successfully.</p>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="primary" onClick={handleSuccessOk}>
//             OK
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       <Modal
//         show={showServitorModal}
//         onHide={handleCloseServitorModal}
//         centered
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>Servitor Details</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           {order.Servitor ? (
//             <div className="servitor-details text-center">
//               <img
//                 src={
//                   order.Servitor.image
//                     ? `${URL}/uploads/${order.Servitor.image}`
//                     : "placeholder.jpg"
//                 }
//                 alt="Servitor"
//                 className="img-fluid rounded-circle mb-3"
//                 style={{
//                   width: "150px",
//                   height: "150px",
//                   objectFit: "cover",
//                   margin: "0 auto",
//                 }}
//               />
//               <p>
//                 <strong>Name:</strong> {order.Servitor.FirstName}{" "}
//                 {order.Servitor.LastName}
//               </p>
//               <p>
//                 <strong>Mobile:</strong>{" "}
//                 {order.Servitor.mobile ? `0${order.Servitor.mobile}` : "N/A"}
//               </p>
//               <p>
//                 <strong>Email:</strong> {order.Servitor.email}
//               </p>
//               <p>
//                 <strong>Address:</strong> {order.Servitor.Address}
//               </p>
//               <p>
//                 <strong>City:</strong> {order.Servitor.city}
//               </p>
//               <p>
//                 <strong>NID:</strong> {order.Servitor.NID}
//               </p>
//             </div>
//           ) : (
//             <p>Servitor details not available.</p>
//           )}
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={handleCloseServitorModal}>
//             Close
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </div>
//   );
// };

// export default OrderDetailsView;

// *********************
// Order Details View
// *********************

// import React, { useState } from "react";
// import { URL } from "../../../config";
// import { Modal, Button, Form } from "react-bootstrap";
// import "./userprofile.css";
// import TransactionModal from "./TransactionModal";

// const OrderDetailsView = ({ order,onBack, onCancel }) => {
//   const [showCancelConfirm, setShowCancelConfirm] = useState(false);
//   const [showCancelFeedback, setShowCancelFeedback] = useState(false);
//   const [showCancelSuccess, setShowCancelSuccess] = useState(false);
//   const [cancellationReason, setCancellationReason] = useState("");
//   const [showTransactionModal, setShowTransactionModal] = useState(false);

//   if (!order) {
//     return <p>No order details available.</p>;
//   }

//   // Function to perform the cancellation
//   // const performCancelOrder = async (reason) => {
//   //   try {
//   //     let endpoint = "";
//   //     // if (order.bed !== undefined) {
//   //     //   endpoint = `${URL}/homeclean/${order.Id}`;
//   //     // } else if (order.Fan_in_un !== undefined) {
//   //     //   endpoint = `${URL}/electrician/${order.Id}`;
//   //     // } else {
//   //     //   endpoint = `${URL}/plumber/${order.Id}`;
//   //     // }

//   //     if (order.service_name === "Home Cleaning") {
//   //       endpoint = `${URL}/homeclean/${order.Id}`;
//   //     } else if (order.service_name === "Electrician") {
//   //       endpoint = `${URL}/electrician/${order.Id}`;
//   //     } else if (order.service_name === "Plumber") {
//   //       endpoint = `${URL}/plumber/${order.Id}`;
//   //     } else {
//   //       console.error("Unknown service type:", order.service_name);
//   //       alert("Unable to determine service type for cancellation.");
//   //       return false;
//   //     }

//   //     const payload = {
//   //       status: "Cancelled",
//   //       cancellation_feedback: reason,
//   //     };

//   //     const response = await fetch(endpoint, {
//   //       method: "PATCH",
//   //       headers: { "Content-Type": "application/json" },
//   //       body: JSON.stringify(payload),
//   //     });

//   //     if (response.ok) {
//   //       return true;
//   //     } else {
//   //       const text = await response.text();
//   //       let errorData;
//   //       try {
//   //         errorData = text ? JSON.parse(text) : { message: text };
//   //       } catch (e) {
//   //         errorData = { message: text };
//   //       }
//   //       console.error("Failed to cancel order:", errorData);
//   //       alert("Failed to cancel order.");
//   //       return false;
//   //     }
//   //   } catch (err) {
//   //     console.error("Error cancelling order:", err);
//   //     alert("Error cancelling order.");
//   //     return false;
//   //   }
//   // };

//   const performCancelOrder = async (reason) => {
//     try {
//       // Use the new unified cancellation endpoint
//       const endpoint = `${URL}/cancelOrder/${order.Id}`;

//       const payload = {
//         serviceType: order.service_name, // e.g., "Home Cleaning", "Electrician", "Plumber"
//         cancellation_feedback: reason,
//       };

//       const response = await fetch(endpoint, {
//         method: "PATCH",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(payload),
//       });

//       if (response.ok) {
//         return true;
//       } else {
//         const text = await response.text();
//         let errorData;
//         try {
//           errorData = text ? JSON.parse(text) : { message: text };
//         } catch (e) {
//           errorData = { message: text };
//         }
//         console.error("Failed to cancel order:", errorData);
//         alert("Failed to cancel order.");
//         return false;
//       }
//     } catch (err) {
//       console.error("Error cancelling order:", err);
//       alert("Error cancelling order.");
//       return false;
//     }
//   };

//   const handleCancelClick = () => setShowCancelConfirm(true);
//   const handleCancelNo = () => setShowCancelConfirm(false);
//   const handleCancelConfirmYes = () => {
//     setShowCancelConfirm(false);
//     setShowCancelFeedback(true);
//   };
//   const handleFeedbackSubmit = async () => {
//     if (!cancellationReason) {
//       alert("Please select a reason for cancellation.");
//       return;
//     }
//     const success = await performCancelOrder(cancellationReason);
//     if (success) {
//       setShowCancelFeedback(false);
//       setShowCancelSuccess(true);
//     }
//   };
//   const handleFeedbackCancel = () => setShowCancelFeedback(false);
//   const handleSuccessOk = () => {
//     setShowCancelSuccess(false);
//     onCancel();
//   };

//   // When "Task Complete" is clicked, open the TransactionModal
//   const handleTaskComplete = () => {
//     setShowTransactionModal(true);
//   };

//   const handleTransactionModalClose = () => {
//     setShowTransactionModal(false);
//   };

//   const handleTransactionSuccess = () => {
//     // alert("Transaction completed successfully. Thank you for your feedback!");
//     setShowTransactionModal(false);
//     onCancel();
//   };

//   const cardStyle = {
//     // width: "48%", //if we use it the card of user and servitor will show side by side
//     width: "100%",
//     backgroundColor: "#f8f8f8",
//     padding: "20px",
//     borderRadius: "8px",
//     boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
//     marginBottom: "20px",
//     textAlign: 'left'
//   };

//   const cardHeaderStyle = {
//     borderBottom: "1px solid #ddd",
//     paddingBottom: "10px",
//     marginBottom: "20px",
//     textAlign: "center",
//     fontWeight: "600",
//     fontSize: "1.2rem",
//   };

//   const userDetailsCard = (
//     <div style={cardStyle}>
//       <div style={cardHeaderStyle}>User Details</div>
//       <p>
//         <strong>Name:</strong>{" "}
//         {order.User
//           ? `${order.User.FirstName} ${order.User.LastName}`
//           : "Unknown"}
//       </p>
//       <p>
//         <strong>Mobile:</strong>{" "}
//         {order.User ? `0${order.User.mobile}` : "Unknown"}
//       </p>
//       <p>
//         <strong>City:</strong> {order.usercity || order.City}
//       </p>
//       <p>
//         <strong>Address:</strong> {order.useraddress || order.Address}
//       </p>
//     </div>
//   );

//   // const servitorDetailsCard =
//   //  (order.status === "Accepted" || order.status === "In-Progress" || order.status === "Completed") && order.Servitor ? (
//   //     <div style={cardStyle}>
//   //       <div style={cardHeaderStyle}>Servitor Details</div>
//   //       <div style={{ textAlign: "left" }}>
//   //         <img
//   //           src={
//   //             order.Servitor.image
//   //               ? `${URL}/uploads/${order.Servitor.image}`
//   //               : "https://via.placeholder.com/150"
//   //           }
//   //           alt="Servitor"
//   //           style={{
//   //             width: "200px",
//   //             height: "200px",
//   //             objectFit: "cover",
//   //             borderRadius: "50%",
//   //             display: "block",
//   //             margin: "0 auto 20px auto",
//   //           }}
//   //         />
//   //         <p>
//   //           <strong>Name:</strong> {order.Servitor.FirstName}{" "}
//   //           {order.Servitor.LastName}
//   //         </p>
//   //         <p>
//   //           <strong>Mobile:</strong>{" "}
//   //           {order.Servitor.mobile ? `0${order.Servitor.mobile}` : "N/A"}
//   //         </p>
//   //         <p>
//   //           <strong>Email:</strong> {order.Servitor.email}
//   //         </p>
//   //         <p>
//   //           <strong>Address:</strong> {order.Servitor.Address}
//   //         </p>
//   //         <p>
//   //           <strong>City:</strong> {order.Servitor.city}
//   //         </p>
//   //         <p>
//   //           <strong>NID:</strong> {order.Servitor.NID}
//   //         </p>

//   //         <p>
//   //           <strong>Experience:</strong> {order.Servitor.experience} years
//   //         </p>

//   //         <p>
//   //           <strong>Service:</strong> {order.Servitor.service}
//   //         </p>
//   //       </div>
//   //     </div>
//   //   ) : (
//   //     <div style={cardStyle}>
//   //       <div style={cardHeaderStyle}>Servitor Details</div>
//   //       <p style={{ fontStyle: "italic", color: "#888" }}>
//   //         Servitor has not accepted the order yet.
//   //       </p>
//   //     </div>
//   //   );
//   const servitorDetailsCard =
//   (order.status === "Accepted" ||
//     order.status === "In-Progress" ||
//     order.status === "Completed") &&
//   order.Servitor ? (
//     <div className="servitor-details-card">
//       {/* Title */}
//       <h2 className="servitor-header">Servitor Details</h2>
//       <hr />

//       <div className="servitor-top-row">
//         {/* LEFT HALF */}
//         <div className="servitor-left-half">
//           {/* Circular photo */}
//           <img
//             src={
//               order.Servitor.image
//                 ? `${URL}/uploads/${order.Servitor.image}`
//                 : "https://via.placeholder.com/150"
//             }
//             alt="Servitor"
//             className="servitor-photo"
//           />

//           {/* Name & Rating */}
//           <div className="servitor-info-block">
//             <h4 className="servitor-name">
//               {order.Servitor.FirstName} {order.Servitor.LastName}
//             </h4>
//             <div className="servitor-rating">
//               <i className="fas fa-star star-filled"></i>
//               <span className="rating-score">{order.Servitor.rating || 0}</span>
//               <span className="rating-count">({order.Servitor.orders_completed || 0} Orders completed)</span>
//             </div>
//           </div>
//         </div>
//         {/* RIGHT HALF */}
//         <div className="servitor-right-half">
//           <div className="contact-line">
//             <i className="fas fa-phone-alt contact-icon"></i>
//             <span>{order.Servitor.mobile ? `0${order.Servitor.mobile}` : "N/A"}</span>
//           </div>
//           <div className="contact-line">
//             <i className="fas fa-envelope contact-icon"></i>
//             <span>{order.Servitor.email || "No email"}</span>
//           </div>
//           <div className="contact-line">
//             <i className="fas fa-map-marker-alt contact-icon"></i>
//             <span>{order.Servitor.city || "No city"}</span>
//           </div>
//         </div>
//       </div>

//       {/* Bottom row: NID, Experience, Service */}
//       <div className="servitor-bottom-row">
//         <div className="servitor-info-box">
//           <div className="info-label">NID</div>
//           <div className="info-value">{order.Servitor.NID || "N/A"}</div>
//         </div>

//         <div className="servitor-info-box">
//           <div className="info-label">Experience</div>
//           <div className="info-value">
//             {order.Servitor.experience} years
//           </div>
//         </div>

//         <div className="servitor-info-box">
//           <div className="info-label">Service</div>
//           <div className="info-value">
//             {order.Servitor.service || "N/A"}
//           </div>
//         </div>
//       </div>
//     </div>
//   ) : (
//     <div className="servitor-details-card">
//       <h2 className="servitor-header">Servitor Details</h2>
//       <p style={{ fontStyle: "italic", color: "#888" }}>
//         Servitor has not accepted the order yet.
//       </p>
//     </div>
//   );

//   return (
//     <div className="order-details-view" style={{ padding: "20px" }}>
//       <h4 style={{ textAlign: "center", marginBottom: "20px" }}>
//         HelpNao - Order Details
//       </h4>
//       <hr />
//       <div
//         className="invoice-header"
//         style={{
//           display: "flex",
//           justifyContent: "space-between",
//           marginBottom: "20px",
//         }}
//       >
//         <div className="invoice-left">
//           <p>
//             <strong>Placed Order Date:</strong>{" "}
//             {new Date(order.created_at).toLocaleDateString()}
//           </p>
//           <p>
//             <strong>Service Delivered Date:</strong>{" "}
//             {order.date ? new Date(order.date).toLocaleDateString() : "TBD"}
//           </p>
//           <p>
//             <strong>Service Delivered Time:</strong> {order.time}
//           </p>

//           <p>
//             <strong>Order Status:</strong> {order.status}
//           </p>
//         </div>
//         <div className="invoice-right">
//           <p>
//             {/* <strong>Invoice Order#:</strong> {order.Id} */}
//             <strong>Invoice Order#:</strong> {order.order_number}
//           </p>
//         </div>
//       </div>
//       {order.status === "Completed" && (
//         <div
//           style={{
//             marginBottom: "20px",
//             textAlign: "center",
//             padding: "20px",
//             backgroundColor: "#e6ffed",
//             borderRadius: "8px",
//             border: "1px solid #10b981",
//           }}
//         >
//           <h3 style={{ margin: 0, color: "#10b981" }}>
//             This order is successfully completed.
//           </h3>
//           <p
//             style={{ margin: "10px 0 0", fontWeight: "600", color: "#2c3e50" }}
//           >
//             Stay with HelpNao
//           </p>
//         </div>
//       )}

//       <div
//         style={{
//           display: "flex",
//           justifyContent: "space-between",
//           flexWrap: "wrap",
//           gap: "20px",
//         }}
//       >
//         {servitorDetailsCard}
//         {userDetailsCard}
//       </div>

//       <div className="invoice-details" style={{ marginTop: "20px" }}>
//         <table style={{ width: "100%", borderCollapse: "collapse" }}>
//           <thead>
//             <tr>
//               <th style={{ border: "1px solid #ddd", padding: "8px" }}>
//                 Service
//               </th>
//               <th style={{ border: "1px solid #ddd", padding: "8px" }}>
//                 Details
//               </th>
//               <th style={{ border: "1px solid #ddd", padding: "8px" }}>
//                 Amount
//               </th>
//             </tr>
//           </thead>
//           {/* <tbody>
//             <tr>
//               <td style={{ border: "1px solid #ddd", padding: "8px" }}>
//                 {order.Service ? order.Service.services_name : "Unknown"}
//               </td>
//               <td style={{ border: "1px solid #ddd", padding: "8px" }}>
//                 {order.bed !== undefined ? (
//                   <>
//                     <div>
//                       Bedroom: {order.bed}, Bathroom: {order.bath},
//                       Drawing-Dinning: {order.dra_din}
//                     </div>
//                     <div>
//                       Kitchen: {order.kitchen}, Cloths: {order.cloth}, Dishes:{" "}
//                       {order.dish}
//                     </div>
//                   </>
//                 ) : order.Fan_in_un !== undefined ? (
//                   <>
//                     <div>
//                       Fan Install: {order.Fan_in_un}, Light Install:{" "}
//                       {order.Light_in_un}, Fan Repair: {order.Fan_repair}, Light
//                       Repair: {order.Light_repair}
//                     </div>
//                     <div>
//                       Switch Repair: {order.Switch_repair}, MCB Service:{" "}
//                       {order.MCB_service}, MDB Service: {order.MDB_service}
//                     </div>
//                   </>
//                 ) : (
//                   <>
//                     <div>
//                       Toilet Install: {order.Toilet_in}, Faucet Install:{" "}
//                       {order.Faucet_in}, Sink Install: {order.Sink_in},
//                       Dishwasher Install: {order.Dishwasher_in}
//                     </div>
//                     <div>
//                       Leak Repair: {order.Leak_repair}, Faucet Repair:{" "}
//                       {order.Faucet_repair}, Toilet Repair:{" "}
//                       {order.Toilet_repair}, Shower Repair:{" "}
//                       {order.Shower_repair}
//                     </div>
//                     <div>Drain Cleaning: {order.Drain_cleaning}</div>
//                   </>
//                 )}
//               </td>
//               <td style={{ border: "1px solid #ddd", padding: "8px" }}>
//                 {order.price} tk
//               </td>
//             </tr>
//           </tbody> */}

//           <tbody>
//             <tr>
//               <td style={{ border: "1px solid #ddd", padding: "8px" }}>
//                 {order.Service
//                   ? order.Service.services_name
//                   : order.service_name || "Unknown"}
//               </td>
//               <td style={{ border: "1px solid #ddd", padding: "8px" }}>
//                 {order.service_name === "Home Cleaning" ? (
//                   <>
//                     <div>
//                       Bedroom: {order.bed}, Bathroom: {order.bath},
//                       Drawing-Dinning: {order.dra_din}
//                     </div>
//                     <div>
//                       Kitchen: {order.kitchen}, Cloths: {order.cloth}, Dishes:{" "}
//                       {order.dish}
//                     </div>
//                   </>
//                 ) : order.service_name === "Electrician" ? (
//                   <>
//                     <div>
//                       Fan Install: {order.Fan_in_un}, Light Install:{" "}
//                       {order.Light_in_un}, Fan Repair: {order.Fan_repair}, Light
//                       Repair: {order.Light_repair}
//                     </div>
//                     <div>
//                       Switch Repair: {order.Switch_repair}, MCB Service:{" "}
//                       {order.MCB_service}, MDB Service: {order.MDB_service}
//                     </div>
//                   </>
//                 ) : order.service_name === "Plumber" ? (
//                   <>
//                     <div>
//                       Toilet Install: {order.Toilet_in}, Faucet Install:{" "}
//                       {order.Faucet_in}, Sink Install: {order.Sink_in},
//                       Dishwasher Install: {order.Dishwasher_in}
//                     </div>
//                     <div>
//                       Leak Repair: {order.Leak_repair}, Faucet Repair:{" "}
//                       {order.Faucet_repair}, Toilet Repair:{" "}
//                       {order.Toilet_repair}, Shower Repair:{" "}
//                       {order.Shower_repair}
//                     </div>
//                     <div>Drain Cleaning: {order.Drain_cleaning}</div>
//                   </>
//                 ) : (
//                   <div>Service details unavailable</div>
//                 )}
//               </td>
//               <td style={{ border: "1px solid #ddd", padding: "8px" }}>
//                 {order.price} tk
//               </td>
//             </tr>
//           </tbody>
//         </table>
//       </div>

//       {/* When order status is Accepted, display the verification PIN card */}
//       {order.status === "Accepted" && order.verification_pin && (
//         <div className="card verification-pin-card">
//           <h3>Verification PIN</h3>
//           <p>
//             This is the PIN provided when the servitor arrived for verification.
//             Please note it down for your records.
//           </p>
//           <div className="pin-display">{order.verification_pin}</div>
//         </div>
//       )}

//       {/* {order.status === "pending" && (
//         <div
//           style={{
//             display: "flex",
//             justifyContent: "flex-start",
//             marginTop: "20px",
//           }}
//         >
//           <button
//             className="manage-button"
//             onClick={handleCancelClick}
//             style={{ background: "red" }}
//           >
//             Cancel Order
//           </button>
//         </div>
//       )} */}

//       {/* {(order.status === "pending" || order.status === "Accepted" || order.status === "In-Progress") && (
//         <div
//           style={{
//             display: "flex",
//             justifyContent: "flex-start",
//             marginTop: "20px",
//           }}
//         >
//           <button
//             className="manage-button"
//             onClick={handleCancelClick}
//             style={{ background: "red" }}
//           >
//             Cancel Order
//           </button>
//         </div>
//       )}

//       {order.status === "Completed" && (
//         <div
//           style={{
//             display: "flex",
//             justifyContent: "flex-start",
//             marginTop: "20px",
//           }}
//         >
//           <button
//             className="manage-button"
//             onClick={() => alert("Print functionality not implemented yet")}
//             style={{ background: "#007bff" }}
//           >
//             Print
//           </button>
//         </div>
//       )} */}

//       {/* Bottom Button Bar */}
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           marginTop: "20px",
//         }}
//       >
//         {/* Left: Back Button */}
//         <button
//           className="orderdetailsbtn back-btn"
//           onClick={onBack}
//           onMouseOver={(e) =>
//             (e.currentTarget.style.backgroundColor = "#6d716e")
//           }
//           onMouseOut={(e) =>
//             (e.currentTarget.style.backgroundColor = "#151515")
//           }
//           style={{
//             backgroundColor: "#151515",
//             color: "#fff",
//             border: "none",
//             borderRadius: "4px",
//             padding: "10px 20px",
//             cursor: "pointer",
//             fontSize: "1rem",
//             transition: "background-color 0.3s ease",
//           }}
//         >
//           ← Back
//         </button>

//         {/* Right: Cancel / Print / Task Complete Buttons */}
//         <div>
//           {/* Cancel Button: shown if status is pending, Accepted, or In-Progress */}
//           {(order.status === "pending" ||
//             order.status === "Accepted" ||
//             order.status === "In-Progress") && (
//             <button
//               className="manage-button"
//               onClick={handleCancelClick}
//               style={{
//                 background: "red",
//                 color: "#fff",
//                 padding: "10px 20px",
//                 border: "none",
//                 borderRadius: "4px",
//                 marginRight: "10px",
//                 cursor: "pointer",
//               }}
//             >
//               Cancel Order
//             </button>
//           )}

//           {/* Print Button: shown if status is Completed */}
//           {order.status === "Completed" && (
//             <button
//               className="manage-button"
//               onClick={() => alert("Print functionality not implemented yet")}
//               style={{
//                 background: "#007bff",
//                 color: "#fff",
//                 padding: "10px 20px",
//                 border: "none",
//                 borderRadius: "4px",
//                 marginRight: "10px",
//                 cursor: "pointer",
//               }}
//             >
//               Print
//             </button>
//           )}

//           {/* Task Complete Button: shown if status is In-Progress */}
//           {order.status === "In-Progress" && (
//             <button
//               className="manage-button"
//               onClick={handleTaskComplete}
//               style={{
//                 background: "green",
//                 color: "#fff",
//                 padding: "10px 20px",
//                 border: "none",
//                 borderRadius: "4px",
//                 cursor: "pointer",
//               }}
//             >
//               Task Complete
//             </button>
//           )}
//         </div>
//       </div>

//       {/* Cancel Confirmation Modal */}
//       <Modal show={showCancelConfirm} onHide={handleCancelNo} centered>
//         <Modal.Header closeButton>
//           <Modal.Title>Confirm Cancellation</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <p>Are you sure you want to cancel this order?</p>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={handleCancelNo}>
//             No
//           </Button>
//           <Button variant="danger" onClick={handleCancelConfirmYes}>
//             Yes, Cancel Order
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Cancellation Feedback Modal */}
//       <Modal show={showCancelFeedback} onHide={handleFeedbackCancel} centered>
//         <Modal.Header closeButton>
//           <Modal.Title>Cancellation Feedback</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <p>Please let us know why you are canceling your order:</p>
//           <Form>
//             <Form.Check
//               type="radio"
//               label="Service is taking too long"
//               name="cancellationReason"
//               value="Service is taking too long"
//               checked={cancellationReason === "Service is taking too long"}
//               onChange={(e) => setCancellationReason(e.target.value)}
//             />
//             <Form.Check
//               type="radio"
//               label="Found another provider"
//               name="cancellationReason"
//               value="Found another provider"
//               checked={cancellationReason === "Found another provider"}
//               onChange={(e) => setCancellationReason(e.target.value)}
//             />
//             <Form.Check
//               type="radio"
//               label="No longer need the service"
//               name="cancellationReason"
//               value="No longer need the service"
//               checked={cancellationReason === "No longer need the service"}
//               onChange={(e) => setCancellationReason(e.target.value)}
//             />
//             <Form.Check
//               type="radio"
//               label="Other"
//               name="cancellationReason"
//               value="Other"
//               checked={cancellationReason === "Other"}
//               onChange={(e) => setCancellationReason(e.target.value)}
//             />
//           </Form>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={handleFeedbackCancel}>
//             Cancel
//           </Button>
//           <Button variant="primary" onClick={handleFeedbackSubmit}>
//             Submit
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Cancellation Success Modal */}
//       <Modal show={showCancelSuccess} onHide={handleSuccessOk} centered>
//         <Modal.Header closeButton>
//           <Modal.Title>Order Cancelled</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <p>Your order has been cancelled successfully.</p>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="primary" onClick={handleSuccessOk}>
//             OK
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* "Task Complete" button shown at bottom right when order status is "In-Progress" */}
//       {/* {order.status === "In-Progress" && (
//         <div style={{ display:'flex', bottom: "20px", justifyContent: "flex-end" }}>
//           <button
//             className="manage-button"
//             onClick={handleTaskComplete}
//             style={{ background: "green", color: "#fff", padding: "10px 20px", border: "none", borderRadius: "4px" }}
//           >
//             Task Complete
//           </button>
//         </div>
//       )} */}

//       {/* Transaction Modal */}
//       {showTransactionModal && (
//         <TransactionModal
//           order={order}
//           onClose={handleTransactionModalClose}
//           onSuccess={handleTransactionSuccess}
//         />
//       )}
//     </div>
//   );
// };

// export default OrderDetailsView;

// import React from 'react';
// import './userprofile.css';

// const OrderDetailsView = ({ order, onCancel }) => {
//   if (!order) {
//     return <p>No order details available.</p>;
//   }

//    // Function to update the order status to "Cancelled"
//    const handleCancelClick = async () => {
//     try {
//       // Determine the appropriate endpoint based on order type.
//       // Adjust the logic as needed to suit your order object.
//       let endpoint = "";
//       if (order.bed !== undefined) {
//         // Homeclean order
//         endpoint = `${URL}/homeclean/${order.Id}`;
//       } else if (order.Fan_in_un !== undefined) {
//         // Electrician order
//         endpoint = `${URL}/electrician/${order.Id}`;
//       } else {
//         // Assume Plumber order
//         endpoint = `${URL}/plumber/${order.Id}`;
//       }

//       // Make a PATCH request to update the status to "Cancelled"
//       const response = await fetch(endpoint, {
//         method: 'PATCH',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ status: "Cancelled" })
//       });

//       if (response.ok) {
//         alert("Order has been cancelled.");
//         onCancel(); // Return to order history or refresh as needed
//       } else {
//         const errorData = await response.json();
//         console.error("Failed to cancel order:", errorData);
//         alert("Failed to cancel order.");
//       }
//     } catch (err) {
//       console.error("Error cancelling order:", err);
//       alert("Error cancelling order.");
//     }
//   };

//   return (
//     <div className="order-details-view">
//       <h4>HelpNao - Order Details</h4>
//       <hr />
//       <div className="invoice-header">
//         <div className="invoice-left">
//           <p>
//             <strong>Placed Order Date:</strong> {new Date(order.created_at).toLocaleDateString()}
//           </p>
//           <p>
//             <strong>Service Delivered Date:</strong> {order.date ? new Date(order.date).toLocaleDateString() : 'TBD'}
//           </p>
//         </div>
//         <div className="invoice-right">
//           <p>
//             <strong>Invoice Order#:</strong> {order.Id}
//           </p>
//         </div>
//       </div>

//       {/* Display order status */}
//       {/* <div className="order-status">
//         <p>
//           <strong>Status:</strong> {order.status ? order.status : 'Pending'}
//         </p>
//       </div> */}

//       <div className="invoice-card">
//         <div className="invoice-info">
//           <div className="invoice-left">
//             <p>
//               <strong>User Name:</strong> {order.User ? `${order.User.FirstName} ${order.User.LastName}` : 'Unknown'}
//             </p>
//             <p>
//               <strong>Mobile:</strong> {order.User ? `0${order.User.mobile}` : 'Unknown'}
//             </p>
//             <p>
//               <strong>City:</strong> {order.usercity || order.City}
//             </p>
//             <p>
//               <strong>Address:</strong> {order.useraddress || order.Address}
//             </p>
//           </div>
//           <div className="invoice-right">
//             {order.status === 'Accepted' ? (
//               <>
//                 <p>
//                   <strong>Name:</strong> {order.Servitor ? `${order.Servitor.FirstName} ${order.Servitor.LastName}` : 'N/A'}
//                 </p>
//                 <p>
//                   <strong>Mobile:</strong> {order.Servitor ? order.Servitor.mobile : 'N/A'}
//                 </p>
//                 <p>
//                   <strong>Email:</strong> {order.Servitor ? order.Servitor.email : 'N/A'}
//                 </p>
//                 <p>
//                   <strong>Address:</strong> {order.Servitor ? order.Servitor.Address : 'N/A'}
//                 </p>
//                 <p>
//                   <strong>City:</strong> {order.Servitor ? order.Servitor.city : 'N/A'}
//                 </p>
//                 <p>
//                   <strong>NID:</strong> {order.Servitor ? order.Servitor.NID : 'N/A'}
//                 </p>
//               </>
//             ) : (
//               <p style={{ fontStyle: 'italic', color: '#888' }}>
//                 Servitor has not accepted the order yet.
//               </p>
//             )}
//           </div>
//         </div>
//       </div>

//       <div className="invoice-details">
//         <table>
//           <thead>
//             <tr>
//               <th>Service</th>
//               <th>Details</th>
//               <th>Amount</th>
//             </tr>
//           </thead>
//           <tbody>
//             <tr>
//               <td>{order.Service ? order.Service.services_name : 'Unknown'}</td>
//               <td>
//                 {order.bed !== undefined ? (
//                   <>
//                     <div>
//                       Bedroom: {order.bed}, Bathroom: {order.bath}, Drawing-Dinning: {order.dra_din}
//                     </div>
//                     <div>
//                       Kitchen: {order.kitchen}, Cloths: {order.cloth}, Dishes: {order.dish}
//                     </div>
//                   </>
//                 ) : order.Fan_in_un !== undefined ? (
//                   <>
//                     <div>
//                       Fan Install: {order.Fan_in_un}, Light Install: {order.Light_in_un}, Fan Repair: {order.Fan_repair}, Light Repair: {order.Light_repair}
//                     </div>
//                     <div>
//                       Switch Repair: {order.Switch_repair}, MCB Service: {order.MCB_service}, MDB Service: {order.MDB_service}
//                     </div>
//                   </>
//                 ) : (
//                   <>
//                     <div>
//                       Toilet Install: {order.Toilet_in}, Faucet Install: {order.Faucet_in}, Sink Install: {order.Sink_in}, Dishwasher Install: {order.Dishwasher_in}
//                     </div>
//                     <div>
//                       Leak Repair: {order.Leak_repair}, Faucet Repair: {order.Faucet_repair}, Toilet Repair: {order.Toilet_repair}, Shower Repair: {order.Shower_repair}
//                     </div>
//                     <div>Drain Cleaning: {order.Drain_cleaning}</div>
//                   </>
//                 )}
//               </td>
//               <td>{order.price} tk</td>
//             </tr>
//           </tbody>
//         </table>
//       </div>

//       {/* If order is not accepted, show Cancel button */}
//       {order.status !== 'Accepted' && (
//         <div className="print-button-container" style={{ display: 'flex', justifyContent: 'flex-start' }}>
//           <button className="manage-button" onClick={handleCancelClick} style={{ background: 'red' }}>
//             Cancel Order
//           </button>
//         </div>
//       )}
//     </div>
//   );
// };

// export default OrderDetailsView;

// import React, { useState } from 'react';
// import { URL } from '../../../config';
// import { Modal, Button } from 'react-bootstrap';
// import './userprofile.css';

// const OrderDetailsView = ({ order, onCancel }) => {
//   const [showCancelConfirm, setShowCancelConfirm] = useState(false);

//   if (!order) {
//     return <p>No order details available.</p>;
//   }

//   // Function to update the order status to "Cancelled"
//   const cancelOrder = async () => {
//     try {
//       // Determine the appropriate endpoint based on order type.
//       let endpoint = "";
//       if (order.bed !== undefined) {
//         // Homeclean order
//         endpoint = `${URL}/homeclean/${order.Id}`;
//       } else if (order.Fan_in_un !== undefined) {
//         // Electrician order
//         endpoint = `${URL}/electrician/${order.Id}`;
//       } else {
//         // Assume Plumber order
//         endpoint = `${URL}/plumber/${order.Id}`;
//       }

//       // Make a PATCH request to update the status to "Cancelled"
//       const response = await fetch(endpoint, {
//         method: 'PATCH',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ status: "Cancelled" })
//       });

//       if (response.ok) {
//         // alert("Order has been cancelled.");
//         setShowCancelConfirm(false);
//         onCancel();
//       } else {
//         const text = await response.text();
//         let errorData;
//         try {
//           errorData = text ? JSON.parse(text) : { message: text };
//         } catch (e) {
//           errorData = { message: text };
//         }
//         console.error("Failed to cancel order:", errorData);
//         alert("Failed to cancel order.");
//       }
//     } catch (err) {
//       console.error("Error cancelling order:", err);
//       alert("Error cancelling order.");
//     }
//   };

//   // Handler when the Cancel Order button is clicked: show the confirmation modal.
//   const handleCancelClick = () => {
//     setShowCancelConfirm(true);
//   };

//   // Handler for the "No" button in the confirm modal.
//   const handleCancelNo = () => {
//     setShowCancelConfirm(false);
//   };

//   return (
//     <div className="order-details-view">
//       <h4>HelpNao - Order Details</h4>
//       <hr />
//       <div className="invoice-header">
//         <div className="invoice-left">
//           <p>
//             <strong>Placed Order Date:</strong> {new Date(order.created_at).toLocaleDateString()}
//           </p>
//           <p>
//             <strong>Service Delivered Date:</strong> {order.date ? new Date(order.date).toLocaleDateString() : 'TBD'}
//           </p>
//         </div>
//         <div className="invoice-right">
//           <p>
//             <strong>Invoice Order#:</strong> {order.Id}
//           </p>
//         </div>
//       </div>

//       <div className="invoice-card">
//         <div className="invoice-info">
//           <div className="invoice-left">
//             <p>
//               <strong>User Name:</strong> {order.User ? `${order.User.FirstName} ${order.User.LastName}` : 'Unknown'}
//             </p>
//             <p>
//               <strong>Mobile:</strong> {order.User ? `0${order.User.mobile}` : 'Unknown'}
//             </p>
//             <p>
//               <strong>City:</strong> {order.usercity || order.City}
//             </p>
//             <p>
//               <strong>Address:</strong> {order.useraddress || order.Address}
//             </p>
//           </div>
//           <div className="invoice-right">
//             {order.status === 'Accepted' ? (
//               <>
//                 <p>
//                   <strong>Name:</strong> {order.Servitor ? `${order.Servitor.FirstName} ${order.Servitor.LastName}` : 'N/A'}
//                 </p>
//                 <p>
//                   <strong>Mobile:</strong> {order.Servitor ? order.Servitor.mobile : 'N/A'}
//                 </p>
//                 <p>
//                   <strong>Email:</strong> {order.Servitor ? order.Servitor.email : 'N/A'}
//                 </p>
//                 <p>
//                   <strong>Address:</strong> {order.Servitor ? order.Servitor.Address : 'N/A'}
//                 </p>
//                 <p>
//                   <strong>City:</strong> {order.Servitor ? order.Servitor.city : 'N/A'}
//                 </p>
//                 <p>
//                   <strong>NID:</strong> {order.Servitor ? order.Servitor.NID : 'N/A'}
//                 </p>
//               </>
//             ) : (
//               <p style={{ fontStyle: 'italic', color: '#888' }}>
//                 Servitor has not accepted the order yet.
//               </p>
//             )}
//           </div>
//         </div>
//       </div>

//       <div className="invoice-details">
//         <table>
//           <thead>
//             <tr>
//               <th>Service</th>
//               <th>Details</th>
//               <th>Amount</th>
//             </tr>
//           </thead>
//           <tbody>
//             <tr>
//               <td>{order.Service ? order.Service.services_name : 'Unknown'}</td>
//               <td>
//                 {order.bed !== undefined ? (
//                   <>
//                     <div>
//                       Bedroom: {order.bed}, Bathroom: {order.bath}, Drawing-Dinning: {order.dra_din}
//                     </div>
//                     <div>
//                       Kitchen: {order.kitchen}, Cloths: {order.cloth}, Dishes: {order.dish}
//                     </div>
//                   </>
//                 ) : order.Fan_in_un !== undefined ? (
//                   <>
//                     <div>
//                       Fan Install: {order.Fan_in_un}, Light Install: {order.Light_in_un}, Fan Repair: {order.Fan_repair}, Light Repair: {order.Light_repair}
//                     </div>
//                     <div>
//                       Switch Repair: {order.Switch_repair}, MCB Service: {order.MCB_service}, MDB Service: {order.MDB_service}
//                     </div>
//                   </>
//                 ) : (
//                   <>
//                     <div>
//                       Toilet Install: {order.Toilet_in}, Faucet Install: {order.Faucet_in}, Sink Install: {order.Sink_in}, Dishwasher Install: {order.Dishwasher_in}
//                     </div>
//                     <div>
//                       Leak Repair: {order.Leak_repair}, Faucet Repair: {order.Faucet_repair}, Toilet Repair: {order.Toilet_repair}, Shower Repair: {order.Shower_repair}
//                     </div>
//                     <div>Drain Cleaning: {order.Drain_cleaning}</div>
//                   </>
//                 )}
//               </td>
//               <td>{order.price} tk</td>
//             </tr>
//           </tbody>
//         </table>
//       </div>

//       {/* If order is not accepted, show Cancel button */}
//       {order.status !== 'Accepted' && (
//         <div className="print-button-container" style={{ display: 'flex', justifyContent: 'flex-start' }}>
//           <button className="manage-button" onClick={handleCancelClick} style={{ background: 'red' }}>
//             Cancel Order
//           </button>
//         </div>
//       )}

//       {/* Confirmation Modal for Cancellation */}
//       <Modal show={showCancelConfirm} onHide={handleCancelNo} centered>
//         <Modal.Header closeButton>
//           <Modal.Title>Confirm Cancellation</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <p>Are you sure you want to cancel this order?</p>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={handleCancelNo}>
//             No
//           </Button>
//           <Button variant="danger" onClick={cancelOrder}>
//             Yes, Cancel Order
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </div>
//   );
// };

// export default OrderDetailsView;

// import React, { useState } from 'react';
// import { URL } from '../../../config';
// import { Modal, Button, Form } from 'react-bootstrap';
// import './userprofile.css';

// const OrderDetailsView = ({ order, onCancel }) => {
//   // State to control each modal's visibility.
//   const [showCancelConfirm, setShowCancelConfirm] = useState(false);
//   const [showCancelFeedback, setShowCancelFeedback] = useState(false);
//   const [showCancelSuccess, setShowCancelSuccess] = useState(false);
//   const [cancellationReason, setCancellationReason] = useState("");
//   const [showServitorModal, setShowServitorModal] = useState(false);

//   if (!order) {
//     return <p>No order details available.</p>;
//   }

//   // Function to perform the cancellation API call with reason.
//   const performCancelOrder = async (reason) => {
//     try {
//       let endpoint = "";
//       if (order.bed !== undefined) {
//         // Homeclean order
//         endpoint = `${URL}/homeclean/${order.Id}`;
//       } else if (order.Fan_in_un !== undefined) {
//         // Electrician order
//         endpoint = `${URL}/electrician/${order.Id}`;
//       } else {
//         // Assume Plumber order
//         endpoint = `${URL}/plumber/${order.Id}`;
//       }

//       // Build payload with cancellation feedback.
//       const payload = {
//         status: "Cancelled",
//         cancellation_feedback: reason
//       };

//       const response = await fetch(endpoint, {
//         method: 'PATCH',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(payload)
//       });

//       if (response.ok) {
//         return true;
//       } else {
//         const text = await response.text();
//         let errorData;
//         try {
//           errorData = text ? JSON.parse(text) : { message: text };
//         } catch (e) {
//           errorData = { message: text };
//         }
//         console.error("Failed to cancel order:", errorData);
//         alert("Failed to cancel order.");
//         return false;
//       }
//     } catch (err) {
//       console.error("Error cancelling order:", err);
//       alert("Error cancelling order.");
//       return false;
//     }
//   };

//   // When the user clicks "Cancel Order"
//   const handleCancelClick = () => {
//     setShowCancelConfirm(true);
//   };

//   // In the confirmation modal, if the user clicks "No"
//   const handleCancelNo = () => {
//     setShowCancelConfirm(false);
//   };

//   // In the confirmation modal, if the user clicks "Yes, Cancel Order"
//   // Hide confirmation modal and show the feedback modal.
//   const handleCancelConfirmYes = () => {
//     setShowCancelConfirm(false);
//     setShowCancelFeedback(true);
//   };

//   // When the user submits the feedback modal
//   const handleFeedbackSubmit = async () => {
//     // Validate that a reason is selected.
//     if (!cancellationReason) {
//       alert("Please select a reason for cancellation.");
//       return;
//     }
//     const reason = cancellationReason;
//     // Proceed with cancellation API call.
//     const success = await performCancelOrder(reason);
//     if (success) {
//       setShowCancelFeedback(false);
//       setShowCancelSuccess(true);
//     }
//   };

//   // If the user cancels out of the feedback modal.
//   const handleFeedbackCancel = () => {
//     setShowCancelFeedback(false);
//   };

//   // After a successful cancellation, handle closing the success modal.
//   const handleSuccessOk = () => {
//     setShowCancelSuccess(false);
//     onCancel();
//   };

//    //Open Servitor Details Modal
//    const handleViewServitor = () => {
//     setShowServitorModal(true);
//   };

//   //Close Servitor Details Modal
//   const handleCloseServitorModal = () => {
//     setShowServitorModal(false);
//   };

//   return (
//     <div className="order-details-view">
//       <h4>HelpNao - Order Details</h4>
//       <hr />
//       <div className="invoice-header">
//         <div className="invoice-left">
//           <p>
//             <strong>Placed Order Date:</strong>{" "}
//             {new Date(order.created_at).toLocaleDateString()}
//           </p>
//           <p>
//             <strong>Service Delivered Date:</strong>{" "}
//             {order.date ? new Date(order.date).toLocaleDateString() : "TBD"}
//           </p>
//         </div>
//         <div className="invoice-right">
//           <p>
//             <strong>Invoice Order#:</strong> {order.Id}
//           </p>
//         </div>
//       </div>

//       <div className="invoice-card">
//         <div className="invoice-info">
//           <div className="invoice-left">
//           <h3 >User Details</h3>
//           <hr />
//             <p>
//               <strong>User Name:</strong>{" "}
//               {order.User
//                 ? `${order.User.FirstName} ${order.User.LastName}`
//                 : "Unknown"}
//             </p>
//             <p>
//               <strong>Mobile:</strong>{" "}
//               {order.User ? `0${order.User.mobile}` : "Unknown"}
//             </p>
//             <p>
//               <strong>City:</strong> {order.usercity || order.City}
//             </p>
//             <p>
//               <strong>Address:</strong> {order.useraddress || order.Address}
//             </p>
//           </div>
//           {/* <div className="invoice-right">
//             {order.status === "Accepted" ? (
//               <>
//                 <p>
//                   <strong>Name:</strong>{" "}
//                   {order.Servitor
//                     ? `${order.Servitor.FirstName} ${order.Servitor.LastName}`
//                     : "N/A"}
//                 </p>
//                 <p>
//                   <strong>Mobile:</strong>{" "}
//                   {order.Servitor ? `0${order.Servitor.mobile}` : "N/A"}
//                 </p>
//                 <p>
//                   <strong>Email:</strong>{" "}
//                   {order.Servitor ? order.Servitor.email : "N/A"}
//                 </p>
//                 <p>
//                   <strong>Address:</strong>{" "}
//                   {order.Servitor ? order.Servitor.Address : "N/A"}
//                 </p>
//                 <p>
//                   <strong>City:</strong>{" "}
//                   {order.Servitor ? order.Servitor.city : "N/A"}
//                 </p>
//                 <p>
//                   <strong>NID:</strong>{" "}
//                   {order.Servitor ? order.Servitor.NID : "N/A"}
//                 </p>

//                 {order.Servitor && (
//                   <Button
//                     variant="info"
//                     onClick={handleViewServitor}
//                     className="mt-2"
//                   >
//                     View Servitor Details
//                   </Button>
//                 )}
//               </>
//             ) : (
//               <p style={{ fontStyle: "italic", color: "#888" }}>
//                 Servitor has not accepted the order yet.
//               </p>
//             )}
//           </div> */}
//         </div>
//       </div>

//       <div className="invoice-card">
//         <div className="invoice-info">
//           <div className="invoice-left">
//           {order.status === "Accepted" ? (
//               <>
//                 <p>
//                   <strong>Name:</strong>{" "}
//                   {order.Servitor
//                     ? `${order.Servitor.FirstName} ${order.Servitor.LastName}`
//                     : "N/A"}
//                 </p>
//                 <p>
//                   <strong>Mobile:</strong>{" "}
//                   {order.Servitor ? `0${order.Servitor.mobile}` : "N/A"}
//                 </p>
//                 <p>
//                   <strong>Email:</strong>{" "}
//                   {order.Servitor ? order.Servitor.email : "N/A"}
//                 </p>
//                 <p>
//                   <strong>Address:</strong>{" "}
//                   {order.Servitor ? order.Servitor.Address : "N/A"}
//                 </p>
//                 <p>
//                   <strong>City:</strong>{" "}
//                   {order.Servitor ? order.Servitor.city : "N/A"}
//                 </p>
//                 <p>
//                   <strong>NID:</strong>{" "}
//                   {order.Servitor ? order.Servitor.NID : "N/A"}
//                 </p>

//                 {order.Servitor && (
//                   <Button
//                     variant="info"
//                     onClick={handleViewServitor}
//                     className="mt-2"
//                   >
//                     View Servitor Details
//                   </Button>
//                 )}
//               </>
//             ) : (
//               <p style={{ fontStyle: "italic", color: "#888" }}>
//                 Servitor has not accepted the order yet.
//               </p>
//             )}

//           </div>
//           <div className="invoice-right">
//             {order.status === "Accepted" ? (
//               <>
//                 <img
//                 src={
//                   order.Servitor.image
//                     ? `${URL}/uploads/${order.Servitor.image}`
//                     : "placeholder.jpg"
//                 }
//                 alt="Servitor"
//                 className="img-fluid rounded-circle mb-3"
//                 style={{
//                   width: "350px",
//                   height: "350px",
//                   objectFit: "cover",
//                   margin: "0 auto",
//                 }}
//               />
//               </>
//             ) : (
//               <p style={{ fontStyle: "italic", color: "#888" }}>

//               </p>
//             )}
//           </div>
//         </div>
//       </div>

//       <div className="invoice-details">
//         <table>
//           <thead>
//             <tr>
//               <th>Service</th>
//               <th>Details</th>
//               <th>Amount</th>
//             </tr>
//           </thead>
//           <tbody>
//             <tr>
//               <td>{order.Service ? order.Service.services_name : "Unknown"}</td>
//               <td>
//                 {order.bed !== undefined ? (
//                   <>
//                     <div>
//                       Bedroom: {order.bed}, Bathroom: {order.bath},
//                       Drawing-Dinning: {order.dra_din}
//                     </div>
//                     <div>
//                       Kitchen: {order.kitchen}, Cloths: {order.cloth}, Dishes:{" "}
//                       {order.dish}
//                     </div>
//                   </>
//                 ) : order.Fan_in_un !== undefined ? (
//                   <>
//                     <div>
//                       Fan Install: {order.Fan_in_un}, Light Install:{" "}
//                       {order.Light_in_un}, Fan Repair: {order.Fan_repair}, Light
//                       Repair: {order.Light_repair}
//                     </div>
//                     <div>
//                       Switch Repair: {order.Switch_repair}, MCB Service:{" "}
//                       {order.MCB_service}, MDB Service: {order.MDB_service}
//                     </div>
//                   </>
//                 ) : (
//                   <>
//                     <div>
//                       Toilet Install: {order.Toilet_in}, Faucet Install:{" "}
//                       {order.Faucet_in}, Sink Install: {order.Sink_in},
//                       Dishwasher Install: {order.Dishwasher_in}
//                     </div>
//                     <div>
//                       Leak Repair: {order.Leak_repair}, Faucet Repair:{" "}
//                       {order.Faucet_repair}, Toilet Repair:{" "}
//                       {order.Toilet_repair}, Shower Repair:{" "}
//                       {order.Shower_repair}
//                     </div>
//                     <div>Drain Cleaning: {order.Drain_cleaning}</div>
//                   </>
//                 )}
//               </td>
//               <td>{order.price} tk</td>
//             </tr>
//           </tbody>
//         </table>
//       </div>

//       {/* Show Cancel button only if the order is not accepted */}
//       {order.status !== "Accepted" && (
//         <div
//           className="print-button-container"
//           style={{ display: "flex", justifyContent: "flex-start" }}
//         >
//           <button
//             className="manage-button"
//             onClick={handleCancelClick}
//             style={{ background: "red" }}
//           >
//             Cancel Order
//           </button>
//         </div>
//       )}

//       {/* Cancel Confirmation Modal */}
//       <Modal show={showCancelConfirm} onHide={handleCancelNo} centered>
//         <Modal.Header closeButton>
//           <Modal.Title>Confirm Cancellation</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <p>Are you sure you want to cancel this order?</p>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={handleCancelNo}>
//             No
//           </Button>
//           <Button variant="danger" onClick={handleCancelConfirmYes}>
//             Yes, Cancel Order
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Cancellation Feedback Modal */}
//       <Modal show={showCancelFeedback} onHide={handleFeedbackCancel} centered>
//         <Modal.Header closeButton>
//           <Modal.Title>Cancellation Feedback</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <p>Please let us know why you are canceling your order:</p>
//           <Form>
//             <Form.Check
//               type="radio"
//               label="Service is taking too long"
//               name="cancellationReason"
//               value="Service is taking too long"
//               checked={cancellationReason === "Service is taking too long"}
//               onChange={(e) => setCancellationReason(e.target.value)}
//             />
//             <Form.Check
//               type="radio"
//               label="Found another provider"
//               name="cancellationReason"
//               value="Found another provider"
//               checked={cancellationReason === "Found another provider"}
//               onChange={(e) => setCancellationReason(e.target.value)}
//             />
//             <Form.Check
//               type="radio"
//               label="No longer need the service"
//               name="cancellationReason"
//               value="No longer need the service"
//               checked={cancellationReason === "No longer need the service"}
//               onChange={(e) => setCancellationReason(e.target.value)}
//             />
//             <Form.Check
//               type="radio"
//               label="Other"
//               name="cancellationReason"
//               value="Other"
//               checked={cancellationReason === "Other"}
//               onChange={(e) => setCancellationReason(e.target.value)}
//             />
//           </Form>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={handleFeedbackCancel}>
//             Cancel
//           </Button>
//           <Button variant="primary" onClick={handleFeedbackSubmit}>
//             Submit
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Cancellation Success Modal */}
//       <Modal show={showCancelSuccess} onHide={handleSuccessOk} centered>
//         <Modal.Header closeButton>
//           <Modal.Title>Order Cancelled</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <p>Your order has been cancelled successfully.</p>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="primary" onClick={handleSuccessOk}>
//             OK
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       <Modal
//         show={showServitorModal}
//         onHide={handleCloseServitorModal}
//         centered
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>Servitor Details</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           {order.Servitor ? (
//             <div className="servitor-details text-center">
//               <img
//                 src={
//                   order.Servitor.image
//                     ? `${URL}/uploads/${order.Servitor.image}`
//                     : "placeholder.jpg"
//                 }
//                 alt="Servitor"
//                 className="img-fluid rounded-circle mb-3"
//                 style={{
//                   width: "150px",
//                   height: "150px",
//                   objectFit: "cover",
//                   margin: "0 auto",
//                 }}
//               />
//               <p>
//                 <strong>Name:</strong> {order.Servitor.FirstName}{" "}
//                 {order.Servitor.LastName}
//               </p>
//               <p>
//                 <strong>Mobile:</strong>{" "}
//                 {order.Servitor.mobile ? `0${order.Servitor.mobile}` : "N/A"}
//               </p>
//               <p>
//                 <strong>Email:</strong> {order.Servitor.email}
//               </p>
//               <p>
//                 <strong>Address:</strong> {order.Servitor.Address}
//               </p>
//               <p>
//                 <strong>City:</strong> {order.Servitor.city}
//               </p>
//               <p>
//                 <strong>NID:</strong> {order.Servitor.NID}
//               </p>
//             </div>
//           ) : (
//             <p>Servitor details not available.</p>
//           )}
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={handleCloseServitorModal}>
//             Close
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </div>
//   );
// };

// export default OrderDetailsView;

// ***** update with order number url ****** //

// import React, { useState, useEffect } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import { jwtDecode } from "jwt-decode"; // Ensure jwtDecode is imported
// import { URL } from "../../../config";
// import { Modal, Button, Form } from "react-bootstrap";
// import "./userprofile.css";
// import TransactionModal from "./TransactionModal";

// const OrderDetailsView = () => {
//   const { orderId } = useParams(); // orderId is the order number, e.g. "PS-1009"
//   const navigate = useNavigate();
//   const [order, setOrder] = useState(null);
//   const [error, setError] = useState(null);

//   // Cancellation and transaction states remain unchanged
//   const [showCancelConfirm, setShowCancelConfirm] = useState(false);
//   const [showCancelFeedback, setShowCancelFeedback] = useState(false);
//   const [showCancelSuccess, setShowCancelSuccess] = useState(false);
//   const [cancellationReason, setCancellationReason] = useState("");
//   const [showTransactionModal, setShowTransactionModal] = useState(false);

//   useEffect(() => {
//     const fetchOrderDetails = async () => {
//       try {
//         // Get the logged-in user's id from token
//         const token = localStorage.getItem("token");
//         const decodedToken = jwtDecode(token);
//         // Remove "user-" prefix if it exists
//         const userId = decodedToken.Id.startsWith("user-")
//           ? decodedToken.Id.split("user-")[1]
//           : decodedToken.Id;

//         // Fetch orders for the user filtered by orderNumber
//         const response = await fetch(
//           `${URL}/user/${userId}/orders?orderNumber=${orderId}`
//         );
//         if (response.ok) {
//           const orderData = await response.json();
//           if (orderData && orderData.length > 0) {
//             // Use the first (and only) order that matches the order number
//             setOrder(orderData[0]);
//           } else {
//             setError("No order found with that order number.");
//           }
//         } else {
//           setError("Failed to fetch order details");
//         }
//       } catch (err) {
//         console.error("Error fetching order details:", err);
//         setError("Error fetching order details");
//       }
//     };

//     fetchOrderDetails();
//   }, [orderId]);

//   if (error) return <p>{error}</p>;
//   if (!order) return <p>Loading order details...</p>;

//   // Cancellation function remains unchanged
//   const performCancelOrder = async (reason) => {
//     try {
//       const endpoint = `${URL}/cancelOrder/${order.Id}`;
//       const payload = {
//         serviceType: order.service_name,
//         cancellation_feedback: reason,
//       };
//       const response = await fetch(endpoint, {
//         method: "PATCH",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(payload),
//       });
//       if (response.ok) {
//         return true;
//       } else {
//         const text = await response.text();
//         let errorData;
//         try {
//           errorData = text ? JSON.parse(text) : { message: text };
//         } catch (e) {
//           errorData = { message: text };
//         }
//         console.error("Failed to cancel order:", errorData);
//         alert("Failed to cancel order.");
//         return false;
//       }
//     } catch (err) {
//       console.error("Error cancelling order:", err);
//       alert("Error cancelling order.");
//       return false;
//     }
//   };

//   const handleCancelClick = () => setShowCancelConfirm(true);
//   const handleCancelNo = () => setShowCancelConfirm(false);
//   const handleCancelConfirmYes = () => {
//     setShowCancelConfirm(false);
//     setShowCancelFeedback(true);
//   };
//   const handleFeedbackSubmit = async () => {
//     if (!cancellationReason) {
//       alert("Please select a reason for cancellation.");
//       return;
//     }
//     const success = await performCancelOrder(cancellationReason);
//     if (success) {
//       setShowCancelFeedback(false);
//       setShowCancelSuccess(true);
//     }
//   };
//   const handleFeedbackCancel = () => setShowCancelFeedback(false);
//   const handleSuccessOk = () => {
//     setShowCancelSuccess(false);
//     navigate("/profile/orderhistory");
//   };

//   const handleTaskComplete = () => {
//     setShowTransactionModal(true);
//   };

//   const handleTransactionModalClose = () => {
//     setShowTransactionModal(false);
//   };

//   const handleTransactionSuccess = () => {
//     setShowTransactionModal(false);
//     navigate("/profile/orderhistory");
//   };

//   // Styles and layout (unchanged)
//   const cardStyle = {
//     width: "100%",
//     backgroundColor: "#f8f8f8",
//     padding: "20px",
//     borderRadius: "8px",
//     boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
//     marginBottom: "20px",
//     textAlign: "left",
//   };

//   const cardHeaderStyle = {
//     borderBottom: "1px solid #ddd",
//     paddingBottom: "10px",
//     marginBottom: "20px",
//     textAlign: "center",
//     fontWeight: "600",
//     fontSize: "1.2rem",
//   };

//   const userDetailsCard = (
//     <div style={cardStyle}>
//       <div style={cardHeaderStyle}>User Details</div>
//       <p>
//         <strong>Name:</strong>{" "}
//         {order.User ? `${order.User.FirstName} ${order.User.LastName}` : "Unknown"}
//       </p>
//       <p>
//         <strong>Mobile:</strong>{" "}
//         {order.User ? `0${order.User.mobile}` : "Unknown"}
//       </p>
//       <p>
//         <strong>City:</strong> {order.usercity || order.City}
//       </p>
//       <p>
//         <strong>Address:</strong> {order.useraddress || order.Address}
//       </p>
//     </div>
//   );

//   const servitorDetailsCard =
//     (order.status === "Accepted" ||
//       order.status === "In-Progress" ||
//       order.status === "Completed") &&
//     order.Servitor ? (
//       <div className="servitor-details-card">
//         <h2 className="servitor-header">Servitor Details</h2>
//         <hr />
//         <div className="servitor-top-row">
//           <div className="servitor-left-half">
//             <img
//               src={
//                 order.Servitor.image
//                   ? `${URL}/uploads/${order.Servitor.image}`
//                   : "https://via.placeholder.com/150"
//               }
//               alt="Servitor"
//               className="servitor-photo"
//             />
//             <div className="servitor-info-block">
//               <h4 className="servitor-name">
//                 {order.Servitor.FirstName} {order.Servitor.LastName}
//               </h4>
//               <div className="servitor-rating">
//                 <i className="fas fa-star star-filled"></i>
//                 <span className="rating-score">{order.Servitor.rating || 0}</span>
//                 <span className="rating-count">({order.Servitor.orders_completed || 0} Orders completed)</span>
//               </div>
//             </div>
//           </div>
//           <div className="servitor-right-half">
//             <div className="contact-line">
//               <i className="fas fa-phone-alt contact-icon"></i>
//               <span>{order.Servitor.mobile ? `0${order.Servitor.mobile}` : "N/A"}</span>
//             </div>
//             <div className="contact-line">
//               <i className="fas fa-envelope contact-icon"></i>
//               <span>{order.Servitor.email || "No email"}</span>
//             </div>
//             <div className="contact-line">
//               <i className="fas fa-map-marker-alt contact-icon"></i>
//               <span>{order.Servitor.city || "No city"}</span>
//             </div>
//           </div>
//         </div>
//         <div className="servitor-bottom-row">
//           <div className="servitor-info-box">
//             <div className="info-label">NID</div>
//             <div className="info-value">{order.Servitor.NID || "N/A"}</div>
//           </div>
//           <div className="servitor-info-box">
//             <div className="info-label">Experience</div>
//             <div className="info-value">{order.Servitor.experience} years</div>
//           </div>
//           <div className="servitor-info-box">
//             <div className="info-label">Service</div>
//             <div className="info-value">{order.Servitor.service || "N/A"}</div>
//           </div>
//         </div>
//       </div>
//     ) : (
//       <div className="servitor-details-card">
//         <h2 className="servitor-header">Servitor Details</h2>
//         <p style={{ fontStyle: "italic", color: "#888" }}>
//           Servitor has not accepted the order yet.
//         </p>
//       </div>
//     );

//   // const ServiceBadge = ({ service }) => {
//   //   let badgeStyle = {
//   //     display: "inline-block",
//   //     padding: "5px 10px",
//   //     borderRadius: "20px",
//   //     fontSize: "12px",
//   //     fontWeight: "500",
//   //     textAlign: "center",
//   //   };
//   //   if (service === "Home Cleaning") {
//   //     badgeStyle.backgroundColor = "#ebf5ff";
//   //     badgeStyle.color = "#2b6cb0";
//   //   } else if (service === "Plumber") {
//   //     badgeStyle.backgroundColor = "#e6fffa";
//   //     badgeStyle.color = "#2c7a7b";
//   //   } else if (service === "Electrician") {
//   //     badgeStyle.backgroundColor = "#fef3c7";
//   //     badgeStyle.color = "#92400e";
//   //   } else {
//   //     badgeStyle.backgroundColor = "#ebf5ff";
//   //     badgeStyle.color = "#2b6cb0";
//   //   }
//   //   return <span style={badgeStyle}>{service}</span>;
//   // };

//   // const StatusBadge = ({ status }) => {
//   //   const baseStyle = {
//   //     padding: "6px 12px",
//   //     borderRadius: "20px",
//   //     fontSize: "13px",
//   //     fontWeight: "500",
//   //     textAlign: "center",
//   //   };

//   //   let backgroundColor = "#e6f7ff";
//   //   let color = "#0958d9";

//   //   if (status.toLowerCase() === "completed") {
//   //     backgroundColor = "#d9f7be";
//   //     color = "#389e0d";
//   //   } else if (status.toLowerCase() === "accepted") {
//   //     backgroundColor = "#e6f7ff";
//   //     color = "#0958d9";
//   //   } else if (status.toLowerCase() === "pending") {
//   //     backgroundColor = "#fff3cd";
//   //     color = "#856404";
//   //   } else if (status.toLowerCase() === "rejected") {
//   //     backgroundColor = "#f8d7da";
//   //     color = "#721c24";
//   //   }

//   //   return (
//   //     <span style={{ ...baseStyle, backgroundColor, color }}>{status}</span>
//   //   );
//   // };

//   // const OrderDetails = ({ order }) => {
//   //   const { service_name } = order;
//   //   const textStyle = {
//   //     backgroundColor: "#f8f9fa",
//   //     padding: "4px 8px",
//   //     borderRadius: "4px",
//   //     fontSize: "12px",
//   //     color: "#495057",
//   //     marginRight: "8px",
//   //     marginBottom: "8px",
//   //     display: "inline-block",
//   //   };

//   //   const renderChip = (label, value) => {
//   //     if (!value || Number(value) === 0) {
//   //       return null;
//   //     }
//   //     return (
//   //       <span style={textStyle}>
//   //         {label}: {value}
//   //       </span>
//   //     );
//   //   };

//   //   if (service_name === "Home Cleaning") {
//   //     return (
//   //       <div style={{ display: "flex", flexDirection: "column" }}>
//   //         <div>
//   //           {renderChip("Bedroom", order.bed)}
//   //           {renderChip("Bathroom", order.bath)}
//   //           {renderChip("Drawing-Dinning", order.dra_din)}
//   //         </div>
//   //         <div>
//   //           {renderChip("Kitchen", order.kitchen)}
//   //           {renderChip("Cloths", order.cloth)}
//   //           {renderChip("Dishes", order.dish)}
//   //         </div>
//   //       </div>
//   //     );
//   //   } else if (service_name === "Plumber") {
//   //     return (
//   //       <div style={{ display: "flex", flexDirection: "column" }}>
//   //         <div>
//   //           {renderChip("Toilet Install", order.Toilet_in)}
//   //           {renderChip("Faucet Install", order.Faucet_in)}
//   //           {renderChip("Sink Install", order.Sink_in)}
//   //           {renderChip("Dishwasher Install", order.Dishwasher_in)}
//   //         </div>
//   //         <div>
//   //           {renderChip("Leak Repair", order.Leak_repair)}
//   //           {renderChip("Faucet Repair", order.Faucet_repair)}
//   //           {renderChip("Toilet Repair", order.Toilet_repair)}
//   //           {renderChip("Shower Repair", order.Shower_repair)}
//   //           {renderChip("Drain Clean", order.Drain_cleaning)}
//   //         </div>
//   //       </div>
//   //     );
//   //   } else if (service_name === "Electrician") {
//   //     return (
//   //       <div style={{ display: "flex", flexDirection: "column" }}>
//   //         <div>
//   //           {renderChip("Fan Install", order.Fan_in_un)}
//   //           {renderChip("Light Install", order.Light_in_un)}
//   //           {renderChip("Fan Repair", order.Fan_repair)}
//   //           {renderChip("Light Repair", order.Light_repair)}
//   //         </div>
//   //         <div>
//   //           {renderChip("Switch Repair", order.Switch_repair)}
//   //           {renderChip("MCB Service", order.MCB_service)}
//   //           {renderChip("MDB Service", order.MDB_service)}
//   //         </div>
//   //       </div>
//   //     );
//   //   } else {
//   //     return <div>Unknown service details</div>;
//   //   }
//   // };

//   return (
//     <div className="order-details-view" style={{ padding: "20px" }}>
//       <h4 style={{ textAlign: "center", marginBottom: "20px" }}>HelpNao - Order Details</h4>
//       <hr />
//       <div
//         className="invoice-header"
//         style={{ display: "flex", justifyContent: "space-between", marginBottom: "20px" }}
//       >
//         <div className="invoice-left">
//           <p>
//             <strong>Placed Order Date:</strong>{" "}
//             {new Date(order.created_at).toLocaleDateString()}
//           </p>
//           <p>
//             <strong>Service Delivered Date:</strong>{" "}
//             {order.date ? new Date(order.date).toLocaleDateString() : "TBD"}
//           </p>
//           <p>
//             <strong>Service Delivered Time:</strong> {order.time}
//           </p>
//           <p>
//             <strong>Order Status:</strong> {order.status}
//           </p>
//         </div>
//         <div className="invoice-right">
//           <p>
//             <strong>Invoice Order#:</strong> {order.order_number}
//           </p>
//         </div>
//       </div>
//       {order.status === "Completed" && (
//         <div
//           style={{
//             marginBottom: "20px",
//             textAlign: "center",
//             padding: "20px",
//             backgroundColor: "#e6ffed",
//             borderRadius: "8px",
//             border: "1px solid #10b981",
//           }}
//         >
//           <h3 style={{ margin: 0, color: "#10b981" }}>This order is successfully completed.</h3>
//           <p style={{ margin: "10px 0 0", fontWeight: "600", color: "#2c3e50" }}>Stay with HelpNao</p>
//         </div>
//       )}
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "space-between",
//           flexWrap: "wrap",
//           gap: "20px",
//         }}
//       >
//         {servitorDetailsCard}
//         {userDetailsCard}
//       </div>
//       <div className="invoice-details" style={{ marginTop: "20px" }}>
//         <table style={{ width: "100%", borderCollapse: "collapse" }}>
//           <thead>
//             <tr>
//               <th style={{ border: "1px solid #ddd", padding: "8px" }}>Service</th>
//               <th style={{ border: "1px solid #ddd", padding: "8px" }}>Details</th>
//               <th style={{ border: "1px solid #ddd", padding: "8px" }}>Amount</th>
//             </tr>
//           </thead>
//           <tbody>
//             <tr>
//               <td style={{ border: "1px solid #ddd", padding: "8px" }}>
//                 {order.Service
//                   ? order.Service.services_name
//                   : order.service_name || "Unknown"}
//               </td>
//               <td style={{ border: "1px solid #ddd", padding: "8px" }}>
//                 {order.service_name === "Home Cleaning" ? (
//                   <>
//                     <div>
//                       Bedroom: {order.bed}, Bathroom: {order.bath}, Drawing-Dinning: {order.dra_din}
//                     </div>
//                     <div>
//                       Kitchen: {order.kitchen}, Cloths: {order.cloth}, Dishes: {order.dish}
//                     </div>
//                   </>
//                 ) : order.service_name === "Electrician" ? (
//                   <>
//                     <div>
//                       Fan Install: {order.Fan_in_un}, Light Install: {order.Light_in_un}, Fan Repair: {order.Fan_repair}, Light Repair: {order.Light_repair}
//                     </div>
//                     <div>
//                       Switch Repair: {order.Switch_repair}, MCB Service: {order.MCB_service}, MDB Service: {order.MDB_service}
//                     </div>
//                   </>
//                 ) : order.service_name === "Plumber" ? (
//                   <>
//                     <div>
//                       Toilet Install: {order.Toilet_in}, Faucet Install: {order.Faucet_in}, Sink Install: {order.Sink_in}, Dishwasher Install: {order.Dishwasher_in}
//                     </div>
//                     <div>
//                       Leak Repair: {order.Leak_repair}, Faucet Repair: {order.Faucet_repair}, Toilet Repair: {order.Toilet_repair}, Shower Repair: {order.Shower_repair}
//                     </div>
//                     <div>Drain Cleaning: {order.Drain_cleaning}</div>
//                   </>
//                 ) : (
//                   <div>Service details unavailable</div>
//                 )}
//               </td>
//               <td style={{ border: "1px solid #ddd", padding: "8px" }}>{order.price} tk</td>
//             </tr>
//           </tbody>
//         </table>
//       </div>
//       {order.status === "Accepted" && order.verification_pin && (
//         <div className="card verification-pin-card">
//           <h3>Verification PIN</h3>
//           <p>
//             This is the PIN provided when the servitor arrived for verification.
//             Please note it down for your records.
//           </p>
//           <div className="pin-display">{order.verification_pin}</div>
//         </div>
//       )}
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           marginTop: "20px",
//         }}
//       >
//         <button
//           className="orderdetailsbtn back-btn"
//           onClick={() => navigate("/profile/orderhistory")}
//           onMouseOver={(e) =>
//             (e.currentTarget.style.backgroundColor = "#6d716e")
//           }
//           onMouseOut={(e) =>
//             (e.currentTarget.style.backgroundColor = "#151515")
//           }
//           style={{
//             backgroundColor: "#151515",
//             color: "#fff",
//             border: "none",
//             borderRadius: "4px",
//             padding: "10px 20px",
//             cursor: "pointer",
//             fontSize: "1rem",
//             transition: "background-color 0.3s ease",
//           }}
//         >
//           ← Back
//         </button>
//         <div>
//           {(order.status === "pending" ||
//             order.status === "Accepted" ||
//             order.status === "In-Progress") && (
//             <button
//               className="manage-button"
//               onClick={handleCancelClick}
//               style={{
//                 background: "red",
//                 color: "#fff",
//                 padding: "10px 20px",
//                 border: "none",
//                 borderRadius: "4px",
//                 marginRight: "10px",
//                 cursor: "pointer",
//               }}
//             >
//               Cancel Order
//             </button>
//           )}
//           {order.status === "Completed" && (
//             <button
//               className="manage-button"
//               onClick={() => alert("Print functionality not implemented yet")}
//               style={{
//                 background: "#007bff",
//                 color: "#fff",
//                 padding: "10px 20px",
//                 border: "none",
//                 borderRadius: "4px",
//                 marginRight: "10px",
//                 cursor: "pointer",
//               }}
//             >
//               Print
//             </button>
//           )}
//           {order.status === "In-Progress" && (
//             <button
//               className="manage-button"
//               onClick={handleTaskComplete}
//               style={{
//                 background: "green",
//                 color: "#fff",
//                 padding: "10px 20px",
//                 border: "none",
//                 borderRadius: "4px",
//                 cursor: "pointer",
//               }}
//             >
//               Task Complete
//             </button>
//           )}
//         </div>
//       </div>
//       <Modal show={showCancelConfirm} onHide={handleCancelNo} centered>
//         <Modal.Header closeButton>
//           <Modal.Title>Confirm Cancellation</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <p>Are you sure you want to cancel this order?</p>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={handleCancelNo}>No</Button>
//           <Button variant="danger" onClick={handleCancelConfirmYes}>Yes, Cancel Order</Button>
//         </Modal.Footer>
//       </Modal>
//       <Modal show={showCancelFeedback} onHide={handleFeedbackCancel} centered>
//         <Modal.Header closeButton>
//           <Modal.Title>Cancellation Feedback</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <p>Please let us know why you are canceling your order:</p>
//           <Form>
//             <Form.Check
//               type="radio"
//               label="Service is taking too long"
//               name="cancellationReason"
//               value="Service is taking too long"
//               checked={cancellationReason === "Service is taking too long"}
//               onChange={(e) => setCancellationReason(e.target.value)}
//             />
//             <Form.Check
//               type="radio"
//               label="Found another provider"
//               name="cancellationReason"
//               value="Found another provider"
//               checked={cancellationReason === "Found another provider"}
//               onChange={(e) => setCancellationReason(e.target.value)}
//             />
//             <Form.Check
//               type="radio"
//               label="No longer need the service"
//               name="cancellationReason"
//               value="No longer need the service"
//               checked={cancellationReason === "No longer need the service"}
//               onChange={(e) => setCancellationReason(e.target.value)}
//             />
//             <Form.Check
//               type="radio"
//               label="Other"
//               name="cancellationReason"
//               value="Other"
//               checked={cancellationReason === "Other"}
//               onChange={(e) => setCancellationReason(e.target.value)}
//             />
//           </Form>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={handleFeedbackCancel}>Cancel</Button>
//           <Button variant="primary" onClick={handleFeedbackSubmit}>Submit</Button>
//         </Modal.Footer>
//       </Modal>
//       <Modal show={showCancelSuccess} onHide={handleSuccessOk} centered>
//         <Modal.Header closeButton>
//           <Modal.Title>Order Cancelled</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <p>Your order has been cancelled successfully.</p>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="primary" onClick={handleSuccessOk}>OK</Button>
//         </Modal.Footer>
//       </Modal>
//       {showTransactionModal && (
//         <TransactionModal
//           order={order}
//           onClose={handleTransactionModalClose}
//           onSuccess={handleTransactionSuccess}
//         />
//       )}
//     </div>
//   );
// };

// export default OrderDetailsView;

// ******* Order Details With responsive and new design 8/4/2025 all is working fine ********** //

// import React, { useState, useEffect } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import { FaRedo } from "react-icons/fa";
// import { jwtDecode } from "jwt-decode";
// import { URL } from "../../../config";
// import { Modal, Button, Form } from "react-bootstrap";
// // import "./userprofile.css";
// import TransactionModal from "./TransactionModal";
// import "./OrderDetailsView.css";

// const OrderDetailsView = () => {
//   const { orderId } = useParams(); // orderId is the order number, e.g. "PS-1009"
//   const navigate = useNavigate();

//   const SERVICE_ROUTES = {
//     "Home Cleaning": "/services/home-cleaning",
//     Electrician: "/services/electrician",
//     Plumber: "/services/plumber",
//   };

//   const [order, setOrder] = useState(null);
//   const [error, setError] = useState(null);

//   // Cancellation and transaction states remain unchanged
//   const [showCancelConfirm, setShowCancelConfirm] = useState(false);
//   const [showCancelFeedback, setShowCancelFeedback] = useState(false);
//   const [showCancelSuccess, setShowCancelSuccess] = useState(false);
//   const [cancellationReason, setCancellationReason] = useState("");
//   const [showTransactionModal, setShowTransactionModal] = useState(false);

//   const [showAccountBlockedModal, setShowAccountBlockedModal] = useState(false);
//   const [blockedMessage, setBlockedMessage] = useState("");

//   useEffect(() => {
//     const fetchOrderDetails = async () => {
//       try {
//         // Get the logged-in user's id from token
//         const token = localStorage.getItem("token");
//         const decodedToken = jwtDecode(token);
//         // Remove "user-" prefix if it exists
//         const userId = decodedToken.Id.startsWith("user-")
//           ? decodedToken.Id.split("user-")[1]
//           : decodedToken.Id;

//         // Fetch orders for the user filtered by orderNumber
//         const response = await fetch(
//           `${URL}/user/${userId}/orders?orderNumber=${orderId}`
//         );
//         if (response.ok) {
//           const orderData = await response.json();
//           if (orderData && orderData.length > 0) {
//             // Use the first (and only) order that matches the order number
//             setOrder(orderData[0]);
//           } else {
//             setError("No order found with that order number.");
//           }
//         } else {
//           setError("Failed to fetch order details");
//         }
//       } catch (err) {
//         console.error("Error fetching order details:", err);
//         setError("Error fetching order details");
//       }
//     };

//     fetchOrderDetails();
//   }, [orderId]);

//   if (error) return <p>{error}</p>;
//   if (!order) return <p>Loading order details...</p>;

//   // Cancellation function remains unchanged
//   const performCancelOrder = async (reason) => {
//     try {
//       const endpoint = `${URL}/cancelOrder/${order.Id}`;
//       const payload = {
//         serviceType: order.service_name,
//         cancellation_feedback: reason,
//       };
//       const response = await fetch(endpoint, {
//         method: "PATCH",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(payload),
//       });
//       if (response.ok) {
//         return true;
//       } else {
//         const text = await response.text();
//         let errorData;
//         try {
//           errorData = text ? JSON.parse(text) : { message: text };
//         } catch (e) {
//           errorData = { message: text };
//         }
//         console.error("Failed to cancel order:", errorData);

//         // Updated: Avoid console error for account blocked case
//         if (errorData.errorType === "account_blocked") {
//           setBlockedMessage(
//             `Your account has been blocked due to excessive cancellations (${errorData.penaltyCount} times). Total penalty: ${errorData.totalPenalty} taka. Please contact support.`
//           );
//           setShowAccountBlockedModal(true);
//           // Updated: Close cancellation feedback modal
//           setShowCancelFeedback(false);
//           return false;
//         }

//         alert("Failed to cancel order.");
//         return false;
//       }
//     } catch (err) {
//       console.error("Error cancelling order:", err);
//       alert("Error cancelling order.");
//       return false;
//     }
//   };

//   const handleCancelClick = () => setShowCancelConfirm(true);
//   const handleCancelNo = () => setShowCancelConfirm(false);
//   const handleCancelConfirmYes = () => {
//     setShowCancelConfirm(false);
//     setShowCancelFeedback(true);
//   };
//   const handleFeedbackSubmit = async () => {
//     if (!cancellationReason) {
//       alert("Please select a reason for cancellation.");
//       return;
//     }
//     const success = await performCancelOrder(cancellationReason);
//     if (success) {
//       setShowCancelFeedback(false);
//       setShowCancelSuccess(true);
//     }
//   };
//   const handleFeedbackCancel = () => setShowCancelFeedback(false);
//   const handleSuccessOk = () => {
//     setShowCancelSuccess(false);
//     navigate("/profile/orderhistory");
//   };

//   const handleAccountBlockedClose = () => {
//     setShowAccountBlockedModal(false);
//     // Clear token and redirect to login since the user is blocked
//     localStorage.removeItem("token");
//     navigate("/profile/orderhistory");
//   };

//   const handleTaskComplete = () => {
//     setShowTransactionModal(true);
//   };

//   const handleTransactionModalClose = () => {
//     setShowTransactionModal(false);
//   };

//   const handleTransactionSuccess = () => {
//     setShowTransactionModal(false);
//     navigate("/profile/orderhistory");
//   };

//   const handleRebook = () => {
//     // pick the right path based on order.service_name
//     const path =
//       SERVICE_ROUTES[order.service_name] || "/services/home-cleaning";
//     navigate(path, {
//       state: {
//         fromRebook: true,
//         previousOrder: order,
//       },
//     });
//   };

//   const userDetailsCard = (
//     <div className="OrderDetailsView-card">
//       <div className="OrderDetailsView-cardHeader">User Details</div>
//       <p>
//         <strong>Name:</strong>{" "}
//         {order.User
//           ? `${order.User.FirstName} ${order.User.LastName}`
//           : "Unknown"}
//       </p>
//       <p>
//         <strong>Mobile:</strong>{" "}
//         {order.User ? `0${order.User.mobile}` : "Unknown"}
//       </p>
//       <p>
//         <strong>City:</strong> {order.usercity || order.City}
//       </p>
//       <p>
//         <strong>Address:</strong> {order.useraddress || order.Address}
//       </p>
//     </div>
//   );

//   const servitorDetailsCard =
//     (order.status === "Accepted" ||
//       order.status === "In-Progress" ||
//       order.status === "Completed") &&
//     order.Servitor ? (
//       <div className="OrderDetails-servitor-card">
//         <h2 className="OrderDetails-servitor-header">Servitor Details</h2>
//         <hr className="OrderDetails-divider" />
//         <div className="OrderDetails-servitor-top-row">
//           <div className="OrderDetails-servitor-left-half">
//             <img
//               src={
//                 order.Servitor.image
//                   ? `${URL}/uploads/${order.Servitor.image}`
//                   : "https://via.placeholder.com/150"
//               }
//               alt="Servitor"
//               className="OrderDetails-servitor-photo"
//             />
//             <div className="OrderDetails-servitor-info-block">
//               <h4 className="OrderDetails-servitor-name">
//                 {order.Servitor.FirstName} {order.Servitor.LastName}
//               </h4>
//               <div className="OrderDetails-servitor-rating">
//                 <i className="fas fa-star OrderDetails-star-filled"></i>
//                 <span className="OrderDetails-rating-score">
//                   {order.Servitor.rating || 0}
//                 </span>
//                 <span className="OrderDetails-rating-count">
//                   ({order.Servitor.orders_completed || 0} Orders completed)
//                 </span>
//               </div>
//             </div>
//           </div>
//           <div className="OrderDetails-servitor-right-half">
//             <div className="OrderDetails-contact-line">
//               <i className="fas fa-phone-alt OrderDetails-contact-icon"></i>
//               <span>
//                 {order.Servitor.mobile ? `0${order.Servitor.mobile}` : "N/A"}
//               </span>
//             </div>
//             <div className="OrderDetails-contact-line">
//               <i className="fas fa-envelope OrderDetails-contact-icon"></i>
//               <span>{order.Servitor.email || "No email"}</span>
//             </div>
//             <div className="OrderDetails-contact-line">
//               <i className="fas fa-map-marker-alt OrderDetails-contact-icon"></i>
//               <span>{order.Servitor.city || "No city"}</span>
//             </div>
//           </div>
//         </div>
//         <div className="OrderDetails-servitor-bottom-row">
//           <div className="OrderDetails-servitor-info-box">
//             <div className="OrderDetails-info-label">NID</div>
//             <div className="OrderDetails-info-value">
//               {order.Servitor.NID || "N/A"}
//             </div>
//           </div>
//           <div className="OrderDetails-servitor-info-box">
//             <div className="OrderDetails-info-label">Experience</div>
//             <div className="OrderDetails-info-value">
//               {order.Servitor.experience} years
//             </div>
//           </div>
//           <div className="OrderDetails-servitor-info-box">
//             <div className="OrderDetails-info-label">Service</div>
//             <div className="OrderDetails-info-value">
//               {order.Servitor.service || "N/A"}
//             </div>
//           </div>
//         </div>
//       </div>
//     ) : (
//       <div className="OrderDetails-servitor-card">
//         <h2 className="OrderDetails-servitor-header">Servitor Details</h2>
//         <p style={{ fontStyle: "italic", color: "#888" }}>
//           Servitor has not accepted the order yet.
//         </p>
//       </div>
//     );

//   return (
//     <div className="OrderDetailsView-container">
//       <h4 className="OrderDetailsView-mainTitle">HelpNao - Order Details</h4>
//       <hr />
//       <div className="OrderDetailsView-invoiceHeader">
//         <div className="invoice-left">
//           <p className="OrderDetailsView-invoiceText">
//             <strong>Placed Order Date:</strong>{" "}
//             {new Date(order.created_at).toLocaleDateString()}
//           </p>
//           <p className="OrderDetailsView-invoiceText">
//             <strong>Service Delivered Date:</strong>{" "}
//             {order.date ? new Date(order.date).toLocaleDateString() : "TBD"}
//           </p>
//           <p className="OrderDetailsView-invoiceText">
//             <strong>Service Delivered Time:</strong> {order.time}
//           </p>
//           <p className="OrderDetailsView-invoiceText">
//             <strong>Order Status:</strong> {order.status}
//           </p>
//         </div>
//         <div className="invoice-right">
//           <p className="OrderDetailsView-invoiceText">
//             <strong>Invoice Order#:</strong> {order.order_number}
//           </p>
//         </div>
//       </div>

//       {order.status === "Completed" && (
//         <div className="OrderDetailsView-completedBanner">
//           <h3>This order is successfully completed.</h3>
//           <p>Stay with HelpNao</p>
//         </div>
//       )}

//       <div className="OrderDetailsView-flexWrap">
//         {servitorDetailsCard}
//         {userDetailsCard}
//       </div>

//       <div className="OrderDetailsView-invoiceDetails">
//         <table className="OrderDetailsView-table">
//           <thead>
//             <tr>
//               <th>Service</th>
//               <th>Details</th>
//               <th>Amount</th>
//             </tr>
//           </thead>
//           <tbody>
//             <tr>
//               <td>
//                 {order.Service
//                   ? order.Service.services_name
//                   : order.service_name || "Unknown"}
//               </td>
//               <td>
//                 {order.service_name === "Home Cleaning" ? (
//                   <>
//                     {/* <div>
//                       Bedroom: {order.bed}, Bathroom: {order.bath},
//                       Drawing-Dinning: {order.dra_din}
//                     </div>
//                     <div>
//                       Kitchen: {order.kitchen}, Cloths: {order.cloth}, Dishes:{" "}
//                       {order.dish}
//                     </div> */}
//                     <div>
//                       Bedroom: {order.bed}, Kitchen: {order.kitchen},
//                       Drawing-Dining: {order.dra_din}
//                     </div>
//                     <div>
//                       Bathroom: {order.bath}, Balcony Cleaning: {order.balcony},
//                       Window & Grill Cleaning: {order.window_grill}
//                     </div>
//                     <div>
//                       Furniture Cleaning: {order.furniture_cleaning}, Cloths:{" "}
//                       {order.cloth}, Dishes: {order.dish}
//                     </div>
//                   </>
//                 ) : order.service_name === "Electrician" ? (
//                   <>
//                     <div>
//                       Fan Install: {order.Fan_in_un}, Light Install:{" "}
//                       {order.Light_in_un}, Fan Repair: {order.Fan_repair}, Light
//                       Repair: {order.Light_repair}
//                     </div>
//                     <div>
//                       Switch Repair: {order.Switch_repair}, MCB Service:{" "}
//                       {order.MCB_service}, MDB Service: {order.MDB_service}
//                     </div>

//                     {/* — new features — */}
//                     <div>
//                       Regulator Install: {order.Fan_regulator_in_un}, Regulator
//                       Repair: {order.Fan_regulator_repair}, Socket Install:{" "}
//                       {order.Socket_in_un}, Socket Repair: {order.Socket_repair}
//                     </div>
//                     <div>
//                       Breaker Repair: {order.Circuit_breaker_repair}, New Wiring
//                       Point: {order.New_wiring_point}, Full Wiring:{" "}
//                       {order.Full_wiring ? "Yes" : "No"}, Electrical Checkup:{" "}
//                       {order.Electrical_checkup ? "Yes" : "No"}
//                     </div>
//                   </>
//                 ) : order.service_name === "Plumber" ? (
//                   <>
//                     <div>
//                       Toilet Install: {order.Toilet_in}, Faucet Install:{" "}
//                       {order.Faucet_in}, Sink Install: {order.Sink_in},
//                       Dishwasher Install: {order.Dishwasher_in}
//                     </div>
//                     <div>
//                       Leak Repair: {order.Leak_repair}, Faucet Repair:{" "}
//                       {order.Faucet_repair}, Toilet Repair:{" "}
//                       {order.Toilet_repair}, Shower Repair:{" "}
//                       {order.Shower_repair}
//                     </div>
//                     <div>
//                       Drain Cleaning: {order.Drain_cleaning}
//                       Pipe Cleaning: {order.pipe_cleaning}, Tank Cleaning:{" "}
//                       {order.tank_cleaning}, Issue Checkup:{" "}
//                       {order.issue_checkup ? "Yes" : "No"}
//                     </div>
//                   </>
//                 ) : (
//                   <div>Service details unavailable</div>
//                 )}
//               </td>
//               <td>{order.price} tk</td>
//             </tr>
//           </tbody>
//         </table>
//       </div>

//       {order.status === "Accepted" && order.verification_pin && (
//         <div className="OrderDetailsView-pinCard">
//           <h3>Verification PIN</h3>
//           <p>
//             This is the PIN provided when the servitor arrived for verification.
//             Please note it down for your records.
//           </p>
//           <div className="pin-display">{order.verification_pin}</div>
//         </div>
//       )}

//       <div className="OrderDetailsView-buttonRow">
//         <button
//           className="OrderDetailsView-backBtn"
//           onClick={() => navigate("/profile/orderhistory")}
//         >
//           ← Back
//         </button>
//         <div className="OrderDetailsView-actionGroup">
//           {(order.status === "pending" ||
//             order.status === "Accepted" ||
//             order.status === "In-Progress") && (
//             <button
//               className="OrderDetailsView-cancelBtn"
//               onClick={handleCancelClick}
//             >
//               Cancel Order
//             </button>
//           )}
//           {order.status === "Completed" && (
//             <>
//               <button
//                 className="OrderDetailsView-printBtn"
//                 onClick={() => alert("Print functionality not implemented yet")}
//               >
//                 Print
//               </button>

//               <button
//                 className="OrderDetailsView-rebookBtn"
//                 onClick={handleRebook}
//               >
//                 <FaRedo className="OrderDetailsView-rebookIcon" />
//                 Rebook
//               </button>
//             </>
//           )}
//           {order.status === "In-Progress" && (
//             <button
//               className="OrderDetailsView-taskCompleteBtn"
//               onClick={handleTaskComplete}
//             >
//               Task Complete
//             </button>
//           )}
//         </div>
//       </div>

//       {/* Cancel Confirm Modal */}
//       <Modal show={showCancelConfirm} onHide={handleCancelNo} centered>
//         <Modal.Header closeButton>
//           <Modal.Title>Confirm Cancellation</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <p>Are you sure you want to cancel this order?</p>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={handleCancelNo}>
//             No
//           </Button>
//           <Button variant="danger" onClick={handleCancelConfirmYes}>
//             Yes, Cancel Order
//           </Button>
//         </Modal.Footer>
//       </Modal>
//       <Modal show={showCancelFeedback} onHide={handleFeedbackCancel} centered>
//         <Modal.Header closeButton>
//           <Modal.Title>Cancellation Feedback</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <p>Please let us know why you are canceling your order:</p>
//           <Form>
//             <Form.Check
//               type="radio"
//               label="Service is taking too long"
//               name="cancellationReason"
//               value="Service is taking too long"
//               checked={cancellationReason === "Service is taking too long"}
//               onChange={(e) => setCancellationReason(e.target.value)}
//             />
//             <Form.Check
//               type="radio"
//               label="Found another provider"
//               name="cancellationReason"
//               value="Found another provider"
//               checked={cancellationReason === "Found another provider"}
//               onChange={(e) => setCancellationReason(e.target.value)}
//             />
//             <Form.Check
//               type="radio"
//               label="No longer need the service"
//               name="cancellationReason"
//               value="No longer need the service"
//               checked={cancellationReason === "No longer need the service"}
//               onChange={(e) => setCancellationReason(e.target.value)}
//             />
//             <Form.Check
//               type="radio"
//               label="Other"
//               name="cancellationReason"
//               value="Other"
//               checked={cancellationReason === "Other"}
//               onChange={(e) => setCancellationReason(e.target.value)}
//             />
//           </Form>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={handleFeedbackCancel}>
//             Cancel
//           </Button>
//           <Button variant="primary" onClick={handleFeedbackSubmit}>
//             Submit
//           </Button>
//         </Modal.Footer>
//       </Modal>
//       <Modal show={showCancelSuccess} onHide={handleSuccessOk} centered>
//         <Modal.Header closeButton>
//           <Modal.Title>Order Cancelled</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <p>Your order has been cancelled successfully.</p>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="primary" onClick={handleSuccessOk}>
//             OK
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Added: Modal for account blocked */}
//       <Modal
//         show={showAccountBlockedModal}
//         onHide={handleAccountBlockedClose}
//         centered
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>Account Blocked</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <p>{blockedMessage}</p>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="primary" onClick={handleAccountBlockedClose}>
//             OK
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {showTransactionModal && (
//         <TransactionModal
//           order={order}
//           onClose={handleTransactionModalClose}
//           onSuccess={handleTransactionSuccess}
//         />
//       )}
//     </div>
//   );
// };

// export default OrderDetailsView;

// ************************** All Update and okay with - Receipt (last check 16-06-25) **************************** //

// import React, { useState, useEffect } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import { FaRedo, FaDownload } from "react-icons/fa";
// import { jwtDecode } from "jwt-decode";
// import { URL } from "../../../config";
// import { Modal, Button, Form } from "react-bootstrap";
// // import "./userprofile.css";
// import TransactionModal from "./TransactionModal";
// import ReceiptGenerator from "./ReceiptGenerator";
// import "./OrderDetailsView.css";

// const OrderDetailsView = () => {
//   const { orderId } = useParams(); // orderId is the order number, e.g. "PS-1009"
//   const navigate = useNavigate();

//   const SERVICE_ROUTES = {
//     "Home Cleaning": "/services/home-cleaning",
//     Electrician: "/services/electrician",
//     Plumber: "/services/plumber",
//   };

//   const [order, setOrder] = useState(null);
//   const [error, setError] = useState(null);

//   // Cancellation and transaction states remain unchanged
//   const [showCancelConfirm, setShowCancelConfirm] = useState(false);
//   const [showCancelFeedback, setShowCancelFeedback] = useState(false);
//   const [showCancelSuccess, setShowCancelSuccess] = useState(false);
//   const [cancellationReason, setCancellationReason] = useState("");
//   const [showTransactionModal, setShowTransactionModal] = useState(false);

//   const [showAccountBlockedModal, setShowAccountBlockedModal] = useState(false);
//   const [blockedMessage, setBlockedMessage] = useState("");

//   const [showReceipt, setShowReceipt] = useState(false);

//   useEffect(() => {
//     const fetchOrderDetails = async () => {
//       try {
//         // Get the logged-in user's id from token
//         const token = localStorage.getItem("token");
//         const decodedToken = jwtDecode(token);
//         // Remove "user-" prefix if it exists
//         const userId = decodedToken.Id.startsWith("user-")
//           ? decodedToken.Id.split("user-")[1]
//           : decodedToken.Id;

//         // Fetch orders for the user filtered by orderNumber
//         const response = await fetch(
//           `${URL}/user/${userId}/orders?orderNumber=${orderId}`
//         );
//         if (response.ok) {
//           const orderData = await response.json();
//           if (orderData && orderData.length > 0) {
//             // Use the first (and only) order that matches the order number
//             setOrder(orderData[0]);
//           } else {
//             setError("No order found with that order number.");
//           }
//         } else {
//           setError("Failed to fetch order details");
//         }
//       } catch (err) {
//         console.error("Error fetching order details:", err);
//         setError("Error fetching order details");
//       }
//     };

//     fetchOrderDetails();
//   }, [orderId]);

//   if (error) return <p>{error}</p>;
//   if (!order) return <p>Loading order details...</p>;

//   // Cancellation function remains unchanged
//   const performCancelOrder = async (reason) => {
//     try {
//       const endpoint = `${URL}/cancelOrder/${order.Id}`;
//       const payload = {
//         serviceType: order.service_name,
//         cancellation_feedback: reason,
//       };
//       const response = await fetch(endpoint, {
//         method: "PATCH",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(payload),
//       });
//       if (response.ok) {
//         return true;
//       } else {
//         const text = await response.text();
//         let errorData;
//         try {
//           errorData = text ? JSON.parse(text) : { message: text };
//         } catch (e) {
//           errorData = { message: text };
//         }
//         console.error("Failed to cancel order:", errorData);

//         // Updated: Avoid console error for account blocked case
//         if (errorData.errorType === "account_blocked") {
//           setBlockedMessage(
//             `Your account has been blocked due to excessive cancellations (${errorData.penaltyCount} times). Total penalty: ${errorData.totalPenalty} taka. Please contact support.`
//           );
//           setShowAccountBlockedModal(true);
//           // Updated: Close cancellation feedback modal
//           setShowCancelFeedback(false);
//           return false;
//         }

//         alert("Failed to cancel order.");
//         return false;
//       }
//     } catch (err) {
//       console.error("Error cancelling order:", err);
//       alert("Error cancelling order.");
//       return false;
//     }
//   };

//   const handleCancelClick = () => setShowCancelConfirm(true);
//   const handleCancelNo = () => setShowCancelConfirm(false);
//   const handleCancelConfirmYes = () => {
//     setShowCancelConfirm(false);
//     setShowCancelFeedback(true);
//   };
//   const handleFeedbackSubmit = async () => {
//     if (!cancellationReason) {
//       alert("Please select a reason for cancellation.");
//       return;
//     }
//     const success = await performCancelOrder(cancellationReason);
//     if (success) {
//       setShowCancelFeedback(false);
//       setShowCancelSuccess(true);
//     }
//   };
//   const handleFeedbackCancel = () => setShowCancelFeedback(false);
//   const handleSuccessOk = () => {
//     setShowCancelSuccess(false);
//     navigate("/profile/orderhistory");
//   };

//   const handleAccountBlockedClose = () => {
//     setShowAccountBlockedModal(false);
//     // Clear token and redirect to login since the user is blocked
//     localStorage.removeItem("token");
//     navigate("/profile/orderhistory");
//   };

//   const handleTaskComplete = () => {
//     setShowTransactionModal(true);
//   };

//   const handleTransactionModalClose = () => {
//     setShowTransactionModal(false);
//   };

//   const handleTransactionSuccess = () => {
//     setShowTransactionModal(false);
//     navigate("/profile/orderhistory");
//   };

//   const handleRebook = () => {
//     // pick the right path based on order.service_name
//     const path =
//       SERVICE_ROUTES[order.service_name] || "/services/home-cleaning";
//     navigate(path, {
//       state: {
//         fromRebook: true,
//         previousOrder: order,
//       },
//     });
//   };

//   const userDetailsCard = (
//     <div className="OrderDetailsView-card">
//       <div className="OrderDetailsView-cardHeader">User Details</div>
//       <p>
//         <strong>Name:</strong>{" "}
//         {order.User
//           ? `${order.User.FirstName} ${order.User.LastName}`
//           : "Unknown"}
//       </p>
//       <p>
//         <strong>Mobile:</strong>{" "}
//         {order.User ? `0${order.User.mobile}` : "Unknown"}
//       </p>
//       <p>
//         <strong>City:</strong> {order.usercity || order.City}
//       </p>
//       <p>
//         <strong>Address:</strong> {order.useraddress || order.Address}
//       </p>
//     </div>
//   );

//   const servitorDetailsCard =
//     (order.status === "Accepted" ||
//       order.status === "In-Progress" ||
//       order.status === "Completed") &&
//     order.Servitor ? (
//       <div className="OrderDetails-servitor-card">
//         <h2 className="OrderDetails-servitor-header">Servitor Details</h2>
//         <hr className="OrderDetails-divider" />
//         <div className="OrderDetails-servitor-top-row">
//           <div className="OrderDetails-servitor-left-half">
//             <img
//               src={
//                 order.Servitor.image
//                   ? `${URL}/uploads/${order.Servitor.image}`
//                   : "https://via.placeholder.com/150"
//               }
//               alt="Servitor"
//               className="OrderDetails-servitor-photo"
//             />
//             <div className="OrderDetails-servitor-info-block">
//               <h4 className="OrderDetails-servitor-name">
//                 {order.Servitor.FirstName} {order.Servitor.LastName}
//               </h4>
//               <div className="OrderDetails-servitor-rating">
//                 <i className="fas fa-star OrderDetails-star-filled"></i>
//                 <span className="OrderDetails-rating-score">
//                   {order.Servitor.rating || 0}
//                 </span>
//                 <span className="OrderDetails-rating-count">
//                   ({order.Servitor.orders_completed || 0} Orders completed)
//                 </span>
//               </div>
//             </div>
//           </div>
//           <div className="OrderDetails-servitor-right-half">
//             <div className="OrderDetails-contact-line">
//               <i className="fas fa-phone-alt OrderDetails-contact-icon"></i>
//               <span>
//                 {order.Servitor.mobile ? `0${order.Servitor.mobile}` : "N/A"}
//               </span>
//             </div>
//             <div className="OrderDetails-contact-line">
//               <i className="fas fa-envelope OrderDetails-contact-icon"></i>
//               <span>{order.Servitor.email || "No email"}</span>
//             </div>
//             <div className="OrderDetails-contact-line">
//               <i className="fas fa-map-marker-alt OrderDetails-contact-icon"></i>
//               <span>{order.Servitor.city || "No city"}</span>
//             </div>
//           </div>
//         </div>
//         <div className="OrderDetails-servitor-bottom-row">
//           <div className="OrderDetails-servitor-info-box">
//             <div className="OrderDetails-info-label">NID</div>
//             <div className="OrderDetails-info-value">
//               {order.Servitor.NID || "N/A"}
//             </div>
//           </div>
//           <div className="OrderDetails-servitor-info-box">
//             <div className="OrderDetails-info-label">Experience</div>
//             <div className="OrderDetails-info-value">
//               {order.Servitor.experience} years
//             </div>
//           </div>
//           <div className="OrderDetails-servitor-info-box">
//             <div className="OrderDetails-info-label">Service</div>
//             <div className="OrderDetails-info-value">
//               {order.Servitor.service || "N/A"}
//             </div>
//           </div>
//         </div>
//       </div>
//     ) : (
//       <div className="OrderDetails-servitor-card">
//         <h2 className="OrderDetails-servitor-header">Servitor Details</h2>
//         <p style={{ fontStyle: "italic", color: "#888" }}>
//           Servitor has not accepted the order yet.
//         </p>
//       </div>
//     );

//   return (
//     <div className="OrderDetailsView-container">
//       <h4 className="OrderDetailsView-mainTitle">HelpNao - Order Details</h4>
//       <hr />
//       <div className="OrderDetailsView-invoiceHeader">
//         <div className="invoice-left">
//           <p className="OrderDetailsView-invoiceText">
//             <strong>Placed Order Date:</strong>{" "}
//             {new Date(order.created_at).toLocaleDateString()}
//           </p>
//           <p className="OrderDetailsView-invoiceText">
//             <strong>Service Delivered Date:</strong>{" "}
//             {order.date ? new Date(order.date).toLocaleDateString() : "TBD"}
//           </p>
//           <p className="OrderDetailsView-invoiceText">
//             <strong>Service Delivered Time:</strong> {order.time}
//           </p>
//           <p className="OrderDetailsView-invoiceText">
//             <strong>Order Status:</strong> {order.status}
//           </p>
//         </div>
//         <div className="invoice-right">
//           <p className="OrderDetailsView-invoiceText">
//             <strong>Invoice Order#:</strong> {order.order_number}
//           </p>
//         </div>
//       </div>

//       {order.status === "Completed" && (
//         <div className="OrderDetailsView-completedBanner">
//           <h3>This order is successfully completed.</h3>
//           <p>Stay with HelpNao</p>
//         </div>
//       )}

//       <div className="OrderDetailsView-flexWrap">
//         {servitorDetailsCard}
//         {userDetailsCard}
//       </div>

//       <div className="OrderDetailsView-invoiceDetails">
//         <table className="OrderDetailsView-table">
//           <thead>
//             <tr>
//               <th>Service</th>
//               <th>Details</th>
//               <th>Amount</th>
//             </tr>
//           </thead>
//           <tbody>
//             <tr>
//               <td>
//                 {order.Service
//                   ? order.Service.services_name
//                   : order.service_name || "Unknown"}
//               </td>
//               <td>
//                 {order.service_name === "Home Cleaning" ? (
//                   <>
//                     {/* <div>
//                       Bedroom: {order.bed}, Bathroom: {order.bath},
//                       Drawing-Dinning: {order.dra_din}
//                     </div>
//                     <div>
//                       Kitchen: {order.kitchen}, Cloths: {order.cloth}, Dishes:{" "}
//                       {order.dish}
//                     </div> */}
//                     <div>
//                       Bedroom: {order.bed}, Kitchen: {order.kitchen},
//                       Drawing-Dining: {order.dra_din}
//                     </div>
//                     <div>
//                       Bathroom: {order.bath}, Balcony Cleaning: {order.balcony},
//                       Window & Grill Cleaning: {order.window_grill}
//                     </div>
//                     <div>
//                       Furniture Cleaning: {order.furniture_cleaning}, Cloths:{" "}
//                       {order.cloth}, Dishes: {order.dish}
//                     </div>
//                   </>
//                 ) : order.service_name === "Electrician" ? (
//                   <>
//                     <div>
//                       Fan Install: {order.Fan_in_un}, Light Install:{" "}
//                       {order.Light_in_un}, Fan Repair: {order.Fan_repair}, Light
//                       Repair: {order.Light_repair}
//                     </div>
//                     <div>
//                       Switch Repair: {order.Switch_repair}, MCB Service:{" "}
//                       {order.MCB_service}, MDB Service: {order.MDB_service}
//                     </div>

//                     {/* — new features — */}
//                     <div>
//                       Regulator Install: {order.Fan_regulator_in_un}, Regulator
//                       Repair: {order.Fan_regulator_repair}, Socket Install:{" "}
//                       {order.Socket_in_un}, Socket Repair: {order.Socket_repair}
//                     </div>
//                     <div>
//                       Breaker Repair: {order.Circuit_breaker_repair}, New Wiring
//                       Point: {order.New_wiring_point}, Full Wiring:{" "}
//                       {order.Full_wiring ? "Yes" : "No"}, Electrical Checkup:{" "}
//                       {order.Electrical_checkup ? "Yes" : "No"}
//                     </div>
//                   </>
//                 ) : order.service_name === "Plumber" ? (
//                   <>
//                     <div>
//                       Toilet Install: {order.Toilet_in}, Faucet Install:{" "}
//                       {order.Faucet_in}, Sink Install: {order.Sink_in},
//                       Dishwasher Install: {order.Dishwasher_in}
//                     </div>
//                     <div>
//                       Leak Repair: {order.Leak_repair}, Faucet Repair:{" "}
//                       {order.Faucet_repair}, Toilet Repair:{" "}
//                       {order.Toilet_repair}, Shower Repair:{" "}
//                       {order.Shower_repair}
//                     </div>
//                     <div>
//                       Drain Cleaning: {order.Drain_cleaning}
//                       Pipe Cleaning: {order.pipe_cleaning}, Tank Cleaning:{" "}
//                       {order.tank_cleaning}, Issue Checkup:{" "}
//                       {order.issue_checkup ? "Yes" : "No"}
//                     </div>
//                   </>
//                 ) : (
//                   <div>Service details unavailable</div>
//                 )}
//               </td>
//               <td>{order.price} tk</td>
//             </tr>
//           </tbody>
//         </table>
//       </div>

//       {order.status === "Accepted" && order.verification_pin && (
//         <div className="OrderDetailsView-pinCard">
//           <h3>Verification PIN</h3>
//           <p>
//             This is the PIN provided when the servitor arrived for verification.
//             Please note it down for your records.
//           </p>
//           <div className="pin-display">{order.verification_pin}</div>
//         </div>
//       )}

//       <div className="OrderDetailsView-buttonRow">
//         <button
//           className="OrderDetailsView-backBtn"
//           onClick={() => navigate("/profile/orderhistory")}
//         >
//           ← Back
//         </button>
//         <div className="OrderDetailsView-actionGroup">
//           {(order.status === "pending" ||
//             order.status === "Accepted" ||
//             order.status === "In-Progress") && (
//             <button
//               className="OrderDetailsView-cancelBtn"
//               onClick={handleCancelClick}
//             >
//               Cancel Order
//             </button>
//           )}
//           {order.status === "Completed" && (
//             <>
//               <button
//                 className="OrderDetailsView-receiptBtn"
//                 // onClick={() => ReceiptGenerator({ order })}
//                 onClick={() => setShowReceipt(true)}
//               >
//                 <FaDownload className="OrderDetailsView-receiptIcon" />
//                 Receipt
//               </button>

//               <button
//                 className="OrderDetailsView-rebookBtn"
//                 onClick={handleRebook}
//               >
//                 <FaRedo className="OrderDetailsView-rebookIcon" />
//                 Rebook
//               </button>
//             </>
//           )}
//           {order.status === "In-Progress" && (
//             <button
//               className="OrderDetailsView-taskCompleteBtn"
//               onClick={handleTaskComplete}
//             >
//               Task Complete
//             </button>
//           )}
//         </div>
//       </div>

//       {/* Cancel Confirm Modal */}
//       <Modal show={showCancelConfirm} onHide={handleCancelNo} centered>
//         <Modal.Header closeButton>
//           <Modal.Title>Confirm Cancellation</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <p>Are you sure you want to cancel this order?</p>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={handleCancelNo}>
//             No
//           </Button>
//           <Button variant="danger" onClick={handleCancelConfirmYes}>
//             Yes, Cancel Order
//           </Button>
//         </Modal.Footer>
//       </Modal>
//       <Modal show={showCancelFeedback} onHide={handleFeedbackCancel} centered>
//         <Modal.Header closeButton>
//           <Modal.Title>Cancellation Feedback</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <p>Please let us know why you are canceling your order:</p>
//           <Form>
//             <Form.Check
//               type="radio"
//               label="Service is taking too long"
//               name="cancellationReason"
//               value="Service is taking too long"
//               checked={cancellationReason === "Service is taking too long"}
//               onChange={(e) => setCancellationReason(e.target.value)}
//             />
//             <Form.Check
//               type="radio"
//               label="Found another provider"
//               name="cancellationReason"
//               value="Found another provider"
//               checked={cancellationReason === "Found another provider"}
//               onChange={(e) => setCancellationReason(e.target.value)}
//             />
//             <Form.Check
//               type="radio"
//               label="No longer need the service"
//               name="cancellationReason"
//               value="No longer need the service"
//               checked={cancellationReason === "No longer need the service"}
//               onChange={(e) => setCancellationReason(e.target.value)}
//             />
//             <Form.Check
//               type="radio"
//               label="Other"
//               name="cancellationReason"
//               value="Other"
//               checked={cancellationReason === "Other"}
//               onChange={(e) => setCancellationReason(e.target.value)}
//             />
//           </Form>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={handleFeedbackCancel}>
//             Cancel
//           </Button>
//           <Button variant="primary" onClick={handleFeedbackSubmit}>
//             Submit
//           </Button>
//         </Modal.Footer>
//       </Modal>
//       <Modal show={showCancelSuccess} onHide={handleSuccessOk} centered>
//         <Modal.Header closeButton>
//           <Modal.Title>Order Cancelled</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <p>Your order has been cancelled successfully.</p>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="primary" onClick={handleSuccessOk}>
//             OK
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Added: Modal for account blocked */}
//       <Modal
//         show={showAccountBlockedModal}
//         onHide={handleAccountBlockedClose}
//         centered
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>Account Blocked</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <p>{blockedMessage}</p>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="primary" onClick={handleAccountBlockedClose}>
//             OK
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {showTransactionModal && (
//         <TransactionModal
//           order={order}
//           onClose={handleTransactionModalClose}
//           onSuccess={handleTransactionSuccess}
//         />
//       )}

//       {showReceipt && (
//         <ReceiptGenerator
//           order={order}
//           onFinish={() => setShowReceipt(false)}
//         />
//       )}
//     </div>
//   );
// };

// export default OrderDetailsView;

// ********** With Has Value Details In table (Updated on 16-6-25)*********** //

// ************************** Receipt **************************** //

// import React, { useState, useEffect } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import { FaRedo, FaDownload } from "react-icons/fa";
// import { jwtDecode } from "jwt-decode";
// import { URL } from "../../../config";
// import { Modal, Button, Form } from "react-bootstrap";
// // import "./userprofile.css";
// import TransactionModal from "./TransactionModal";
// import ReceiptGenerator from "./ReceiptGenerator";
// import "./OrderDetailsView.css";

// const OrderDetailsView = () => {
//   const { orderId } = useParams(); // orderId is the order number, e.g. "PS-1009"
//   const navigate = useNavigate();

//   const SERVICE_ROUTES = {
//     "Home Cleaning": "/services/home-cleaning",
//     Electrician: "/services/electrician",
//     Plumber: "/services/plumber",
//   };

//   const [order, setOrder] = useState(null);
//   const [error, setError] = useState(null);

//   // Cancellation and transaction states remain unchanged
//   const [showCancelConfirm, setShowCancelConfirm] = useState(false);
//   const [showCancelFeedback, setShowCancelFeedback] = useState(false);
//   const [showCancelSuccess, setShowCancelSuccess] = useState(false);
//   const [cancellationReason, setCancellationReason] = useState("");
//   const [showTransactionModal, setShowTransactionModal] = useState(false);

//   const [showAccountBlockedModal, setShowAccountBlockedModal] = useState(false);
//   const [blockedMessage, setBlockedMessage] = useState("");

//   const [showReceipt, setShowReceipt] = useState(false);

//   useEffect(() => {
//     const fetchOrderDetails = async () => {
//       try {
//         // Get the logged-in user's id from token
//         const token = localStorage.getItem("token");
//         const decodedToken = jwtDecode(token);
//         // Remove "user-" prefix if it exists
//         const userId = decodedToken.Id.startsWith("user-")
//           ? decodedToken.Id.split("user-")[1]
//           : decodedToken.Id;

//         // Fetch orders for the user filtered by orderNumber
//         const response = await fetch(
//           `${URL}/user/${userId}/orders?orderNumber=${orderId}`
//         );
//         if (response.ok) {
//           const orderData = await response.json();
//           if (orderData && orderData.length > 0) {
//             // Use the first (and only) order that matches the order number
//             setOrder(orderData[0]);
//           } else {
//             setError("No order found with that order number.");
//           }
//         } else {
//           setError("Failed to fetch order details");
//         }
//       } catch (err) {
//         console.error("Error fetching order details:", err);
//         setError("Error fetching order details");
//       }
//     };

//     fetchOrderDetails();
//   }, [orderId]);

//   if (error) return <p>{error}</p>;
//   if (!order) return <p>Loading order details...</p>;

//   // Cancellation function remains unchanged
//   const performCancelOrder = async (reason) => {
//     try {
//       const endpoint = `${URL}/cancelOrder/${order.Id}`;
//       const payload = {
//         serviceType: order.service_name,
//         cancellation_feedback: reason,
//       };
//       const response = await fetch(endpoint, {
//         method: "PATCH",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(payload),
//       });
//       if (response.ok) {
//         return true;
//       } else {
//         const text = await response.text();
//         let errorData;
//         try {
//           errorData = text ? JSON.parse(text) : { message: text };
//         } catch (e) {
//           errorData = { message: text };
//         }
//         console.error("Failed to cancel order:", errorData);

//         // Updated: Avoid console error for account blocked case
//         if (errorData.errorType === "account_blocked") {
//           setBlockedMessage(
//             `Your account has been blocked due to excessive cancellations (${errorData.penaltyCount} times). Total penalty: ${errorData.totalPenalty} taka. Please contact support.`
//           );
//           setShowAccountBlockedModal(true);
//           // Updated: Close cancellation feedback modal
//           setShowCancelFeedback(false);
//           return false;
//         }

//         alert("Failed to cancel order.");
//         return false;
//       }
//     } catch (err) {
//       console.error("Error cancelling order:", err);
//       alert("Error cancelling order.");
//       return false;
//     }
//   };

//   const handleCancelClick = () => setShowCancelConfirm(true);
//   const handleCancelNo = () => setShowCancelConfirm(false);
//   const handleCancelConfirmYes = () => {
//     setShowCancelConfirm(false);
//     setShowCancelFeedback(true);
//   };
//   const handleFeedbackSubmit = async () => {
//     if (!cancellationReason) {
//       alert("Please select a reason for cancellation.");
//       return;
//     }
//     const success = await performCancelOrder(cancellationReason);
//     if (success) {
//       setShowCancelFeedback(false);
//       setShowCancelSuccess(true);
//     }
//   };
//   const handleFeedbackCancel = () => setShowCancelFeedback(false);
//   const handleSuccessOk = () => {
//     setShowCancelSuccess(false);
//     navigate("/profile/orderhistory");
//   };

//   const handleAccountBlockedClose = () => {
//     setShowAccountBlockedModal(false);
//     // Clear token and redirect to login since the user is blocked
//     localStorage.removeItem("token");
//     navigate("/profile/orderhistory");
//   };

//   const handleTaskComplete = () => {
//     setShowTransactionModal(true);
//   };

//   const handleTransactionModalClose = () => {
//     setShowTransactionModal(false);
//   };

//   const handleTransactionSuccess = () => {
//     setShowTransactionModal(false);
//     navigate("/profile/orderhistory");
//   };

//   const handleRebook = () => {
//     // pick the right path based on order.service_name
//     const path =
//       SERVICE_ROUTES[order.service_name] || "/services/home-cleaning";
//     navigate(path, {
//       state: {
//         fromRebook: true,
//         previousOrder: order,
//       },
//     });
//   };

//    // *** NEW: Helper function to determine if a value should be displayed ***
//   const hasValue = (value) => {
//     if (typeof value === "number") return value > 0; // Show only for 1, 2, 3, etc.
//     if (typeof value === "string") return value.toLowerCase() === "yes"; // Show only for "Yes"
//     return !!value; // Fallback for other truthy values
//   };

//   // *** NEW: Helper function to format values with units ***
//   const formatValue = (value, isBoolean = false) => {
//     if (isBoolean) return value ? "Yes" : "No";
//     if (typeof value === "number") {
//       return value === 1 ? "1 unit" : `${value} units`;
//     }
//     return value;
//   };

//   // *** NEW: Function to render service details based on service type ***
//   const renderServiceDetails = () => {
//     const details = [];

//     switch (order.service_name) {
//       case "Home Cleaning":
//         [
//           { label: "Bedroom", value: order.bed },
//           { label: "Bathroom", value: order.bath },
//           { label: "Drawing-Dining", value: order.dra_din },
//           { label: "Kitchen", value: order.kitchen },
//           { label: "Balcony Cleaning", value: order.balcony },
//           { label: "Window & Grill Cleaning", value: order.window_grill },
//           { label: "Furniture Cleaning", value: order.furniture_cleaning },
//           { label: "Cloths", value: order.cloth },
//           { label: "Dishes", value: order.dish },
//         ].forEach((item) => {
//           if (hasValue(item.value)) {
//             details.push(`${item.label}: ${formatValue(item.value)}`);
//           }
//         });
//         break;

//       case "Electrician":
//         [
//           { label: "Fan Install/Uninstall", value: order.Fan_in_un },
//           { label: "Light Install/Uninstall", value: order.Light_in_un },
//           { label: "Fan Repair", value: order.Fan_repair },
//           { label: "Light Repair", value: order.Light_repair },
//           { label: "Switch Repair", value: order.Switch_repair },
//           { label: "MCB Service", value: order.MCB_service },
//           { label: "MDB Service", value: order.MDB_service },
//           { label: "Regulator Install/Uninstall", value: order.Fan_regulator_in_un },
//           { label: "Regulator Repair", value: order.Fan_regulator_repair },
//           { label: "Socket Install/Uninstall", value: order.Socket_in_un },
//           { label: "Socket Repair", value: order.Socket_repair },
//           { label: "Breaker Repair", value: order.Circuit_breaker_repair },
//           { label: "New Wiring Point", value: order.New_wiring_point },
//           { label: "Full Wiring", value: order.Full_wiring, isBoolean: true },
//           { label: "Electrical Checkup", value: order.Electrical_checkup, isBoolean: true },
//         ].forEach((item) => {
//           if (hasValue(item.value)) {
//             details.push(`${item.label}: ${formatValue(item.value, item.isBoolean)}`);
//           }
//         });
//         break;

//       case "Plumber":
//         [
//           { label: "Toilet Install", value: order.Toilet_in },
//           { label: "Faucet Install", value: order.Faucet_in },
//           { label: "Sink Install", value: order.Sink_in },
//           { label: "Dishwasher Install", value: order.Dishwasher_in },
//           { label: "Leak Repair", value: order.Leak_repair },
//           { label: "Faucet Repair", value: order.Faucet_repair },
//           { label: "Toilet Repair", value: order.Toilet_repair },
//           { label: "Shower Repair", value: order.Shower_repair },
//           { label: "Drain Cleaning", value: order.Drain_cleaning },
//           { label: "Pipe Cleaning", value: order.pipe_cleaning },
//           { label: "Tank Cleaning", value: order.tank_cleaning },
//           { label: "Issue Checkup", value: order.issue_checkup, isBoolean: true },
//         ].forEach((item) => {
//           if (hasValue(item.value)) {
//             details.push(`${item.label}: ${formatValue(item.value, item.isBoolean)}`);
//           }
//         });
//         break;

//       default:
//         return <div>Service details unavailable</div>;
//     }

//     return details.length > 0 ? (
//       details.map((detail, index) => (
//         <div key={index} className="service-detail-item">
//           {detail}
//         </div>
//       ))
//     ) : (
//       <div>No service details available</div>
//     );
//   };

//   const userDetailsCard = (
//     <div className="OrderDetailsView-card">
//       <div className="OrderDetailsView-cardHeader">User Details</div>
//       <p>
//         <strong>Name:</strong>{" "}
//         {order.User
//           ? `${order.User.FirstName} ${order.User.LastName}`
//           : "Unknown"}
//       </p>
//       <p>
//         <strong>Mobile:</strong>{" "}
//         {order.User ? `0${order.User.mobile}` : "Unknown"}
//       </p>
//       <p>
//         <strong>City:</strong> {order.usercity || order.City}
//       </p>
//       <p>
//         <strong>Address:</strong> {order.useraddress || order.Address}
//       </p>
//     </div>
//   );

//   const servitorDetailsCard =
//     (order.status === "Accepted" ||
//       order.status === "In-Progress" ||
//       order.status === "Completed") &&
//     order.Servitor ? (
//       <div className="OrderDetails-servitor-card">
//         <h2 className="OrderDetails-servitor-header">Servitor Details</h2>
//         <hr className="OrderDetails-divider" />
//         <div className="OrderDetails-servitor-top-row">
//           <div className="OrderDetails-servitor-left-half">
//             <img
//               src={
//                 order.Servitor.image
//                   ? `${URL}/uploads/${order.Servitor.image}`
//                   : "https://via.placeholder.com/150"
//               }
//               alt="Servitor"
//               className="OrderDetails-servitor-photo"
//             />
//             <div className="OrderDetails-servitor-info-block">
//               <h4 className="OrderDetails-servitor-name">
//                 {order.Servitor.FirstName} {order.Servitor.LastName}
//               </h4>
//               <div className="OrderDetails-servitor-rating">
//                 <i className="fas fa-star OrderDetails-star-filled"></i>
//                 <span className="OrderDetails-rating-score">
//                   {order.Servitor.rating || 0}
//                 </span>
//                 <span className="OrderDetails-rating-count">
//                   ({order.Servitor.orders_completed || 0} Orders completed)
//                 </span>
//               </div>
//             </div>
//           </div>
//           <div className="OrderDetails-servitor-right-half">
//             <div className="OrderDetails-contact-line">
//               <i className="fas fa-phone-alt OrderDetails-contact-icon"></i>
//               <span>
//                 {order.Servitor.mobile ? `0${order.Servitor.mobile}` : "N/A"}
//               </span>
//             </div>
//             <div className="OrderDetails-contact-line">
//               <i className="fas fa-envelope OrderDetails-contact-icon"></i>
//               <span>{order.Servitor.email || "No email"}</span>
//             </div>
//             <div className="OrderDetails-contact-line">
//               <i className="fas fa-map-marker-alt OrderDetails-contact-icon"></i>
//               <span>{order.Servitor.city || "No city"}</span>
//             </div>
//           </div>
//         </div>
//         <div className="OrderDetails-servitor-bottom-row">
//           <div className="OrderDetails-servitor-info-box">
//             <div className="OrderDetails-info-label">NID</div>
//             <div className="OrderDetails-info-value">
//               {order.Servitor.NID || "N/A"}
//             </div>
//           </div>
//           <div className="OrderDetails-servitor-info-box">
//             <div className="OrderDetails-info-label">Experience</div>
//             <div className="OrderDetails-info-value">
//               {order.Servitor.experience} years
//             </div>
//           </div>
//           <div className="OrderDetails-servitor-info-box">
//             <div className="OrderDetails-info-label">Service</div>
//             <div className="OrderDetails-info-value">
//               {order.Servitor.service || "N/A"}
//             </div>
//           </div>
//         </div>
//       </div>
//     ) : (
//       <div className="OrderDetails-servitor-card">
//         <h2 className="OrderDetails-servitor-header">Servitor Details</h2>
//         <p style={{ fontStyle: "italic", color: "#888" }}>
//           Servitor has not accepted the order yet.
//         </p>
//       </div>
//     );

//   return (
//     <div className="OrderDetailsView-container">
//       <h4 className="OrderDetailsView-mainTitle">HelpNao - Order Details</h4>
//       <hr />
//       <div className="OrderDetailsView-invoiceHeader">
//         <div className="invoice-left">
//           <p className="OrderDetailsView-invoiceText">
//             <strong>Placed Order Date:</strong>{" "}
//             {new Date(order.created_at).toLocaleDateString()}
//           </p>
//           <p className="OrderDetailsView-invoiceText">
//             <strong>Service Delivered Date:</strong>{" "}
//             {order.date ? new Date(order.date).toLocaleDateString() : "TBD"}
//           </p>
//           <p className="OrderDetailsView-invoiceText">
//             <strong>Service Delivered Time:</strong> {order.time}
//           </p>
//           <p className="OrderDetailsView-invoiceText">
//             <strong>Order Status:</strong> {order.status}
//           </p>
//         </div>
//         <div className="invoice-right">
//           <p className="OrderDetailsView-invoiceText">
//             <strong>Invoice Order#:</strong> {order.order_number}
//           </p>
//         </div>
//       </div>

//       {order.status === "Completed" && (
//         <div className="OrderDetailsView-completedBanner">
//           <h3>This order is successfully completed.</h3>
//           <p>Stay with HelpNao</p>
//         </div>
//       )}

//       <div className="OrderDetailsView-flexWrap">
//         {servitorDetailsCard}
//         {userDetailsCard}
//       </div>

//       <div className="OrderDetailsView-invoiceDetails">
//         <table className="OrderDetailsView-table">
//           <thead>
//             <tr>
//               <th>Service</th>
//               <th>Details</th>
//               <th>Amount</th>
//             </tr>
//           </thead>
//           <tbody>
//             <tr>
//               <td>
//                 {order.Service
//                   ? order.Service.services_name
//                   : order.service_name || "Unknown"}
//               </td>
//               <td>
//                 {renderServiceDetails()}
//               </td>
//               <td>{order.price} tk</td>
//             </tr>
//           </tbody>
//         </table>
//       </div>

//       {order.status === "Accepted" && order.verification_pin && (
//         <div className="OrderDetailsView-pinCard">
//           <h3>Verification PIN</h3>
//           <p>
//             This is the PIN provided when the servitor arrived for verification.
//             Please note it down for your records.
//           </p>
//           <div className="pin-display">{order.verification_pin}</div>
//         </div>
//       )}

//       <div className="OrderDetailsView-buttonRow">
//         <button
//           className="OrderDetailsView-backBtn"
//           onClick={() => navigate("/profile/orderhistory")}
//         >
//           ← Back
//         </button>
//         <div className="OrderDetailsView-actionGroup">
//           {(order.status === "pending" ||
//             order.status === "Accepted" ||
//             order.status === "In-Progress") && (
//             <button
//               className="OrderDetailsView-cancelBtn"
//               onClick={handleCancelClick}
//             >
//               Cancel Order
//             </button>
//           )}
//           {order.status === "Completed" && (
//             <>
//               <button
//                 className="OrderDetailsView-receiptBtn"
//                 // onClick={() => ReceiptGenerator({ order })}
//                 onClick={() => setShowReceipt(true)}
//               >
//                 <FaDownload className="OrderDetailsView-receiptIcon" />
//                 Receipt
//               </button>

//               <button
//                 className="OrderDetailsView-rebookBtn"
//                 onClick={handleRebook}
//               >
//                 <FaRedo className="OrderDetailsView-rebookIcon" />
//                 Rebook
//               </button>
//             </>
//           )}
//           {order.status === "In-Progress" && (
//             <button
//               className="OrderDetailsView-taskCompleteBtn"
//               onClick={handleTaskComplete}
//             >
//               Task Complete
//             </button>
//           )}
//         </div>
//       </div>

//       {/* Cancel Confirm Modal */}
//       <Modal show={showCancelConfirm} onHide={handleCancelNo} centered>
//         <Modal.Header closeButton>
//           <Modal.Title>Confirm Cancellation</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <p>Are you sure you want to cancel this order?</p>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={handleCancelNo}>
//             No
//           </Button>
//           <Button variant="danger" onClick={handleCancelConfirmYes}>
//             Yes, Cancel Order
//           </Button>
//         </Modal.Footer>
//       </Modal>
//       <Modal show={showCancelFeedback} onHide={handleFeedbackCancel} centered>
//         <Modal.Header closeButton>
//           <Modal.Title>Cancellation Feedback</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <p>Please let us know why you are canceling your order:</p>
//           <Form>
//             <Form.Check
//               type="radio"
//               label="Service is taking too long"
//               name="cancellationReason"
//               value="Service is taking too long"
//               checked={cancellationReason === "Service is taking too long"}
//               onChange={(e) => setCancellationReason(e.target.value)}
//             />
//             <Form.Check
//               type="radio"
//               label="Found another provider"
//               name="cancellationReason"
//               value="Found another provider"
//               checked={cancellationReason === "Found another provider"}
//               onChange={(e) => setCancellationReason(e.target.value)}
//             />
//             <Form.Check
//               type="radio"
//               label="No longer need the service"
//               name="cancellationReason"
//               value="No longer need the service"
//               checked={cancellationReason === "No longer need the service"}
//               onChange={(e) => setCancellationReason(e.target.value)}
//             />
//             <Form.Check
//               type="radio"
//               label="Other"
//               name="cancellationReason"
//               value="Other"
//               checked={cancellationReason === "Other"}
//               onChange={(e) => setCancellationReason(e.target.value)}
//             />
//           </Form>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={handleFeedbackCancel}>
//             Cancel
//           </Button>
//           <Button variant="primary" onClick={handleFeedbackSubmit}>
//             Submit
//           </Button>
//         </Modal.Footer>
//       </Modal>
//       <Modal show={showCancelSuccess} onHide={handleSuccessOk} centered>
//         <Modal.Header closeButton>
//           <Modal.Title>Order Cancelled</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <p>Your order has been cancelled successfully.</p>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="primary" onClick={handleSuccessOk}>
//             OK
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Added: Modal for account blocked */}
//       <Modal
//         show={showAccountBlockedModal}
//         onHide={handleAccountBlockedClose}
//         centered
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>Account Blocked</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <p>{blockedMessage}</p>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="primary" onClick={handleAccountBlockedClose}>
//             OK
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {showTransactionModal && (
//         <TransactionModal
//           order={order}
//           onClose={handleTransactionModalClose}
//           onSuccess={handleTransactionSuccess}
//         />
//       )}

//       {showReceipt && (
//         <ReceiptGenerator
//           order={order}
//           onFinish={() => setShowReceipt(false)}
//         />
//       )}
//     </div>
//   );
// };

// export default OrderDetailsView;

// ***** All checked upper code is okay (24-6-25) ***** //

// ***** Add Translate to EN BN with update (24-6-25) ***** //

// import React, { useState, useEffect } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import { FaRedo, FaDownload, FaCheckSquare, FaLock, FaCopy, FaCheck } from "react-icons/fa";
// import { jwtDecode } from "jwt-decode";
// import { URL } from "../../../config";
// import { Modal, Button, Form } from "react-bootstrap";
// import { useTranslation } from "react-i18next";
// // import "./userprofile.css";
// import TransactionModal from "./TransactionModal";
// import ReceiptGenerator from "./ReceiptGenerator";
// import "./OrderDetailsView.css";
// import OrderTimeline from "../Modal/OrderTimeline";
// import { serviceFields } from "../../Services/serviceFields";

// const OrderDetailsView = () => {
//   const { t } = useTranslation();

//   const { orderId } = useParams(); // orderId is the order number, e.g. "PS-1009"
//   const navigate = useNavigate();

//   const SERVICE_ROUTES = {
//     "Home Cleaning": "/services/home-cleaning",
//     Electrician: "/services/electrician",
//     Plumber: "/services/plumber",
//     "Gas Chula": "/services/gas-chula",
//     "AC Service": "/services/ac-service",
//     Filter: "/services/filter",
//     "Tutor Service": "/services/tutor-service",
//   };

//   const [order, setOrder] = useState(null);
//   const [error, setError] = useState(null);

//   // Cancellation and transaction states remain unchanged
//   const [showCancelConfirm, setShowCancelConfirm] = useState(false);
//   const [showCancelFeedback, setShowCancelFeedback] = useState(false);
//   const [showCancelSuccess, setShowCancelSuccess] = useState(false);
//   const [cancellationReason, setCancellationReason] = useState("");
//   const [showTransactionModal, setShowTransactionModal] = useState(false);
//   const [copied, setCopied] = useState(false);

//   const [showAccountBlockedModal, setShowAccountBlockedModal] = useState(false);
//   const [blockedMessage, setBlockedMessage] = useState("");

//   const [showReceipt, setShowReceipt] = useState(false);

//   useEffect(() => {
//     const fetchOrderDetails = async () => {
//       try {
//         // Get the logged-in user's id from token
//         const token = localStorage.getItem("token");
//         const decodedToken = jwtDecode(token);
//         // Remove "user-" prefix if it exists
//         const userId = decodedToken.Id.startsWith("user-")
//           ? decodedToken.Id.split("user-")[1]
//           : decodedToken.Id;

//         // Fetch orders for the user filtered by orderNumber
//         const response = await fetch(
//           `${URL}/user/${userId}/orders?orderNumber=${orderId}`
//         );
//         if (response.ok) {
//           const orderData = await response.json();
//           if (orderData && orderData.length > 0) {
//             // Use the first (and only) order that matches the order number
//             setOrder(orderData[0]);
//           } else {
//             // setError("No order found with that order number.");
//             setError(t("orderDetailsView.errors.noOrderFound"));
//           }
//         } else {
//           // setError("Failed to fetch order details");
//           setError(t("orderDetailsView.errors.fetchFailed"));
//         }
//       } catch (err) {
//         console.error("Error fetching order details:", err);
//         // setError("Error fetching order details");
//         setError(t("orderDetailsView.errors.fetchError"));
//       }
//     };

//     fetchOrderDetails();
//   }, [orderId, t]);

//   if (error) return <p>{error}</p>;
//   if (!order) return <p>
//     {/* Loading order details... */}
//     {t("orderDetailsView.errors.fetchError")}
//     </p>;

//   // Cancellation function remains unchanged
//   const performCancelOrder = async (reason) => {
//     try {
//       const endpoint = `${URL}/cancelOrder/${order.Id}`;
//       const payload = {
//         serviceType: order.service_name,
//         cancellation_feedback: reason,
//       };
//       const response = await fetch(endpoint, {
//         method: "PATCH",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(payload),
//       });
//       if (response.ok) {
//         return true;
//       } else {
//         const text = await response.text();
//         let errorData;
//         try {
//           errorData = text ? JSON.parse(text) : { message: text };
//         } catch (e) {
//           errorData = { message: text };
//         }
//         console.error("Failed to cancel order:", errorData);

//         // Updated: Avoid console error for account blocked case
//         if (errorData.errorType === "account_blocked") {
//           // setBlockedMessage(
//           //   `Your account has been blocked due to excessive cancellations (${errorData.penaltyCount} times). Total penalty: ${errorData.totalPenalty} taka. Please contact support.`
//           // );
//           setBlockedMessage(errorData.message);
//           setShowAccountBlockedModal(true);
//           // Updated: Close cancellation feedback modal
//           setShowCancelFeedback(false);
//           return false;
//         }

//         // alert("Failed to cancel order.");
//         alert(t("orderDetailsView.errors.cancelFailed"));
//         return false;
//       }
//     } catch (err) {
//       console.error("Error cancelling order:", err);
//       // alert("Error cancelling order.");
//       alert(t("orderDetailsView.errors.cancelError"));
//       return false;
//     }
//   };

//   const handleCancelClick = () => setShowCancelConfirm(true);
//   const handleCancelNo = () => setShowCancelConfirm(false);
//   const handleCancelConfirmYes = () => {
//     setShowCancelConfirm(false);
//     setShowCancelFeedback(true);
//   };
//   const handleFeedbackSubmit = async () => {
//     if (!cancellationReason) {
//       // alert("Please select a reason for cancellation.");
//       alert(t("orderDetailsView.modals.cancelFeedback.error"));
//       return;
//     }
//     const success = await performCancelOrder(cancellationReason);
//     if (success) {
//       setShowCancelFeedback(false);
//       setShowCancelSuccess(true);
//     }
//   };
//   const handleFeedbackCancel = () => setShowCancelFeedback(false);
//   const handleSuccessOk = () => {
//     setShowCancelSuccess(false);
//     navigate("/profile/orderhistory");
//   };

//   const handleAccountBlockedClose = () => {
//     setShowAccountBlockedModal(false);
//     // Clear token and redirect to login since the user is blocked
//     localStorage.removeItem("token");
//     navigate("/profile/orderhistory");
//   };

//   const handleTaskComplete = () => {
//     setShowTransactionModal(true);
//   };

//   const handleTransactionModalClose = () => {
//     setShowTransactionModal(false);
//   };

//   const handleTransactionSuccess = () => {
//     setShowTransactionModal(false);
//     navigate("/profile/orderhistory");
//   };

//   const handleRebook = () => {
//     // pick the right path based on order.service_name
//     const path =
//       SERVICE_ROUTES[order.service_name] || "/services/home-cleaning";
//     navigate(path, {
//       state: {
//         fromRebook: true,
//         previousOrder: order,
//       },
//     });
//   };

//   const handleCopyPin = () => {
//   navigator.clipboard.writeText(order.verification_pin);
//   setCopied(true);
//   setTimeout(() => setCopied(false), 2000);
// };

//    // *** NEW: Helper function to determine if a value should be displayed ***
//   // const hasValue = (value) => {
//   //   if (typeof value === "number") return value > 0; // Show only for 1, 2, 3, etc.
//   //   if (typeof value === "string") return value.toLowerCase() === "yes"; // Show only for "Yes"
//   //   return !!value; // Fallback for other truthy values
//   // };

//   // *** NEW: Helper function to format values with units ***
//   // const formatValue = (value, isBoolean = false) => {
//   //   if (isBoolean) return value ? "Yes" : "No";
//   //   if (typeof value === "number") {
//   //     return value === 1 ? "1 unit" : `${value} units`;
//   //   }
//   //   return value;
//   // };

//   const formatValue = (value, isBoolean = false) => {
//     if (isBoolean) return value ? t("orderDetailsView.serviceDetails.yes") : t("orderDetailsView.serviceDetails.no");
//     if (typeof value === "number") {
//       return value === 1 ? `1 ${t("orderDetailsView.serviceDetails.unit")}` : `${value} ${t("orderDetailsView.serviceDetails.units")}`;
//     }
//     return value;
//   };

//   const renderServiceDetails = () => {
//   // 1) pick the right field list (or empty)
//   const fields = serviceFields[order.service_name] || [];

//   // 2) map→filter→format into { label, value } pairs
//   const visible = fields
//     .map(({ prop, labelKey, type }) => {
//       const raw = order[prop];
//       // boolean only if true
//       if (type === "boolean") return raw ? { label: t(labelKey), value: "Yes" } : null;
//       // number skip zero
//       if (type === "number" && Number(raw) === 0) return null;
//       // text skip empty
//       // if (type === "text" && !raw) return null;
//       // return { label: t(labelKey), value: raw };
//        if (type === "text" && !raw) return null;
//         return {
//           label: t(labelKey),
//           value: type === "number" ? formatValue(raw) : raw
//         };
//     })
//     .filter(Boolean);

//   // 3) render each on its own line
//   if (visible.length === 0) {
//     return <div>{t("orderDetailsView.serviceDetails.noDetails")}</div>;
//   }

//   return visible.map((f, i) => (
//     <div key={i} className="service-detail-item">
//       {f.label}: {f.value}
//     </div>
//   ));
// };

//   const userDetailsCard = (
//     <div className="OrderDetailsView-card">
//       <div className="OrderDetailsView-cardHeader">User Details</div>
//       {/* <p>
//         <strong>Name:</strong>{" "}
//         {order.User
//           ? `${order.User.FirstName} ${order.User.LastName}`
//           : "Unknown"}
//       </p> */}
//       <p>
//         <strong>{t("orderDetailsView.userDetails.name")}:</strong>{" "}
//         {order.User
//           ? `${order.User.FirstName} ${order.User.LastName}`
//           : t("orderDetailsView.userDetails.unknown")}
//       </p>
//       {/* <p>
//         <strong>Mobile:</strong>{" "}
//         {order.User ? `0${order.User.mobile}` : "Unknown"}
//       </p> */}
//       <p>
//         <strong>{t("orderDetailsView.userDetails.mobile")}:</strong>{" "}
//         {order.User ? `0${order.User.mobile}` : t("orderDetailsView.userDetails.unknown")}
//       </p>

//       <p>
//         {/* <strong>City:</strong> {order.usercity || order.City} */}
//         <strong>{t("orderDetailsView.userDetails.city")}:</strong> {order.usercity || order.City}
//       </p>
//       <p>
//         {/* <strong>Address:</strong> {order.useraddress || order.Address} */}
//         <strong>{t("orderDetailsView.userDetails.address")}:</strong> {order.useraddress || order.Address}
//       </p>
//     </div>
//   );

//   const servitorDetailsCard =
//     (order.status === "Accepted" ||
//       order.status === "In-Progress" ||
//       order.status === "Completed") &&
//     order.Servitor ? (
//       <div className="OrderDetails-servitor-card">
//         {/* <h2 className="OrderDetails-servitor-header">Servitor Details</h2> */}
//         <h2 className="OrderDetails-servitor-header">{t("orderDetailsView.servitorDetails.title")}</h2>
//         {/* <hr className="OrderDetails-divider" /> */}
//         <div className="OrderDetails-servitor-top-row">
//           <div className="OrderDetails-servitor-left-half">
//             <img
//               src={
//                 order.Servitor.image
//                   ? `${URL}/uploads/${order.Servitor.image}`
//                   : "https://via.placeholder.com/150"
//               }
//               alt="Servitor"
//               className="OrderDetails-servitor-photo"
//             />
//             <div className="OrderDetails-servitor-info-block">
//               <h4 className="OrderDetails-servitor-name">
//                 {order.Servitor.FirstName} {order.Servitor.LastName}
//               </h4>
//               <div className="OrderDetails-servitor-rating">
//                 <i className="fas fa-star OrderDetails-star-filled"></i>
//                 <span className="OrderDetails-rating-score">
//                   {order.Servitor.rating || 0}
//                 </span>
//                 <span className="OrderDetails-rating-count">
//                   ({order.Servitor.orders_completed || 0} Orders completed)
//                 </span>

//                 {/* <span className="OrderDetails-rating-score">
//                   {t("orderDetailsView.servitorDetails.rating", {
//                     rating: order.Servitor.rating || 0,
//                     count: order.Servitor.orders_completed || 0
//                   })}
//                 </span> */}
//               </div>
//             </div>
//           </div>
//           <div className="OrderDetails-servitor-right-half">
//             <div className="OrderDetails-contact-line">
//               <i className="fas fa-phone-alt OrderDetails-contact-icon"></i>
//               <span>
//                 {/* {order.Servitor.mobile ? `0${order.Servitor.mobile}` : "N/A"} */}
//                 {order.Servitor.mobile ? `0${order.Servitor.mobile}` : t("orderDetailsView.servitorDetails.na")}
//               </span>
//             </div>
//             <div className="OrderDetails-contact-line">
//               <i className="fas fa-envelope OrderDetails-contact-icon"></i>
//               {/* <span>{order.Servitor.email || "No email"}</span> */}
//               <span>{order.Servitor.email || t("orderDetailsView.servitorDetails.noEmail")}</span>
//             </div>
//             <div className="OrderDetails-contact-line">
//               <i className="fas fa-map-marker-alt OrderDetails-contact-icon"></i>
//               {/* <span>{order.Servitor.city || "No city"}</span> */}
//               <span>{order.Servitor.city || t("orderDetailsView.servitorDetails.noCity")}</span>
//             </div>
//           </div>
//         </div>
//         <div className="OrderDetails-servitor-bottom-row">
//           <div className="OrderDetails-servitor-info-box">
//             {/* <div className="OrderDetails-info-label">NID</div> */}
//             <div className="OrderDetails-info-label">{t("orderDetailsView.servitorDetails.nid")}</div>
//             <div className="OrderDetails-info-value">
//               {/* {order.Servitor.NID || "N/A"} */}
//               {order.Servitor.NID || t("orderDetailsView.servitorDetails.na")}
//             </div>
//           </div>
//           <div className="OrderDetails-servitor-info-box">
//             {/* <div className="OrderDetails-info-label">Experience</div> */}
//             <div className="OrderDetails-info-label">{t("orderDetailsView.servitorDetails.experience")}</div>
//             <div className="OrderDetails-info-value">
//               {/* {order.Servitor.experience} years */}
//               {t("orderDetailsView.servitorDetails.years", { count: order.Servitor.experience })}
//             </div>
//           </div>
//           <div className="OrderDetails-servitor-info-box">
//             {/* <div className="OrderDetails-info-label">Service</div> */}
//             <div className="OrderDetails-info-label">{t("orderDetailsView.servitorDetails.service")}</div>
//             <div className="OrderDetails-info-value">
//               {/* {order.Servitor.service || "N/A"} */}
//               {order.Servitor.service || t("orderDetailsView.servitorDetails.na")}
//             </div>
//           </div>
//         </div>
//       </div>
//     ) : (
//       <div className="OrderDetails-servitor-card">
//         {/* <h2 className="OrderDetails-servitor-header">Servitor Details</h2> */}
//         <h2 className="OrderDetails-servitor-header">{t("orderDetailsView.servitorDetails.title")}</h2>
//         <p style={{ fontStyle: "italic", color: "#888" }}>
//           {/* Servitor has not accepted the order yet. */}
//           {t("orderDetailsView.servitorDetails.notAccepted")}
//         </p>
//       </div>
//     );

//   return (
//     <div className="OrderDetailsView-container">
//       {/* <h4 className="OrderDetailsView-mainTitle">HelpNao - Order Details</h4> */}
//       <h4 className="OrderDetailsView-mainTitle">
//         {t("orderDetailsView.mainTitle")}
//       </h4>
//       <hr />
//       <div className="OrderDetailsView-invoiceHeader">
//         <div className="invoice-left">
//           <p className="OrderDetailsView-invoiceText">
//             {/* <strong>Placed Order Date:</strong>{" "} */}
//             <strong>
//               {t("orderDetailsView.invoice.placedOrderDate")}:
//             </strong>{" "}
//             {new Date(order.created_at).toLocaleDateString()}
//           </p>
//           <p className="OrderDetailsView-invoiceText">
//             {/* <strong>Service Delivered Date:</strong>{" "} */}
//             <strong>
//               {t("orderDetailsView.invoice.serviceDeliveredDate")}:
//             </strong>{" "}
//             {order.date ? new Date(order.date).toLocaleDateString() : "TBD"}
//           </p>
//           <p className="OrderDetailsView-invoiceText">
//             {/* <strong>Service Delivered Time:</strong> {order.time} */}
//             <strong>
//               {t("orderDetailsView.invoice.serviceDeliveredTime")}:
//             </strong>{" "}
//             {order.time}
//           </p>
//           <p className="OrderDetailsView-invoiceText">
//             {/* <strong>Order Status:</strong> {order.status} */}
//             <strong>{t("orderDetailsView.invoice.orderStatus")}:</strong>{" "}
//             {order.status}
//           </p>
//         </div>
//         <div className="invoice-right">
//           <p className="OrderDetailsView-invoiceText">
//             {/* <strong>Invoice Order#:</strong> {order.order_number} */}
//             <strong>{t("orderDetailsView.invoice.invoiceOrder")}:</strong>{" "}
//             {order.order_number}
//           </p>
//         </div>
//       </div>

//       <OrderTimeline order={order} />

//       {order.status === "Completed" && (
//         <div className="OrderDetailsView-completedBanner">
//           {/* <h3>This order is successfully completed.</h3>
//           <p>Stay with HelpNao</p> */}
//           <h3>{t("orderDetailsView.completedBanner.title")}</h3>
//           <p>{t("orderDetailsView.completedBanner.subtitle")}</p>
//         </div>
//       )}

//       <div className="OrderDetailsView-flexWrap">
//         {servitorDetailsCard}
//         {userDetailsCard}
//       </div>

//       <div className="OrderDetailsView-invoiceDetails">
//         <table className="OrderDetailsView-table">
//           <thead>
//             <tr>
//               {/* <th>Service</th>
//               <th>Details</th>
//               <th>Amount</th> */}

//               <th>{t("orderDetailsView.serviceDetails.service")}</th>
//               <th>{t("orderDetailsView.serviceDetails.details")}</th>
//               <th>{t("orderDetailsView.serviceDetails.amount")}</th>
//             </tr>
//           </thead>
//           <tbody>
//             <tr>
//               {/* <td>
//                 {order.Service
//                   ? order.Service.services_name
//                   : order.service_name || "Unknown"}
//               </td> */}
//               <td>
//                 {order.Service
//                   ? order.Service.services_name
//                   : order.service_name ||
//                     t("orderDetailsView.userDetails.unknown")}
//               </td>

//               <td>{renderServiceDetails()}</td>
//               <td>{order.price} tk</td>
//             </tr>
//           </tbody>
//         </table>
//       </div>

//       {/* Reamrks */}
//       {order.remarks && (
//         <div className="OrderDetailsView-remarksRow">
//           <FaCheckSquare className="OrderDetailsView-remarksIcon" />
//           <strong>{t("orderDetailsView.remarks.title")}:</strong>{" "}
//           <span className="OrderDetailsView-remarksText">{order.remarks}</span>
//         </div>
//       )}

//       {order.status === "Accepted" && order.verification_pin && (
//         <div className="OrderDetailsView-pinCard">
//           {/* <h3>Verification PIN</h3>
//           <p>
//             This is the PIN provided when the servitor arrived for verification.
//             Please note it down for your records.
//           </p> */}
//           {/* <h3>{t("orderDetailsView.verificationPin.title")}</h3>
//           <p>{t("orderDetailsView.verificationPin.description")}</p> */}

//           {/* <div className="pin-display">{order.verification_pin}</div> */}

//           {/* <div className="pin-display">
//             {order.verification_pin}
//             <button
//               className="pin-copy-btn"
//               onClick={() => {
//                 navigator.clipboard.writeText(order.verification_pin);
//                 setCopied(true);
//                 setTimeout(() => setCopied(false), 2000);
//               }}
//             >
//               <FaClipboard />
//             </button>
//           </div>
//           {copied && <div className="pin-copied-feedback">Copied!</div>} */}

//           <div className="OrderDetailsView-pinCardHeader">
//             <FaLock className="OrderDetailsView-pinIcon" />
//             <h3>{t("orderDetailsView.verificationPin.title")}</h3>
//           </div>
//           <p>{t("orderDetailsView.verificationPin.description")}</p>
//           <div className="OrderDetailsView-pinContainer">
//             <div className="OrderDetailsView-pinDisplay">{order.verification_pin}</div>
//             <button
//               className={`OrderDetailsView-copyBtn ${copied ? "copied" : ""}`}
//               onClick={handleCopyPin}
//             >
//               {copied ? (
//                 <>
//                   <FaCheck className="OrderDetailsView-copyIcon" />
//                   {t("orderDetailsView.verificationPin.copied")}
//                 </>
//               ) : (
//                 <>
//                   <FaCopy className="OrderDetailsView-copyIcon" />
//                   {t("orderDetailsView.verificationPin.copy")}
//                 </>
//               )}
//             </button>
//           </div>
//         </div>
//       )}

//       <div className="OrderDetailsView-buttonRow">
//         <button
//           className="OrderDetailsView-backBtn"
//           onClick={() => navigate("/profile/orderhistory")}
//         >
//           {/* ← Back */}← {t("orderDetailsView.buttons.back")}
//         </button>
//         <div className="OrderDetailsView-actionGroup">
//           {(order.status === "pending" ||
//             order.status === "Accepted" ||
//             order.status === "In-Progress") && (
//             <button
//               className="OrderDetailsView-cancelBtn"
//               onClick={handleCancelClick}
//             >
//               {/* Cancel Order */}
//               {t("orderDetailsView.buttons.cancelOrder")}
//             </button>
//           )}
//           {order.status === "Completed" && (
//             <>
//               <button
//                 className="OrderDetailsView-receiptBtn"
//                 // onClick={() => ReceiptGenerator({ order })}
//                 onClick={() => setShowReceipt(true)}
//               >
//                 <FaDownload className="OrderDetailsView-receiptIcon" />
//                 {/* Receipt */}
//                 {t("orderDetailsView.buttons.receipt")}
//               </button>

//               <button
//                 className="OrderDetailsView-rebookBtn"
//                 onClick={handleRebook}
//               >
//                 <FaRedo className="OrderDetailsView-rebookIcon" />
//                 {/* Rebook */}
//                 {t("orderDetailsView.buttons.rebook")}
//               </button>
//             </>
//           )}
//           {order.status === "In-Progress" && (
//             <button
//               className="OrderDetailsView-taskCompleteBtn"
//               onClick={handleTaskComplete}
//             >
//               {/* Task Complete */}
//               {t("orderDetailsView.buttons.taskComplete")}
//             </button>
//           )}
//         </div>
//       </div>

//       {/* Cancel Confirm Modal */}
//       <Modal show={showCancelConfirm} onHide={handleCancelNo} centered dialogClassName="OrderDetailsView-cancel-confirm-modal">
//         <Modal.Header closeButton>
//           {/* <Modal.Title>Confirm Cancellation</Modal.Title> */}
//           <Modal.Title>
//             {t("orderDetailsView.modals.cancelConfirm.title")}
//           </Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           {/* <p>Are you sure you want to cancel this order?</p> */}
//           <p>{t("orderDetailsView.modals.cancelConfirm.body")}</p>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={handleCancelNo}>
//             {/* No */}
//             {t("orderDetailsView.modals.cancelConfirm.no")}
//           </Button>
//           <Button variant="danger" onClick={handleCancelConfirmYes}>
//             {/* Yes, Cancel Order */}
//             {t("orderDetailsView.modals.cancelConfirm.yes")}
//           </Button>
//         </Modal.Footer>
//       </Modal>
//       <Modal show={showCancelFeedback} onHide={handleFeedbackCancel} centered dialogClassName="OrderDetailsView-cancel-feedback-modal">
//         <Modal.Header closeButton>
//           {/* <Modal.Title>Cancellation Feedback</Modal.Title> */}
//           <Modal.Title>
//             {t("orderDetailsView.modals.cancelFeedback.title")}
//           </Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           {/* <p>Please let us know why you are canceling your order:</p> */}
//           <p>{t("orderDetailsView.modals.cancelFeedback.body")}</p>
//           {/* <Form>
//             <Form.Check
//               type="radio"
//               label="Service is taking too long"
//               name="cancellationReason"
//               value="Service is taking too long"
//               checked={cancellationReason === "Service is taking too long"}
//               onChange={(e) => setCancellationReason(e.target.value)}
//             />
//             <Form.Check
//               type="radio"
//               label="Found another provider"
//               name="cancellationReason"
//               value="Found another provider"
//               checked={cancellationReason === "Found another provider"}
//               onChange={(e) => setCancellationReason(e.target.value)}
//             />
//             <Form.Check
//               type="radio"
//               label="No longer need the service"
//               name="cancellationReason"
//               value="No longer need the service"
//               checked={cancellationReason === "No longer need the service"}
//               onChange={(e) => setCancellationReason(e.target.value)}
//             />
//             <Form.Check
//               type="radio"
//               label="Other"
//               name="cancellationReason"
//               value="Other"
//               checked={cancellationReason === "Other"}
//               onChange={(e) => setCancellationReason(e.target.value)}
//             />
//           </Form> */}

//           <Form>
//             <Form.Check
//               type="radio"
//               label={t(
//                 "orderDetailsView.modals.cancelFeedback.reasons.tooLong"
//               )}
//               name="cancellationReason"
//               value={t(
//                 "orderDetailsView.modals.cancelFeedback.reasons.tooLong"
//               )}
//               checked={
//                 cancellationReason ===
//                 t("orderDetailsView.modals.cancelFeedback.reasons.tooLong")
//               }
//               onChange={(e) => setCancellationReason(e.target.value)}
//             />
//             <Form.Check
//               type="radio"
//               label={t(
//                 "orderDetailsView.modals.cancelFeedback.reasons.anotherProvider"
//               )}
//               name="cancellationReason"
//               value={t(
//                 "orderDetailsView.modals.cancelFeedback.reasons.anotherProvider"
//               )}
//               checked={
//                 cancellationReason ===
//                 t(
//                   "orderDetailsView.modals.cancelFeedback.reasons.anotherProvider"
//                 )
//               }
//               onChange={(e) => setCancellationReason(e.target.value)}
//             />
//             <Form.Check
//               type="radio"
//               label={t("orderDetailsView.modals.cancelFeedback.reasons.noNeed")}
//               name="cancellationReason"
//               value={t("orderDetailsView.modals.cancelFeedback.reasons.noNeed")}
//               checked={
//                 cancellationReason ===
//                 t("orderDetailsView.modals.cancelFeedback.reasons.noNeed")
//               }
//               onChange={(e) => setCancellationReason(e.target.value)}
//             />
//             <Form.Check
//               type="radio"
//               label={t("orderDetailsView.modals.cancelFeedback.reasons.other")}
//               name="cancellationReason"
//               value={t("orderDetailsView.modals.cancelFeedback.reasons.other")}
//               checked={
//                 cancellationReason ===
//                 t("orderDetailsView.modals.cancelFeedback.reasons.other")
//               }
//               onChange={(e) => setCancellationReason(e.target.value)}
//             />
//           </Form>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={handleFeedbackCancel}>
//             {/* Cancel */}
//             {t("orderDetailsView.modals.cancelFeedback.cancel")}
//           </Button>
//           <Button variant="primary" onClick={handleFeedbackSubmit}>
//             {/* Submit */}
//             {t("orderDetailsView.modals.cancelFeedback.submit")}
//           </Button>
//         </Modal.Footer>
//       </Modal>
//       <Modal show={showCancelSuccess} onHide={handleSuccessOk} centered dialogClassName="OrderDetailsView-cancel-success-modal">
//         <Modal.Header closeButton>
//           {/* <Modal.Title>Order Cancelled</Modal.Title> */}
//           <Modal.Title>
//             {t("orderDetailsView.modals.cancelSuccess.title")}
//           </Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           {/* <p>Your order has been cancelled successfully.</p> */}
//           <p>{t("orderDetailsView.modals.cancelSuccess.body")}</p>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="primary" onClick={handleSuccessOk}>
//             {/* OK */}
//             {t("orderDetailsView.modals.cancelSuccess.ok")}
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Added: Modal for account blocked */}
//       <Modal
//         show={showAccountBlockedModal}
//         onHide={handleAccountBlockedClose}
//         centered
//       >
//         <Modal.Header closeButton>
//           {/* <Modal.Title>Account Blocked</Modal.Title> */}
//           <Modal.Title>
//             {t("orderDetailsView.modals.accountBlocked.title")}
//           </Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <p>{blockedMessage}</p>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="primary" onClick={handleAccountBlockedClose}>
//             {/* OK */}
//             {t("orderDetailsView.modals.accountBlocked.ok")}
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {showTransactionModal && (
//         <TransactionModal
//           order={order}
//           onClose={handleTransactionModalClose}
//           onSuccess={handleTransactionSuccess}
//         />
//       )}

//       {showReceipt && (
//         <ReceiptGenerator
//           order={order}
//           onFinish={() => setShowReceipt(false)}
//         />
//       )}
//     </div>
//   );
// };

// export default OrderDetailsView;

// ********* upper code all is okay (21-8-25) ********* //

// *********** New tutor service processign (21-8-25) ************** //

// import React, { useState, useEffect, useCallback } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import {
//   FaRedo,
//   FaDownload,
//   FaCheckSquare,
//   FaLock,
//   FaCopy,
//   FaCheck,
//   FaEye,
//   FaPhoneAlt,

// } from "react-icons/fa";
// import { jwtDecode } from "jwt-decode";
// import { URL } from "../../../config";
// import { Modal, Button, Form } from "react-bootstrap";
// import { useTranslation } from "react-i18next";
// // import "./userprofile.css";
// import TransactionModal from "./TransactionModal";
// import ReceiptGenerator from "./ReceiptGenerator";
// import "./OrderDetailsView.css";
// import OrderTimeline from "../Modal/OrderTimeline";
// import { serviceFields } from "../../Services/serviceFields";
// import ServitorDocuments from "../Modal/ServitorDocuments";
// import ServiceEditModal from "../Modal/ServiceEditModal";
// import { formatDate, formatDateTime } from "../../dateTimefrontpart";
// import Loader from "../../../Components/LoaderSpin/Loader";

// const OrderDetailsView = () => {
//   const { t } = useTranslation();

//   const { orderId } = useParams(); // orderId is the order number, e.g. "PS-1009"
//   const navigate = useNavigate();

//   const SERVICE_ROUTES = {
//     "Home Cleaning": "/services/home-cleaning",
//     Electrician: "/services/electrician",
//     Plumber: "/services/plumber",
//     "Gas Chula": "/services/gas-chula",
//     "AC Service": "/services/ac-service",
//     Filter: "/services/filter",
//     "Tutor Service": "/services/tutor-service",
//   };

//   const [order, setOrder] = useState(null);
//   const [error, setError] = useState(null);
//   const [loading, setLoading] = useState(false);

//   // Cancellation and transaction states remain unchanged
//   const [showCancelConfirm, setShowCancelConfirm] = useState(false);
//   const [showCancelFeedback, setShowCancelFeedback] = useState(false);
//   const [showCancelSuccess, setShowCancelSuccess] = useState(false);
//   const [cancellationReason, setCancellationReason] = useState("");
//   const [showTransactionModal, setShowTransactionModal] = useState(false);
//   const [copied, setCopied] = useState(false);

//   const [showAccountBlockedModal, setShowAccountBlockedModal] = useState(false);
//   const [blockedMessage, setBlockedMessage] = useState("");

//   const [showReceipt, setShowReceipt] = useState(false);

//   // --- New state for documents modal ---
//   const [showDocumentsModal, setShowDocumentsModal] = useState(false);

//   const [showEditModal, setShowEditModal] = useState(false);


//   // --- Tutor-only helpers ---
//   const isTutor = order?.service_name === "Tutor Service";
//   const canSeePhones = !isTutor || !!order?.user_approved; // phones unlock after approval

//   const normalizeTel = (s) => (s ? String(s).replace(/[^+\d]/g, "") : "");


//   // useEffect(() => {
//   //   const fetchOrderDetails = async () => {
//   //     try {
//   //       // Get the logged-in user's id from token
//   //       const token = localStorage.getItem("token");
//   //       const decodedToken = jwtDecode(token);
//   //       // Remove "user-" prefix if it exists
//   //       const userId = decodedToken.Id.startsWith("user-")
//   //         ? decodedToken.Id.split("user-")[1]
//   //         : decodedToken.Id;

//   //       // Fetch orders for the user filtered by orderNumber
//   //       const response = await fetch(
//   //         `${URL}/user/${userId}/orders?orderNumber=${orderId}`
//   //       );
//   //       if (response.ok) {
//   //         const orderData = await response.json();
//   //         if (orderData && orderData.length > 0) {
//   //           // Use the first (and only) order that matches the order number
//   //           setOrder(orderData[0]);
//   //         } else {
//   //           // setError("No order found with that order number.");
//   //           setError(t("orderDetailsView.errors.noOrderFound"));
//   //         }
//   //       } else {
//   //         // setError("Failed to fetch order details");
//   //         setError(t("orderDetailsView.errors.fetchFailed"));
//   //       }
//   //     } catch (err) {
//   //       console.error("Error fetching order details:", err);
//   //       // setError("Error fetching order details");
//   //       setError(t("orderDetailsView.errors.fetchError"));
//   //     }
//   //   };

//   //   fetchOrderDetails();
//   // }, [orderId, t]);



//   const fetchOrderDetails = useCallback(async () => {
//   try {
//     setLoading(true);
//     const token = localStorage.getItem("token");
//     const decodedToken = jwtDecode(token);
//     const userId = decodedToken.Id.startsWith("user-")
//       ? decodedToken.Id.split("user-")[1]
//       : decodedToken.Id;

//     const response = await fetch(
//       `${URL}/user/${userId}/orders?orderNumber=${orderId}`
//     );
//     if (response.ok) {
//       const orderData = await response.json();
//       if (orderData && orderData.length > 0) {
//         setOrder(orderData[0]);
//       } else {
//         setError(t("orderDetailsView.errors.noOrderFound"));
//       }
//     } else {
//       setError(t("orderDetailsView.errors.fetchFailed"));
//     }
//   } catch (err) {
//     console.error("Error fetching order details:", err);
//     setError(t("orderDetailsView.errors.fetchError"));
//   } finally {
//     setLoading(false);
//   }
// }, [orderId, t]);

// useEffect(() => {
//   fetchOrderDetails();
// }, [fetchOrderDetails]);

//   if (error) return <p>{error}</p>;
//   if (!order || loading)
//     return (
//       <p>
//         {/* Loading order details... */}
//         {/* {t("orderDetailsView.errors.fetchError")} */}
//         <Loader
//           show
//           // brand="HelpNao"
//           // message={t("orderDetailsView.loading", "Loading order details…")}
//         />
//       </p>
//     );

//   // Cancellation function remains unchanged
//   const performCancelOrder = async (reason) => {
//     try {
//       const endpoint = `${URL}/cancelOrder/${order.Id}`;
//       const payload = {
//         serviceType: order.service_name,
//         cancellation_feedback: reason,
//       };
//       const response = await fetch(endpoint, {
//         method: "PATCH",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(payload),
//       });
//       if (response.ok) {
//         return true;
//       } else {
//         const text = await response.text();
//         let errorData;
//         try {
//           errorData = text ? JSON.parse(text) : { message: text };
//         } catch (e) {
//           errorData = { message: text };
//         }
//         console.error("Failed to cancel order:", errorData);

//         // Updated: Avoid console error for account blocked case
//         if (errorData.errorType === "account_blocked") {
//           // setBlockedMessage(
//           //   `Your account has been blocked due to excessive cancellations (${errorData.penaltyCount} times). Total penalty: ${errorData.totalPenalty} taka. Please contact support.`
//           // );
//           setBlockedMessage(errorData.message);
//           setShowAccountBlockedModal(true);
//           // Updated: Close cancellation feedback modal
//           setShowCancelFeedback(false);
//           return false;
//         }

//         // alert("Failed to cancel order.");
//         // alert(t("orderDetailsView.errors.cancelFailed"));
//         return false;
//       }
//     } catch (err) {
//       console.error("Error cancelling order:", err);
//       // alert("Error cancelling order.");
//       // alert(t("orderDetailsView.errors.cancelError"));
//       return false;
//     }
//   };

//   // --- Tutor flow actions ---
//   const callTutorEndpoint = async (path) => {
//     const token = localStorage.getItem("token");
//     const resp = await fetch(`${URL}/tutor/${order.Id}/${path}`, {
//       method: "PATCH",
//       headers: {
//         "Content-Type": "application/json",
//         ...(token ? { Authorization: `Bearer ${token}` } : {}),
//       },
//     });
//     if (!resp.ok) {
//       const txt = await resp.text();
//       throw new Error(txt || "Request failed");
//     }
//     return resp.json();
//   };

//   const handleApproveTutor = async () => {
//     try {
//       const data = await callTutorEndpoint("approve");
//       // server returns { verification_pin }
//       setOrder((prev) => ({
//         ...prev,
//         user_approved: true,
//         approved_at: new Date().toISOString(),
//         verification_pin: data?.verification_pin || prev?.verification_pin,
//       }));
//       // alert(t("tutorFlow.approved") || "Tutor approved. OTP generated.");
//     } catch (e) {
//       console.error(e);
//       // alert(t("tutorFlow.approveFailed") || "Failed to approve tutor.");
//     }
//   };

//   const handleFindAnotherTutor = async () => {
//     try {
//       await callTutorEndpoint("find-another");
//       // Re-open order: go back to pending and clear assignment + pin
//       setOrder((prev) => ({
//         ...prev,
//         status: "pending",
//         servitor_id: null,
//         Servitor: null,
//         verification_pin: null,
//         accepted_at: null,
//       }));
//       // alert(t("tutorFlow.reopened") || "Order reopened for other tutors.");
//     } catch (e) {
//       console.error(e);
//       // alert(t("tutorFlow.reopenFailed") || "Failed to reopen order.");
//     }
//   };

//   // const handleConfirmTutorHired = async () => {
//   //   try {
//   //     await callTutorEndpoint("hired");
//   //     setOrder((prev) => ({
//   //       ...prev,
//   //       hired_confirmed: true,
//   //       hired_at: new Date().toISOString(),
//   //     }));
//   //     alert(t("tutorFlow.hired") || "Tutor hire confirmed (100tk charged).");
//   //   } catch (e) {
//   //     console.error(e);
//   //     alert(t("tutorFlow.hiredFailed") || "Failed to confirm hire.");
//   //   }
//   // };
//   // --- End Tutor flow actions ---

//   const handleCancelClick = () => setShowCancelConfirm(true);
//   const handleCancelNo = () => setShowCancelConfirm(false);
//   const handleCancelConfirmYes = () => {
//     setShowCancelConfirm(false);
//     setShowCancelFeedback(true);
//   };
//   const handleFeedbackSubmit = async () => {
//     if (!cancellationReason) {
//       // alert("Please select a reason for cancellation.");
//       // alert(t("orderDetailsView.modals.cancelFeedback.error"));
//       return;
//     }
//     const success = await performCancelOrder(cancellationReason);
//     if (success) {
//       setShowCancelFeedback(false);
//       setShowCancelSuccess(true);
//     }
//   };
//   const handleFeedbackCancel = () => setShowCancelFeedback(false);
//   const handleSuccessOk = () => {
//     setShowCancelSuccess(false);
//     navigate("/profile/orderhistory");
//   };

//   const handleAccountBlockedClose = () => {
//     setShowAccountBlockedModal(false);
//     // Clear token and redirect to login since the user is blocked
//     localStorage.removeItem("token");
//     navigate("/profile/orderhistory");
//   };

//   const handleTaskComplete = async () => {

//     if (isTutor && !order.hired_confirmed) {
//       try {
//         await callTutorEndpoint("hired"); // marks hired + charges 100 as per backend
//         setOrder((prev) => ({
//           ...prev,
//           hired_confirmed: true,
//           hired_at: new Date().toISOString(),
//         }));
//       } catch (e) {
//         console.error(e);
//         // (optional) alert(t("tutorFlow.hiredFailed") || "Failed to confirm hire.");
//       }
//     }

//     setShowTransactionModal(true);
//   };

//   const handleTransactionModalClose = () => {
//     setShowTransactionModal(false);
//   };

//   const handleTransactionSuccess = () => {
//     setShowTransactionModal(false);
//     navigate("/profile/orderhistory");
//   };

//   const handleRebook = () => {
//     // pick the right path based on order.service_name
//     const path =
//       SERVICE_ROUTES[order.service_name] || "/services/home-cleaning";
//     navigate(path, {
//       state: {
//         fromRebook: true,
//         previousOrder: order,
//       },
//     });
//   };

//   // const handleCopyPin = () => {
//   //   navigator.clipboard.writeText(order.verification_pin);
//   //   setCopied(true);
//   //   setTimeout(() => setCopied(false), 2000);
//   // };

//   const handleCopyPin = async () => {
//   try {
//     const text = String(order?.verification_pin ?? "");

//     // Preferred: modern Clipboard API (requires HTTPS or localhost)
//     if (navigator.clipboard && window.isSecureContext) {
//       await navigator.clipboard.writeText(text);
//     } else {
//       // Fallback: create a temporary textarea and execCommand('copy')
//       const ta = document.createElement("textarea");
//       ta.value = text;
//       ta.setAttribute("readonly", "");
//       ta.style.position = "fixed";
//       ta.style.left = "-9999px";
//       document.body.appendChild(ta);
//       ta.select();
//       document.execCommand("copy");
//       document.body.removeChild(ta);
//     }

//     setCopied(true);
//     setTimeout(() => setCopied(false), 2000);
//   } catch (err) {
//     console.error("Copy failed:", err);
//     // Last-resort manual copy
//     window.prompt("Copy this PIN:", String(order?.verification_pin ?? ""));
//   }
// };


//   // *** NEW: Helper function to determine if a value should be displayed ***
//   // const hasValue = (value) => {
//   //   if (typeof value === "number") return value > 0; // Show only for 1, 2, 3, etc.
//   //   if (typeof value === "string") return value.toLowerCase() === "yes"; // Show only for "Yes"
//   //   return !!value; // Fallback for other truthy values
//   // };

//   // *** NEW: Helper function to format values with units ***
//   // const formatValue = (value, isBoolean = false) => {
//   //   if (isBoolean) return value ? "Yes" : "No";
//   //   if (typeof value === "number") {
//   //     return value === 1 ? "1 unit" : `${value} units`;
//   //   }
//   //   return value;
//   // };

//   const formatValue = (value, isBoolean = false) => {
//     if (isBoolean)
//       return value
//         ? t("orderDetailsView.serviceDetails.yes")
//         : t("orderDetailsView.serviceDetails.no");
//     if (typeof value === "number") {
//       return value === 1
//         ? `1 ${t("orderDetailsView.serviceDetails.unit")}`
//         : `${value} ${t("orderDetailsView.serviceDetails.units")}`;
//     }
//     return value;
//   };

//   const renderServiceDetails = () => {
//     // 1) pick the right field list (or empty)
//     const fields = serviceFields[order.service_name] || [];

//     // 2) map→filter→format into { label, value } pairs
//     const visible = fields
//       .map(({ prop, labelKey, type }) => {
//         const raw = order[prop];
//         // boolean only if true
//         if (type === "boolean")
//           return raw ? { label: t(labelKey), value: "Yes" } : null;
//         // number skip zero
//         if (type === "number" && Number(raw) === 0) return null;
//         // text skip empty
//         // if (type === "text" && !raw) return null;
//         // return { label: t(labelKey), value: raw };
//         if (type === "text" && !raw) return null;
//         return {
//           label: t(labelKey),
//           value: type === "number" ? formatValue(raw) : raw,
//         };
//       })
//       .filter(Boolean);

//     // 3) render each on its own line
//     if (visible.length === 0) {
//       return <div>{t("orderDetailsView.serviceDetails.noDetails")}</div>;
//     }

//     return visible.map((f, i) => (
//       <div key={i} className="service-detail-item">
//         {f.label}: {f.value}
//       </div>
//     ));
//   };

//   const userDetailsCard = (
//     <div className="OrderDetailsView-card">
//       <div className="OrderDetailsView-cardHeader">User Details</div>
//       {/* <p>
//         <strong>Name:</strong>{" "}
//         {order.User
//           ? `${order.User.FirstName} ${order.User.LastName}`
//           : "Unknown"}
//       </p> */}
//       <p>
//         <strong>{t("orderDetailsView.userDetails.name")}:</strong>{" "}
//         {order.User
//           ? `${order.User.FirstName} ${order.User.LastName}`
//           : t("orderDetailsView.userDetails.unknown")}
//       </p>
//       {/* <p>
//         <strong>Mobile:</strong>{" "}
//         {order.User ? `0${order.User.mobile}` : "Unknown"}
//       </p> */}
//       <p>
//         <strong>{t("orderDetailsView.userDetails.mobile")}:</strong>{" "}
//         {order.User
//           ? `${order.User.mobile}`
//           : t("orderDetailsView.userDetails.unknown")}
//       </p>

//       <p>
//         {/* <strong>City:</strong> {order.usercity || order.City} */}
//         <strong>{t("orderDetailsView.userDetails.city")}:</strong>{" "}
//         {order.usercity || order.City}
//       </p>

//       <p>
//         {/* <strong>City:</strong> {order.usercity || order.City} */}
//         <strong>{t("orderDetailsView.userDetails.area")}:</strong>{" "}
//         {order.userarea || order.Area}
//       </p>

//       <p>
//         {/* <strong>Address:</strong> {order.useraddress || order.Address} */}
//         <strong>{t("orderDetailsView.userDetails.address")}:</strong>{" "}
//         {order.useraddress || order.Address}
//       </p>
//     </div>
//   );

//   const servitorDetailsCard =
//     (order.status === "Accepted" ||
//       order.status === "In-Progress" ||
//       order.status === "Completed") &&
//     order.Servitor ? (
//       <div className="OrderDetails-servitor-card">
//         {/* <h2 className="OrderDetails-servitor-header">Servitor Details</h2> */}
//         <h2 className="OrderDetails-servitor-header">
//           {t("orderDetailsView.servitorDetails.title")}
//         </h2>
//         {/* <hr className="OrderDetails-divider" /> */}
//         <div className="OrderDetails-servitor-top-row">
//           <div className="OrderDetails-servitor-left-half">
//             <img
//               src={
//                 order.Servitor.image
//                   ? `${URL}/uploads/${order.Servitor.image}`
//                   : "https://via.placeholder.com/150"
//               }
//               alt="Servitor"
//               className="OrderDetails-servitor-photo"
//             />
//             <div className="OrderDetails-servitor-info-block">
//               <h4 className="OrderDetails-servitor-name">
//                 {order.Servitor.FirstName} {order.Servitor.LastName}
//               </h4>
//               <div className="OrderDetails-servitor-rating">
//                 <i className="fas fa-star OrderDetails-star-filled"></i>
//                 <span className="OrderDetails-rating-score">
//                   {order.Servitor.rating || 0}
//                 </span>
//                 <span className="OrderDetails-rating-count">
//                   ({order.Servitor.orders_completed || 0} Orders completed)
//                 </span>

//                 {/* <span className="OrderDetails-rating-score">
//                   {t("orderDetailsView.servitorDetails.rating", {
//                     rating: order.Servitor.rating || 0,
//                     count: order.Servitor.orders_completed || 0
//                   })}
//                 </span> */}
//               </div>
//             </div>
//           </div>
//           <div className="OrderDetails-servitor-right-half">
//             <div className="OrderDetails-contact-line">
//               {canSeePhones && order?.Servitor?.mobile ? (
//                   <>
//                     {/* LEFT SLOT: call button replaces the static phone icon */}
//                     <a
//                       className="OrderDetails-callBtn OrderDetails-contact-leading"
//                       href={`tel:${normalizeTel(order.Servitor.mobile)}`}
//                       aria-label={t("orderDetailsView.servitorDetails.callServitor")}
//                       title={t("orderDetailsView.servitorDetails.callServitor")}
//                     >
//                       <FaPhoneAlt />
//                     </a>

//                     {/* Number */}
//                     <span className="OrderDetails-phoneNumber">
//                       {order.Servitor.mobile}
//                     </span>
//                   </>
//                 ) : (
//                   <>
//                     {/* LEFT SLOT: regular phone icon when hidden */}
//                     <i className="fas fa-phone-alt OrderDetails-contact-icon"></i>

//                     {/* Hidden notice */}
//                     <span className="OrderDetails-phoneHidden">
//                       <FaLock className="OrderDetails-lockIcon" />
//                       <span className="OrderDetails-phoneHiddenText">
//                         {t("orderDetailsView.servitorDetails.phoneHiddenUntilApprove")}
//                       </span>
//                     </span>
//                   </>
//                 )}
//             </div>
            
//             {/* <div className="OrderDetails-contact-line">
//               <i className="fas fa-envelope OrderDetails-contact-icon"></i>
//               <span>
//                 {order.Servitor.email ||
//                   t("orderDetailsView.servitorDetails.noEmail")}
//               </span>
//             </div> */}
//             {/* <div className="OrderDetails-contact-line">
//               <i className="fas fa-map-marker-alt OrderDetails-contact-icon"></i>
//               <span>
//                 {order.Servitor.city ||
//                   t("orderDetailsView.servitorDetails.noCity")}
//               </span>
//             </div> */}

//             <div className="OrderDetails-contact-line">
//               <i className="fas fa-map-marker-alt OrderDetails-contact-icon"></i>
//               <span>
//                 {(() => {
//                   const city = order?.Servitor?.city?.trim();
//                   const area = order?.Servitor?.area?.trim();
//                   if (city && area) return `${city}, ${area}`;
//                   if (city) return city;
//                   if (area) return area;
//                   return t("orderDetailsView.servitorDetails.noLocation") 
//                         || t("orderDetailsView.servitorDetails.noCity");
//                 })()}
//               </span>
//             </div>

//           </div>
//         </div>
//         <div className="OrderDetails-servitor-bottom-row">
//           <div className="OrderDetails-servitor-info-box">
//             {/* <div className="OrderDetails-info-label">NID</div> */}
//             <div className="OrderDetails-info-label">
//               {t("orderDetailsView.servitorDetails.nid")}
//             </div>
//             <div className="OrderDetails-info-value">
//               {/* {order.Servitor.NID || "N/A"} */}
//               {order.Servitor.NID || t("orderDetailsView.servitorDetails.na")}
//             </div>
//           </div>
//           <div className="OrderDetails-servitor-info-box">
//             {/* <div className="OrderDetails-info-label">Experience</div> */}
//             <div className="OrderDetails-info-label">
//               {t("orderDetailsView.servitorDetails.experience")}
//             </div>
//             <div className="OrderDetails-info-value">
//               {/* {order.Servitor.experience} years */}
//               {t("orderDetailsView.servitorDetails.years", {
//                 count: order.Servitor.experience,
//               })}
//             </div>
//           </div>
//           <div className="OrderDetails-servitor-info-box">
//             {/* <div className="OrderDetails-info-label">Service</div> */}
//             <div className="OrderDetails-info-label">
//               {t("orderDetailsView.servitorDetails.service")}
//             </div>
//             <div className="OrderDetails-info-value">
//               {/* {order.Servitor.service || "N/A"} */}
//               {order.Servitor.service ||
//                 t("orderDetailsView.servitorDetails.na")}
//             </div>
//           </div>
//         </div>

//         {/* New: View Documents Button */}
//         {isTutor && (
//         <button
//           className="OrderDetailsView-viewDocumentsBtn"
//           onClick={() => setShowDocumentsModal(true)}
//         >
//           <FaEye className="OrderDetailsView-viewDocumentsIcon" />
//           View Documents & Bio
//         </button>
//         )}
//       </div>
//     ) : (
//       <div className="OrderDetails-servitor-card">
//         {/* <h2 className="OrderDetails-servitor-header">Servitor Details</h2> */}
//         <h2 className="OrderDetails-servitor-header">
//           {t("orderDetailsView.servitorDetails.title")}
//         </h2>
//         <p style={{ fontStyle: "italic", color: "#888" }}>
//           {/* Servitor has not accepted the order yet. */}
//           {t("orderDetailsView.servitorDetails.notAccepted")}
//         </p>
//       </div>
//     );

//   return (
//     <div className="OrderDetailsView-container">
//       {/* <h4 className="OrderDetailsView-mainTitle">HelpNao - Order Details</h4> */}
//       <h4 className="OrderDetailsView-mainTitle">
//         {t("orderDetailsView.mainTitle")}
//       </h4>
//       <hr />
//       <div className="OrderDetailsView-invoiceHeader">
//         <div className="invoice-left">
//           <p className="OrderDetailsView-invoiceText">
//             {/* <strong>Placed Order Date:</strong>{" "} */}
//             <strong>
//               {t("orderDetailsView.invoice.placedOrderDate")}:
//             </strong>{" "}
//             {/* {new Date(order.created_at).toLocaleDateString()} */}
//             {order?.created_at ? formatDate(order.created_at) : "TBD"}
//           </p>
//           <p className="OrderDetailsView-invoiceText">
//             {/* <strong>Service Delivered Date:</strong>{" "} */}
//             <strong>
//               {t("orderDetailsView.invoice.serviceDeliveredDate")}:
//             </strong>{" "}
//             {/* {order.date ? new Date(order.date).toLocaleDateString() : "TBD"} */}
//             {order?.date ? formatDate(order.date) : "TBD"}
//           </p>
//           <p className="OrderDetailsView-invoiceText">
//             {/* <strong>Service Delivered Time:</strong> {order.time} */}
//             <strong>
//               {t("orderDetailsView.invoice.serviceDeliveredTime")}:
//             </strong>{" "}
//             {order.time}
//           </p>
//           <p className="OrderDetailsView-invoiceText">
//             <strong>{t("orderDetailsView.invoice.deadline")}:</strong>{" "}
//             {order?.deadline ? formatDateTime(order.deadline) : "TBD"}
//           </p>
//           <p className="OrderDetailsView-invoiceText">
//             {/* <strong>Order Status:</strong> {order.status} */}
//             <strong>{t("orderDetailsView.invoice.orderStatus")}:</strong>{" "}
//             {order.status}
//           </p>
//         </div>
//         <div className="invoice-right">
//           <p className="OrderDetailsView-invoiceText">
//             {/* <strong>Invoice Order#:</strong> {order.order_number} */}
//             <strong>{t("orderDetailsView.invoice.invoiceOrder")}:</strong>{" "}
//             {order.order_number}
//           </p>
//         </div>
//       </div>

//       <OrderTimeline order={order} />

//       {order.status === "Completed" && (
//         <div className="OrderDetailsView-completedBanner">
//           {/* <h3>This order is successfully completed.</h3>
//           <p>Stay with HelpNao</p> */}
//           <h3>{t("orderDetailsView.completedBanner.title")}</h3>
//           <p>{t("orderDetailsView.completedBanner.subtitle")}</p>
//         </div>
//       )}

//       <div className="OrderDetailsView-flexWrap">
//         {servitorDetailsCard}
//         {userDetailsCard}
//       </div>

//       <div className="OrderDetailsView-invoiceDetails">
//         <table className="OrderDetailsView-table">
//           <thead>
//             <tr>
//               {/* <th>Service</th>
//               <th>Details</th>
//               <th>Amount</th> */}

//               <th>{t("orderDetailsView.serviceDetails.service")}</th>
//               <th>{t("orderDetailsView.serviceDetails.details")}</th>
//               <th>{t("orderDetailsView.serviceDetails.amount")}</th>
//             </tr>
//           </thead>
//           <tbody>
//             <tr>
//               {/* <td>
//                 {order.Service
//                   ? order.Service.services_name
//                   : order.service_name || "Unknown"}
//               </td> */}
//               <td>
//                 {order.Service
//                   ? order.Service.services_name
//                   : order.service_name ||
//                     t("orderDetailsView.userDetails.unknown")}
//               </td>

//               <td>{renderServiceDetails()}</td>
//               <td>{order.price} tk</td>
//             </tr>
//           </tbody>
//         </table>
//       </div>

//       {/* Reamrks */}
//       {order.remarks && (
//         <div className="OrderDetailsView-remarksRow">
//           <FaCheckSquare className="OrderDetailsView-remarksIcon" />
//           <strong>{t("orderDetailsView.remarks.title")}:</strong>{" "}
//           <span className="OrderDetailsView-remarksText">{order.remarks}</span>
//         </div>
//       )}

//       {/* {order.status === "Accepted" && order.verification_pin && ( */}
//       {order.verification_pin &&
//         order.status === "Accepted" &&
//         ((isTutor && order.user_approved) || !isTutor) && (
//           <div className="OrderDetailsView-pinCard">
//             {/* <h3>Verification PIN</h3>
//           <p>
//             This is the PIN provided when the servitor arrived for verification.
//             Please note it down for your records.
//           </p> */}
//             {/* <h3>{t("orderDetailsView.verificationPin.title")}</h3>
//           <p>{t("orderDetailsView.verificationPin.description")}</p> */}

//             {/* <div className="pin-display">{order.verification_pin}</div> */}

//             {/* <div className="pin-display">
//             {order.verification_pin}
//             <button
//               className="pin-copy-btn"
//               onClick={() => {
//                 navigator.clipboard.writeText(order.verification_pin);
//                 setCopied(true);
//                 setTimeout(() => setCopied(false), 2000);
//               }}
//             >
//               <FaClipboard />
//             </button>
//           </div>
//           {copied && <div className="pin-copied-feedback">Copied!</div>} */}

//             <div className="OrderDetailsView-pinCardHeader">
//               <FaLock className="OrderDetailsView-pinIcon" />
//               <h3>{t("orderDetailsView.verificationPin.title")}</h3>
//             </div>
//             <p>{t("orderDetailsView.verificationPin.description")}</p>
//             <div className="OrderDetailsView-pinContainer">
//               <div className="OrderDetailsView-pinDisplay">
//                 {order.verification_pin}
//               </div>
//               <button
//                 className={`OrderDetailsView-copyBtn ${copied ? "copied" : ""}`}
//                 onClick={handleCopyPin}
//               >
//                 {copied ? (
//                   <>
//                     <FaCheck className="OrderDetailsView-copyIcon" />
//                     {t("orderDetailsView.verificationPin.copied")}
//                   </>
//                 ) : (
//                   <>
//                     <FaCopy className="OrderDetailsView-copyIcon" />
//                     {t("orderDetailsView.verificationPin.copy")}
//                   </>
//                 )}
//               </button>
//             </div>
//           </div>
//         )}

//       <div className="OrderDetailsView-buttonRow">
//         <button
//           className="OrderDetailsView-backBtn"
//           onClick={() => navigate("/profile/orderhistory")}
//         >
//           {/* ← Back */}← {t("orderDetailsView.buttons.back")}
//         </button>
//         <div className="OrderDetailsView-actionGroup">
//           {(order.status === "pending" ||
//             order.status === "Accepted") 
//             // ||  order.status === "In-Progress") 
//             && (
//             <button
//               className="OrderDetailsView-cancelBtn"
//               onClick={handleCancelClick}
//             >
//               {/* Cancel Order */}
//               {t("orderDetailsView.buttons.cancelOrder")}
//             </button>
//           )}

//           {!isTutor && (order.status === "pending" || order.status === "Accepted" || order.status === "In-Progress") && (
//             <button
//               className="OrderDetailsView-editBtn"
//               onClick={() => setShowEditModal(true)}
//               // title={t("orderDetailsView.buttons.edit")}
//               // title="Add more items/time to this order"
//               // style={{ backgroundColor: "#3b82f6", color: "#fff" }}
//             >
//               {/* Edit */}
//               {t("orderDetailsView.buttons.edit")}
//             </button>
//           )}
//           {order.status === "Completed" && (
//             <>
//               <button
//                 className="OrderDetailsView-receiptBtn"
//                 // onClick={() => ReceiptGenerator({ order })}
//                 onClick={() => setShowReceipt(true)}
//               >
//                 <FaDownload className="OrderDetailsView-receiptIcon" />
//                 {/* Receipt */}
//                 {t("orderDetailsView.buttons.receipt")}
//               </button>

//               <button
//                 className="OrderDetailsView-rebookBtn"
//                 onClick={handleRebook}
//               >
//                 <FaRedo className="OrderDetailsView-rebookIcon" />
//                 {/* Rebook */}
//                 {t("orderDetailsView.buttons.rebook")}
//               </button>
//             </>
//           )}
//           {order.status === "In-Progress" && (
//             <button
//               className="OrderDetailsView-taskCompleteBtn"
//               onClick={handleTaskComplete}
//             >
//               {/* Task Complete */}
//               {/* {t("orderDetailsView.buttons.taskComplete")} */}
//               {isTutor
//                 ? "Tutor Hired"
//                 : t("orderDetailsView.buttons.taskComplete")}
//             </button>
//           )}

//           {/* Tutor-only: before approval (Accepted) */}
//           {isTutor && order.status === "Accepted" && !order.user_approved && (
//             <>
//               <button
//                 className="OrderDetailsView-approveBtn"
//                 onClick={handleApproveTutor}
//               >
//                 {/* {t("tutorFlow.buttons.approve") || "Approve Tutor"} */}
//                 Approve Tutor
//               </button>
//               <button
//                 className="OrderDetailsView-findAnotherBtn"
//                 onClick={handleFindAnotherTutor}
//               >
//                 {/* {t("tutorFlow.buttons.findAnother") || "Find another tutor"} */}
//                 Find another tutor
//               </button>
//             </>
//           )}

//           {/* {isTutor &&
//             order.status === "In-Progress" &&
//             !order.hired_confirmed && (
//               <button
//                 className="OrderDetailsView-hiredBtn"
//                 onClick={handleConfirmTutorHired}
//               > */}
//           {/* {t("tutorFlow.buttons.hired") || "Confirm Tutor Hired"} */}
//           {/* Confirm Tutor Hired
//               </button>
//             )} */}
//         </div>
//       </div>

//       {/* Cancel Confirm Modal */}
//       <Modal
//         show={showCancelConfirm}
//         onHide={handleCancelNo}
//         centered
//         dialogClassName="OrderDetailsView-cancel-confirm-modal"
//       >
//         <Modal.Header closeButton>
//           {/* <Modal.Title>Confirm Cancellation</Modal.Title> */}
//           <Modal.Title>
//             {t("orderDetailsView.modals.cancelConfirm.title")}
//           </Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           {/* <p>Are you sure you want to cancel this order?</p> */}
//           <p>{t("orderDetailsView.modals.cancelConfirm.body")}</p>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={handleCancelNo}>
//             {/* No */}
//             {t("orderDetailsView.modals.cancelConfirm.no")}
//           </Button>
//           <Button variant="danger" onClick={handleCancelConfirmYes}>
//             {/* Yes, Cancel Order */}
//             {t("orderDetailsView.modals.cancelConfirm.yes")}
//           </Button>
//         </Modal.Footer>
//       </Modal>
//       <Modal
//         show={showCancelFeedback}
//         onHide={handleFeedbackCancel}
//         centered
//         dialogClassName="OrderDetailsView-cancel-feedback-modal"
//       >
//         <Modal.Header closeButton>
//           {/* <Modal.Title>Cancellation Feedback</Modal.Title> */}
//           <Modal.Title>
//             {t("orderDetailsView.modals.cancelFeedback.title")}
//           </Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           {/* <p>Please let us know why you are canceling your order:</p> */}
//           <p>{t("orderDetailsView.modals.cancelFeedback.body")}</p>
//           {/* <Form>
//             <Form.Check
//               type="radio"
//               label="Service is taking too long"
//               name="cancellationReason"
//               value="Service is taking too long"
//               checked={cancellationReason === "Service is taking too long"}
//               onChange={(e) => setCancellationReason(e.target.value)}
//             />
//             <Form.Check
//               type="radio"
//               label="Found another provider"
//               name="cancellationReason"
//               value="Found another provider"
//               checked={cancellationReason === "Found another provider"}
//               onChange={(e) => setCancellationReason(e.target.value)}
//             />
//             <Form.Check
//               type="radio"
//               label="No longer need the service"
//               name="cancellationReason"
//               value="No longer need the service"
//               checked={cancellationReason === "No longer need the service"}
//               onChange={(e) => setCancellationReason(e.target.value)}
//             />
//             <Form.Check
//               type="radio"
//               label="Other"
//               name="cancellationReason"
//               value="Other"
//               checked={cancellationReason === "Other"}
//               onChange={(e) => setCancellationReason(e.target.value)}
//             />
//           </Form> */}

//           <Form>
//             <Form.Check
//               type="radio"
//               label={t(
//                 "orderDetailsView.modals.cancelFeedback.reasons.tooLong"
//               )}
//               name="cancellationReason"
//               value={t(
//                 "orderDetailsView.modals.cancelFeedback.reasons.tooLong"
//               )}
//               checked={
//                 cancellationReason ===
//                 t("orderDetailsView.modals.cancelFeedback.reasons.tooLong")
//               }
//               onChange={(e) => setCancellationReason(e.target.value)}
//             />
//             <Form.Check
//               type="radio"
//               label={t(
//                 "orderDetailsView.modals.cancelFeedback.reasons.anotherProvider"
//               )}
//               name="cancellationReason"
//               value={t(
//                 "orderDetailsView.modals.cancelFeedback.reasons.anotherProvider"
//               )}
//               checked={
//                 cancellationReason ===
//                 t(
//                   "orderDetailsView.modals.cancelFeedback.reasons.anotherProvider"
//                 )
//               }
//               onChange={(e) => setCancellationReason(e.target.value)}
//             />
//             <Form.Check
//               type="radio"
//               label={t("orderDetailsView.modals.cancelFeedback.reasons.noNeed")}
//               name="cancellationReason"
//               value={t("orderDetailsView.modals.cancelFeedback.reasons.noNeed")}
//               checked={
//                 cancellationReason ===
//                 t("orderDetailsView.modals.cancelFeedback.reasons.noNeed")
//               }
//               onChange={(e) => setCancellationReason(e.target.value)}
//             />
//             <Form.Check
//               type="radio"
//               label={t("orderDetailsView.modals.cancelFeedback.reasons.other")}
//               name="cancellationReason"
//               value={t("orderDetailsView.modals.cancelFeedback.reasons.other")}
//               checked={
//                 cancellationReason ===
//                 t("orderDetailsView.modals.cancelFeedback.reasons.other")
//               }
//               onChange={(e) => setCancellationReason(e.target.value)}
//             />
//           </Form>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={handleFeedbackCancel}>
//             {/* Cancel */}
//             {t("orderDetailsView.modals.cancelFeedback.cancel")}
//           </Button>
//           <Button variant="primary" onClick={handleFeedbackSubmit}>
//             {/* Submit */}
//             {t("orderDetailsView.modals.cancelFeedback.submit")}
//           </Button>
//         </Modal.Footer>
//       </Modal>
//       <Modal
//         show={showCancelSuccess}
//         onHide={handleSuccessOk}
//         centered
//         dialogClassName="OrderDetailsView-cancel-success-modal"
//       >
//         <Modal.Header closeButton>
//           {/* <Modal.Title>Order Cancelled</Modal.Title> */}
//           <Modal.Title>
//             {t("orderDetailsView.modals.cancelSuccess.title")}
//           </Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           {/* <p>Your order has been cancelled successfully.</p> */}
//           <p>{t("orderDetailsView.modals.cancelSuccess.body")}</p>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="primary" onClick={handleSuccessOk}>
//             {/* OK */}
//             {t("orderDetailsView.modals.cancelSuccess.ok")}
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Added: Modal for account blocked */}
//       <Modal
//         show={showAccountBlockedModal}
//         onHide={handleAccountBlockedClose}
//         centered
//       >
//         <Modal.Header closeButton>
//           {/* <Modal.Title>Account Blocked</Modal.Title> */}
//           <Modal.Title>
//             {t("orderDetailsView.modals.accountBlocked.title")}
//           </Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <p>{blockedMessage}</p>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="primary" onClick={handleAccountBlockedClose}>
//             {/* OK */}
//             {t("orderDetailsView.modals.accountBlocked.ok")}
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {showTransactionModal && (
//         <TransactionModal
//           order={order}
//           onClose={handleTransactionModalClose}
//           onSuccess={handleTransactionSuccess}
//         />
//       )}

//       {showReceipt && (
//         <ReceiptGenerator
//           order={order}
//           onFinish={() => setShowReceipt(false)}
//         />
//       )}

//       <ServitorDocuments
//         show={showDocumentsModal}
//         onHide={() => setShowDocumentsModal(false)}
//         servitor={order.Servitor}
//         servitorId={order.servitor_id}
//       />

//       <ServiceEditModal
//         show={showEditModal}
//         onHide={() => setShowEditModal(false)}
//         order={order}
//         URL={URL}
//         onApplied={(serverResult) => {
//           // Optional optimistic refresh after apply/submit:
//           // If backend returns new totals/deadline, reflect them.
//           if (serverResult?.newTotal) {
//             setOrder((prev) => ({ ...prev, price: serverResult.newTotal }));
//           }
//           if (serverResult?.deadline) {
//             setOrder((prev) => ({ ...prev, deadline: serverResult.deadline }));
//           }
//           // If only "submitted for approval", still close the modal
//           fetchOrderDetails();
//           setShowEditModal(false);
//         }}
//       />

//     </div>
//   );
// };

// export default OrderDetailsView;







// ***** Update Servie details with new design add getNumberedServiceDetails() (29-Oct-2025) ***** //

import React, { useState, useEffect, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  FaRedo,
  FaDownload,
  FaCheckSquare,
  FaLock,
  FaCopy,
  FaCheck,
  FaEye,
  FaPhoneAlt,

} from "react-icons/fa";
import { jwtDecode } from "jwt-decode";
import { URL } from "../../../config";
import { Modal, Button, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
// import "./userprofile.css";
import TransactionModal from "./TransactionModal";
import ReceiptGenerator from "./ReceiptGenerator";
import "./OrderDetailsView.css";
import OrderTimeline from "../Modal/OrderTimeline";
import { serviceFields } from "../../Services/serviceFields";
import ServitorDocuments from "../Modal/ServitorDocuments";
import ServiceEditModal from "../Modal/ServiceEditModal";
import { formatDate, formatDateTime } from "../../dateTimefrontpart";
import Loader from "../../../Components/LoaderSpin/Loader";

const OrderDetailsView = () => {
  const { t } = useTranslation();

  const { orderId } = useParams(); // orderId is the order number, e.g. "PS-1009"
  const navigate = useNavigate();

  const SERVICE_ROUTES = {
    "Home Cleaning": "/services/home-cleaning",
    Electrician: "/services/electrician",
    Plumber: "/services/plumber",
    "Gas Chula": "/services/gas-chula",
    "AC Service": "/services/ac-service",
    Filter: "/services/filter",
    "Tutor Service": "/services/tutor-service",
  };

  const [order, setOrder] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  // Cancellation and transaction states remain unchanged
  const [showCancelConfirm, setShowCancelConfirm] = useState(false);
  const [showCancelFeedback, setShowCancelFeedback] = useState(false);
  const [showCancelSuccess, setShowCancelSuccess] = useState(false);
  const [cancellationReason, setCancellationReason] = useState("");
  const [showTransactionModal, setShowTransactionModal] = useState(false);
  const [copied, setCopied] = useState(false);

  const [showAccountBlockedModal, setShowAccountBlockedModal] = useState(false);
  const [blockedMessage, setBlockedMessage] = useState("");

  const [showReceipt, setShowReceipt] = useState(false);

  // --- New state for documents modal ---
  const [showDocumentsModal, setShowDocumentsModal] = useState(false);

  const [showEditModal, setShowEditModal] = useState(false);

  const [showImageModal, setShowImageModal] = useState(false);
  const [previewImageSrc, setPreviewImageSrc] = useState("");


  // --- Tutor-only helpers ---
  const isTutor = order?.service_name === "Tutor Service";
  // const canSeePhones = !isTutor || !!order?.user_approved; // phones unlock after approval
  const isCompleted = order?.status === "Completed";
  const canSeePhones = !isCompleted && (!isTutor || !!order?.user_approved);


  const normalizeTel = (s) => (s ? String(s).replace(/[^+\d]/g, "") : "");

  const getCustomItems = (order) => {
    // prefer backend parsed array
    if (Array.isArray(order?.customServices)) return order.customServices;

    // fallback: parse custom_service_json
    if (!order?.custom_service_json) return [];

    try {
      const parsed =
        typeof order.custom_service_json === "string"
          ? JSON.parse(order.custom_service_json)
          : order.custom_service_json;

      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  };


  // useEffect(() => {
  //   const fetchOrderDetails = async () => {
  //     try {
  //       // Get the logged-in user's id from token
  //       const token = localStorage.getItem("token");
  //       const decodedToken = jwtDecode(token);
  //       // Remove "user-" prefix if it exists
  //       const userId = decodedToken.Id.startsWith("user-")
  //         ? decodedToken.Id.split("user-")[1]
  //         : decodedToken.Id;

  //       // Fetch orders for the user filtered by orderNumber
  //       const response = await fetch(
  //         `${URL}/user/${userId}/orders?orderNumber=${orderId}`
  //       );
  //       if (response.ok) {
  //         const orderData = await response.json();
  //         if (orderData && orderData.length > 0) {
  //           // Use the first (and only) order that matches the order number
  //           setOrder(orderData[0]);
  //         } else {
  //           // setError("No order found with that order number.");
  //           setError(t("orderDetailsView.errors.noOrderFound"));
  //         }
  //       } else {
  //         // setError("Failed to fetch order details");
  //         setError(t("orderDetailsView.errors.fetchFailed"));
  //       }
  //     } catch (err) {
  //       console.error("Error fetching order details:", err);
  //       // setError("Error fetching order details");
  //       setError(t("orderDetailsView.errors.fetchError"));
  //     }
  //   };

  //   fetchOrderDetails();
  // }, [orderId, t]);



//   const fetchOrderDetails = useCallback(async () => {
//   try {
//     setLoading(true);
//     const token = localStorage.getItem("token");
//     const decodedToken = jwtDecode(token);
//     const userId = decodedToken.Id.startsWith("user-")
//       ? decodedToken.Id.split("user-")[1]
//       : decodedToken.Id;

//     const response = await fetch(
//       `${URL}/user/${userId}/orders?orderNumber=${orderId}`
//     );
//     if (response.ok) {
//       const orderData = await response.json();
//       if (orderData && orderData.length > 0) {
//         setOrder(orderData[0]);
//       } else {
//         setError(t("orderDetailsView.errors.noOrderFound"));
//       }
//     } else {
//       setError(t("orderDetailsView.errors.fetchFailed"));
//     }
//   } catch (err) {
//     console.error("Error fetching order details:", err);
//     setError(t("orderDetailsView.errors.fetchError"));
//   } finally {
//     setLoading(false);
//   }
// }, [orderId, t]);


const fetchOrderDetails = useCallback(
  async ({ silent = false } = {}) => {
    try {
      if (!silent) setLoading(true);

      const token = localStorage.getItem("token");
      const decodedToken = jwtDecode(token);
      const userId = decodedToken.Id.startsWith("user-")
        ? decodedToken.Id.split("user-")[1]
        : decodedToken.Id;

      const response = await fetch(
        `${URL}/user/${userId}/orders?orderNumber=${orderId}`
      );

      if (response.ok) {
        const orderData = await response.json();
        if (orderData && orderData.length > 0) {
          setOrder(orderData[0]);
          setError(null);
        } else {
          setError(t("orderDetailsView.errors.noOrderFound"));
        }
      } else {
        setError(t("orderDetailsView.errors.fetchFailed"));
      }
    } catch (err) {
      console.error("Error fetching order details:", err);
      setError(t("orderDetailsView.errors.fetchError"));
    } finally {
      if (!silent) setLoading(false);
    }
  },
  [orderId, t]
);


useEffect(() => {
  fetchOrderDetails();
}, [fetchOrderDetails]);

const orderStatus = order?.status;

// 2) background polling
useEffect(() => {
  if (orderStatus && ["Completed", "Cancelled"].includes(orderStatus)) {
    return;
  }

  const intervalId = setInterval(() => {
    fetchOrderDetails({ silent: true }); // no loader
  }, 10000);

  return () => clearInterval(intervalId);
}, [orderStatus, fetchOrderDetails]);



  if (error) return <p>{error}</p>;
  if (!order || loading)
    return (
      <p>
        {/* Loading order details... */}
        {/* {t("orderDetailsView.errors.fetchError")} */}
        <Loader
          show
          // brand="HelpNao"
          // message={t("orderDetailsView.loading", "Loading order details…")}
        />
      </p>
    );

  // Cancellation function remains unchanged
  const performCancelOrder = async (reason) => {
    try {
      const endpoint = `${URL}/cancelOrder/${order.Id}`;
      const payload = {
        serviceType: order.service_name,
        cancellation_feedback: reason,
      };
      const response = await fetch(endpoint, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      if (response.ok) {
        return true;
      } else {
        const text = await response.text();
        let errorData;
        try {
          errorData = text ? JSON.parse(text) : { message: text };
        } catch (e) {
          errorData = { message: text };
        }
        console.error("Failed to cancel order:", errorData);

        // Updated: Avoid console error for account blocked case
        if (errorData.errorType === "account_blocked") {
          // setBlockedMessage(
          //   `Your account has been blocked due to excessive cancellations (${errorData.penaltyCount} times). Total penalty: ${errorData.totalPenalty} taka. Please contact support.`
          // );
          setBlockedMessage(errorData.message);
          setShowAccountBlockedModal(true);
          // Updated: Close cancellation feedback modal
          setShowCancelFeedback(false);
          return false;
        }

        // alert("Failed to cancel order.");
        // alert(t("orderDetailsView.errors.cancelFailed"));
        return false;
      }
    } catch (err) {
      console.error("Error cancelling order:", err);
      // alert("Error cancelling order.");
      // alert(t("orderDetailsView.errors.cancelError"));
      return false;
    }
  };

  // --- Tutor flow actions ---
  const callTutorEndpoint = async (path) => {
    const token = localStorage.getItem("token");
    const resp = await fetch(`${URL}/tutor/${order.Id}/${path}`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    });
    if (!resp.ok) {
      const txt = await resp.text();
      throw new Error(txt || "Request failed");
    }
    return resp.json();
  };

  const handleApproveTutor = async () => {
    try {
      const data = await callTutorEndpoint("approve");
      // server returns { verification_pin }
      setOrder((prev) => ({
        ...prev,
        user_approved: true,
        approved_at: new Date().toISOString(),
        verification_pin: data?.verification_pin || prev?.verification_pin,
      }));
      // alert(t("tutorFlow.approved") || "Tutor approved. OTP generated.");
    } catch (e) {
      console.error(e);
      // alert(t("tutorFlow.approveFailed") || "Failed to approve tutor.");
    }
  };

  const handleFindAnotherTutor = async () => {
    try {
      await callTutorEndpoint("find-another");
      // Re-open order: go back to pending and clear assignment + pin
      setOrder((prev) => ({
        ...prev,
        status: "pending",
        servitor_id: null,
        Servitor: null,
        verification_pin: null,
        accepted_at: null,
      }));
      // alert(t("tutorFlow.reopened") || "Order reopened for other tutors.");
    } catch (e) {
      console.error(e);
      // alert(t("tutorFlow.reopenFailed") || "Failed to reopen order.");
    }
  };

  // const handleConfirmTutorHired = async () => {
  //   try {
  //     await callTutorEndpoint("hired");
  //     setOrder((prev) => ({
  //       ...prev,
  //       hired_confirmed: true,
  //       hired_at: new Date().toISOString(),
  //     }));
  //     alert(t("tutorFlow.hired") || "Tutor hire confirmed (100tk charged).");
  //   } catch (e) {
  //     console.error(e);
  //     alert(t("tutorFlow.hiredFailed") || "Failed to confirm hire.");
  //   }
  // };
  // --- End Tutor flow actions ---

  const handleCancelClick = () => setShowCancelConfirm(true);
  const handleCancelNo = () => setShowCancelConfirm(false);
  const handleCancelConfirmYes = () => {
    setShowCancelConfirm(false);
    setShowCancelFeedback(true);
  };
  const handleFeedbackSubmit = async () => {
    if (!cancellationReason) {
      // alert("Please select a reason for cancellation.");
      // alert(t("orderDetailsView.modals.cancelFeedback.error"));
      return;
    }
    const success = await performCancelOrder(cancellationReason);
    if (success) {
      setShowCancelFeedback(false);
      setShowCancelSuccess(true);
    }
  };
  const handleFeedbackCancel = () => setShowCancelFeedback(false);
  const handleSuccessOk = () => {
    setShowCancelSuccess(false);
    navigate("/profile/orderhistory");
  };

  const handleAccountBlockedClose = () => {
    setShowAccountBlockedModal(false);
    // Clear token and redirect to login since the user is blocked
    localStorage.removeItem("token");
    navigate("/profile/orderhistory");
  };

  const handleTaskComplete = async () => {

    if (isTutor && !order.hired_confirmed) {
      try {
        await callTutorEndpoint("hired"); // marks hired + charges 100 as per backend
        setOrder((prev) => ({
          ...prev,
          hired_confirmed: true,
          hired_at: new Date().toISOString(),
        }));
      } catch (e) {
        console.error(e);
        // (optional) alert(t("tutorFlow.hiredFailed") || "Failed to confirm hire.");
      }
    }

    setShowTransactionModal(true);
  };

  const handleTransactionModalClose = () => {
    setShowTransactionModal(false);
  };

  const handleTransactionSuccess = () => {
    setShowTransactionModal(false);
    navigate("/profile/orderhistory");
  };

  const handleRebook = () => {
    // pick the right path based on order.service_name
    const path =
      SERVICE_ROUTES[order.service_name] || "/services/home-cleaning";
    navigate(path, {
      state: {
        fromRebook: true,
        previousOrder: order,
      },
    });
  };

  // const handleCopyPin = () => {
  //   navigator.clipboard.writeText(order.verification_pin);
  //   setCopied(true);
  //   setTimeout(() => setCopied(false), 2000);
  // };

  const handleCopyPin = async () => {
  try {
    const text = String(order?.verification_pin ?? "");

    // Preferred: modern Clipboard API (requires HTTPS or localhost)
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
    } else {
      // Fallback: create a temporary textarea and execCommand('copy')
      const ta = document.createElement("textarea");
      ta.value = text;
      ta.setAttribute("readonly", "");
      ta.style.position = "fixed";
      ta.style.left = "-9999px";
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
    }

    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  } catch (err) {
    console.error("Copy failed:", err);
    // Last-resort manual copy
    window.prompt("Copy this PIN:", String(order?.verification_pin ?? ""));
  }
};


// *** Show Image *** //
const openImagePreview = (src) => {
  if (!src) return;
  setPreviewImageSrc(src);
  setShowImageModal(true);
};

const closeImagePreview = () => {
  setShowImageModal(false);
  setPreviewImageSrc("");
};


  // *** NEW: Helper function to determine if a value should be displayed ***
  // const hasValue = (value) => {
  //   if (typeof value === "number") return value > 0; // Show only for 1, 2, 3, etc.
  //   if (typeof value === "string") return value.toLowerCase() === "yes"; // Show only for "Yes"
  //   return !!value; // Fallback for other truthy values
  // };

  // *** NEW: Helper function to format values with units ***
  // const formatValue = (value, isBoolean = false) => {
  //   if (isBoolean) return value ? "Yes" : "No";
  //   if (typeof value === "number") {
  //     return value === 1 ? "1 unit" : `${value} units`;
  //   }
  //   return value;
  // };



  // const formatValue = (value, isBoolean = false) => {
  //   if (isBoolean)
  //     return value
  //       ? t("orderDetailsView.serviceDetails.yes")
  //       : t("orderDetailsView.serviceDetails.no");
  //   if (typeof value === "number") {
  //     return value === 1
  //       ? `1 ${t("orderDetailsView.serviceDetails.unit")}`
  //       : `${value} ${t("orderDetailsView.serviceDetails.units")}`;
  //   }
  //   return value;
  // };

  // const renderServiceDetails = () => {
  //   // 1) pick the right field list (or empty)
  //   const fields = serviceFields[order.service_name] || [];

  //   // 2) map→filter→format into { label, value } pairs
  //   const visible = fields
  //     .map(({ prop, labelKey, type }) => {
  //       const raw = order[prop];
  //       // boolean only if true
  //       if (type === "boolean")
  //         return raw ? { label: t(labelKey), value: "Yes" } : null;
  //       // number skip zero
  //       if (type === "number" && Number(raw) === 0) return null;
  //       // text skip empty
  //       // if (type === "text" && !raw) return null;
  //       // return { label: t(labelKey), value: raw };
  //       if (type === "text" && !raw) return null;
  //       return {
  //         label: t(labelKey),
  //         value: type === "number" ? formatValue(raw) : raw,
  //       };
  //     })
  //     .filter(Boolean);

  //   // 3) render each on its own line
  //   if (visible.length === 0) {
  //     return <div>{t("orderDetailsView.serviceDetails.noDetails")}</div>;
  //   }

  //   return visible.map((f, i) => (
  //     <div key={i} className="service-detail-item">
  //       {f.label}: {f.value}
  //     </div>
  //   ));
  // };


  // Build numbered detail rows and expose the total count
  const getNumberedServiceDetails = () => {
    const fields = serviceFields[order.service_name] || [];
  
    const rows = fields
      .map(({ prop, labelKey, type }) => {
        const raw = order[prop];
  
        // booleans: show only when true
        if (type === "boolean") {
          if (!raw) return null;
          return { label: t(labelKey), value: t("orderDetailsView.serviceDetails.yes") };
        }
  
        // numbers: skip zeros
        if (type === "number") {
          if (Number(raw) === 0) return null;
          const unit =
            Number(raw) === 1
              ? t("orderDetailsView.serviceDetails.unit")
              : t("orderDetailsView.serviceDetails.units");
          return { label: t(labelKey), value: `${raw} ${unit}` };
        }
  
        // text: skip empty
        if (type === "text") {
          if (!raw) return null;
          return { label: t(labelKey), value: String(raw) };
        }
  
        return null;
      })
      .filter(Boolean);


      // Append custom services (only if exists)
      const customItems = getCustomItems(order);

      customItems.forEach((c) => {
        const name = String(c?.name || "").trim();
        const price = Number(c?.price || 0);
        if (!name) return;

        rows.push({
          label: "Custom Service",
          value: `${name} (${price} tk)`,
        });
      });
  
    return {
      count: rows.length,
      items: rows.length
        ? rows.map((r, i) => ({ ...r, index: i + 1 }))
        : [{ index: 1, label: t("orderDetailsView.serviceDetails.noDetails"), value: "" }],
    };
  };

  const userDetailsCard = (
    <div className="OrderDetailsView-card">
      <div className="OrderDetailsView-cardHeader">User Details</div>
      {/* <p>
        <strong>Name:</strong>{" "}
        {order.User
          ? `${order.User.FirstName} ${order.User.LastName}`
          : "Unknown"}
      </p> */}
      <p>
        <strong>{t("orderDetailsView.userDetails.name")}:</strong>{" "}
        {order.User
          ? `${order.User.FirstName} ${order.User.LastName}`
          : t("orderDetailsView.userDetails.unknown")}
      </p>
      {/* <p>
        <strong>Mobile:</strong>{" "}
        {order.User ? `0${order.User.mobile}` : "Unknown"}
      </p> */}
      <p>
        <strong>{t("orderDetailsView.userDetails.mobile")}:</strong>{" "}
        {order.User
          ? `${order.User.mobile}`
          : t("orderDetailsView.userDetails.unknown")}
      </p>

      <p>
        {/* <strong>City:</strong> {order.usercity || order.City} */}
        <strong>{t("orderDetailsView.userDetails.city")}:</strong>{" "}
        {order.usercity || order.City}
      </p>

      <p>
        {/* <strong>City:</strong> {order.usercity || order.City} */}
        <strong>{t("orderDetailsView.userDetails.area")}:</strong>{" "}
        {order.userarea || order.Area}
      </p>

      <p>
        {/* <strong>Address:</strong> {order.useraddress || order.Address} */}
        <strong>{t("orderDetailsView.userDetails.address")}:</strong>{" "}
        {order.useraddress || order.Address}
      </p>
    </div>
  );

  const servitorDetailsCard =
    (order.status === "Accepted" ||
      order.status === "In-Progress" ||
      order.status === "Completed") &&
    order.Servitor ? (
      <div className="OrderDetails-servitor-card">
        {/* <h2 className="OrderDetails-servitor-header">Servitor Details</h2> */}
        <h2 className="OrderDetails-servitor-header">
          {t("orderDetailsView.servitorDetails.title")}
        </h2>
        {/* <hr className="OrderDetails-divider" /> */}
        <div className="OrderDetails-servitor-top-row">
          <div className="OrderDetails-servitor-left-half">
            <img
              src={
                order.Servitor.image
                  ? `${URL}/uploads/${order.Servitor.image}`
                  : "https://via.placeholder.com/150"
              }
              alt="Servitor"
              className="OrderDetails-servitor-photo OrderDetails-clickablePhoto"
              onClick={() =>
                  openImagePreview(
                    order.Servitor.image
                      ? `${URL}/uploads/${order.Servitor.image}`
                      : "https://via.placeholder.com/150"
                  )
                }
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    openImagePreview(
                      order.Servitor.image
                        ? `${URL}/uploads/${order.Servitor.image}`
                        : "https://via.placeholder.com/150"
                    );
                  }
                }}
            />
            <div className="OrderDetails-servitor-info-block">
              <h4 className="OrderDetails-servitor-name">
                {order.Servitor.FirstName} {order.Servitor.LastName}
              </h4>
              <div className="OrderDetails-servitor-rating">
                <i className="fas fa-star OrderDetails-star-filled"></i>
                <span className="OrderDetails-rating-score">
                  {order.Servitor.rating || 0}
                </span>
                <span className="OrderDetails-rating-count">
                  ({order.Servitor.orders_completed || 0} Orders completed)
                </span>

                {/* <span className="OrderDetails-rating-score">
                  {t("orderDetailsView.servitorDetails.rating", {
                    rating: order.Servitor.rating || 0,
                    count: order.Servitor.orders_completed || 0
                  })}
                </span> */}
              </div>
            </div>
          </div>
          <div className="OrderDetails-servitor-right-half">
            <div className="OrderDetails-contact-line">
              {canSeePhones && order?.Servitor?.mobile ? (
                  <>
                    {/* LEFT SLOT: call button replaces the static phone icon */}
                    <a
                      className="OrderDetails-callBtn OrderDetails-contact-leading"
                      href={`tel:${normalizeTel(order.Servitor.mobile)}`}
                      aria-label={t("orderDetailsView.servitorDetails.callServitor")}
                      title={t("orderDetailsView.servitorDetails.callServitor")}
                    >
                      <FaPhoneAlt />
                    </a>

                    {/* Number */}
                    <span className="OrderDetails-phoneNumber">
                      {order.Servitor.mobile}
                    </span>
                  </>
                ) : (
                  <>
                    {/* LEFT SLOT: regular phone icon when hidden */}
                    <i className="fas fa-phone-alt OrderDetails-contact-icon"></i>

                    {/* Hidden notice */}
                    <span className="OrderDetails-phoneHidden">
                      <FaLock className="OrderDetails-lockIcon" />
                      <span className="OrderDetails-phoneHiddenText">
                        {t("orderDetailsView.servitorDetails.phoneHiddenUntilApprove")}
                      </span>
                    </span>
                  </>
                )}
            </div>
            
            {/* <div className="OrderDetails-contact-line">
              <i className="fas fa-envelope OrderDetails-contact-icon"></i>
              <span>
                {order.Servitor.email ||
                  t("orderDetailsView.servitorDetails.noEmail")}
              </span>
            </div> */}
            {/* <div className="OrderDetails-contact-line">
              <i className="fas fa-map-marker-alt OrderDetails-contact-icon"></i>
              <span>
                {order.Servitor.city ||
                  t("orderDetailsView.servitorDetails.noCity")}
              </span>
            </div> */}

            <div className="OrderDetails-contact-line">
              <i className="fas fa-map-marker-alt OrderDetails-contact-icon"></i>
              <span>
                {(() => {
                  const city = order?.Servitor?.city?.trim();
                  const area = order?.Servitor?.area?.trim();
                  if (city && area) return `${city}, ${area}`;
                  if (city) return city;
                  if (area) return area;
                  return t("orderDetailsView.servitorDetails.noLocation") 
                        || t("orderDetailsView.servitorDetails.noCity");
                })()}
              </span>
            </div>

          </div>
        </div>
        <div className="OrderDetails-servitor-bottom-row">
          {/* <div className="OrderDetails-servitor-info-box">
            <div className="OrderDetails-info-label">
              {t("orderDetailsView.servitorDetails.nid")}
            </div>
            <div className="OrderDetails-info-value">
              {order.Servitor.NID || t("orderDetailsView.servitorDetails.na")}
            </div>
          </div> */}
          <div className="OrderDetails-servitor-info-box">
            {/* <div className="OrderDetails-info-label">Experience</div> */}
            <div className="OrderDetails-info-label">
              {t("orderDetailsView.servitorDetails.experience")}
            </div>
            <div className="OrderDetails-info-value">
              {/* {order.Servitor.experience} years */}
              {t("orderDetailsView.servitorDetails.years", {
                count: order.Servitor.experience,
              })}
            </div>
          </div>
          <div className="OrderDetails-servitor-info-box">
            {/* <div className="OrderDetails-info-label">Service</div> */}
            <div className="OrderDetails-info-label">
              {t("orderDetailsView.servitorDetails.service")}
            </div>
            <div className="OrderDetails-info-value">
              {/* {order.Servitor.service || "N/A"} */}
              {order.Servitor.service ||
                t("orderDetailsView.servitorDetails.na")}
            </div>
          </div>
        </div>

        {/* New: View Documents Button */}
        {isTutor && (
        <button
          className="OrderDetailsView-viewDocumentsBtn"
          onClick={() => setShowDocumentsModal(true)}
        >
          <FaEye className="OrderDetailsView-viewDocumentsIcon" />
          View Documents & Bio
        </button>
        )}
      </div>
    ) : (
      <div className="OrderDetails-servitor-card">
        {/* <h2 className="OrderDetails-servitor-header">Servitor Details</h2> */}
        <h2 className="OrderDetails-servitor-header">
          {t("orderDetailsView.servitorDetails.title")}
        </h2>
        <p style={{ fontStyle: "italic", color: "#888" }}>
          {/* Servitor has not accepted the order yet. */}
          {t("orderDetailsView.servitorDetails.notAccepted")}
        </p>
      </div>
    );

  return (
    <div className="OrderDetailsView-container">
      {/* <h4 className="OrderDetailsView-mainTitle">HelpNao - Order Details</h4> */}
      <h4 className="OrderDetailsView-mainTitle">
        {t("orderDetailsView.mainTitle")}
      </h4>
      <hr />
      <div className="OrderDetailsView-invoiceHeader">
        <div className="invoice-left">
          <p className="OrderDetailsView-invoiceText">
            {/* <strong>Placed Order Date:</strong>{" "} */}
            <strong>
              {t("orderDetailsView.invoice.placedOrderDate")}:
            </strong>{" "}
            {/* {new Date(order.created_at).toLocaleDateString()} */}
            {order?.created_at ? formatDate(order.created_at) : "TBD"}
          </p>
          <p className="OrderDetailsView-invoiceText">
            {/* <strong>Service Delivered Date:</strong>{" "} */}
            <strong>
              {t("orderDetailsView.invoice.serviceDeliveredDate")}:
            </strong>{" "}
            {/* {order.date ? new Date(order.date).toLocaleDateString() : "TBD"} */}
            {order?.date ? formatDate(order.date) : "TBD"}
          </p>
          <p className="OrderDetailsView-invoiceText">
            {/* <strong>Service Delivered Time:</strong> {order.time} */}
            <strong>
              {t("orderDetailsView.invoice.serviceDeliveredTime")}:
            </strong>{" "}
            {order.time}
          </p>
          <p className="OrderDetailsView-invoiceText">
            <strong>{t("orderDetailsView.invoice.deadline")}:</strong>{" "}
            {order?.deadline ? formatDateTime(order.deadline) : "TBD"}
          </p>
          <p className="OrderDetailsView-invoiceText">
            {/* <strong>Order Status:</strong> {order.status} */}
            <strong>{t("orderDetailsView.invoice.orderStatus")}:</strong>{" "}
            {order.status}
          </p>
        </div>
        <div className="invoice-right">
          <p className="OrderDetailsView-invoiceText">
            {/* <strong>Invoice Order#:</strong> {order.order_number} */}
            <strong>{t("orderDetailsView.invoice.invoiceOrder")}:</strong>{" "}
            {order.order_number}
          </p>
        </div>
      </div>

      <OrderTimeline order={order} />

      {order.status === "Completed" && (
        <div className="OrderDetailsView-completedBanner">
          {/* <h3>This order is successfully completed.</h3>
          <p>Stay with HelpNao</p> */}
          <h3>{t("orderDetailsView.completedBanner.title")}</h3>
          <p>{t("orderDetailsView.completedBanner.subtitle")}</p>
        </div>
      )}

      <div className="OrderDetailsView-flexWrap">
        {servitorDetailsCard}
        {userDetailsCard}
      </div>

      {/* <div className="OrderDetailsView-invoiceDetails">
        <table className="OrderDetailsView-table">
          <thead>
            <tr>
              <th>{t("orderDetailsView.serviceDetails.service")}</th>
              <th>{t("orderDetailsView.serviceDetails.details")}</th>
              <th>{t("orderDetailsView.serviceDetails.amount")}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                {order.Service
                  ? order.Service.services_name
                  : order.service_name ||
                    t("orderDetailsView.userDetails.unknown")}
              </td>

              <td>{renderServiceDetails()}</td>
              <td>{order.price} tk</td>
            </tr>
          </tbody>
        </table>
      </div> */}


      {/* === Service Summary (modern, responsive) === */}
      <section className="ODV-invoiceCard" aria-labelledby="odv-service-title">
        <header className="ODV-invoiceHeaderRow">
        <div className="ODV-serviceTitleWrap">
          <h5 id="odv-service-title" className="ODV-serviceTitle">
            {(order.Service?.services_name) ||
              order.service_name ||
              t("orderDetailsView.userDetails.unknown")}
          </h5>

          {/* count chip (DESKTOP/TABLET ONLY) */}
          {(() => {
            const { count } = getNumberedServiceDetails();
            return (
              <span className="ODV-countChip ODV-count--left">
                {count} {t("orderDetailsView.serviceDetails.items") || "items"}
              </span>
            );
          })()}
        </div>

        {/* order no. + status (+ MOBILE count chip) */}
        <div className="ODV-orderMeta">
          <span className="ODV-orderNo">#{order.order_number}</span>

          {order.status && (
            <span
              className={`ODV-statusPill ODV-status--${String(order.status)
                .toLowerCase()
                .replace(/\s+/g, "-")}`}
            >
              {order.status}
            </span>
          )}

          {/* count chip (MOBILE ONLY, shown on the right) */}
          {(() => {
            const { count } = getNumberedServiceDetails();
            return (
              <span className="ODV-countChip ODV-count--right">
                {count} {t("orderDetailsView.serviceDetails.items") || "items"}
              </span>
            );
          })()}
        </div>
      </header>


        {/* scrollable list */}
        <div className="ODV-detailList" role="list">
          {getNumberedServiceDetails().items.map((row) => (
            <div key={row.index} className="ODV-detailRow" role="listitem">
              <span className="ODV-indexPlain">{row.index}.</span>
              <div className="ODV-detailText">
                <div className="ODV-detailPrimary">{row.label}</div>
                {row.value ? (
                  <div className="ODV-detailSecondary">{row.value}</div>
                ) : null}
              </div>
            </div>
          ))}
        </div>

        {/* total row */}
        <div
          className="ODV-totalRow"
          aria-label={t("orderDetailsView.serviceDetails.total") || "Total"}
        >
          <div className="ODV-totalLabel">
            {t("orderDetailsView.serviceDetails.total") || "Total"}
          </div>
          <div className="ODV-totalAmount">{order.price} Tk</div>
        </div>
      </section>


      {/* Reamrks */}
      {order.remarks && (
        <div className="OrderDetailsView-remarksRow">
          <FaCheckSquare className="OrderDetailsView-remarksIcon" />
          <strong>{t("orderDetailsView.remarks.title")}:</strong>{" "}
          <span className="OrderDetailsView-remarksText">{order.remarks}</span>
        </div>
      )}

      {/* {order.status === "Accepted" && order.verification_pin && ( */}
      {order.verification_pin &&
        order.status === "Accepted" &&
        ((isTutor && order.user_approved) || !isTutor) && (
          <div className="OrderDetailsView-pinCard">
            {/* <h3>Verification PIN</h3>
          <p>
            This is the PIN provided when the servitor arrived for verification.
            Please note it down for your records.
          </p> */}
            {/* <h3>{t("orderDetailsView.verificationPin.title")}</h3>
          <p>{t("orderDetailsView.verificationPin.description")}</p> */}

            {/* <div className="pin-display">{order.verification_pin}</div> */}

            {/* <div className="pin-display">
            {order.verification_pin}
            <button
              className="pin-copy-btn"
              onClick={() => {
                navigator.clipboard.writeText(order.verification_pin);
                setCopied(true);
                setTimeout(() => setCopied(false), 2000);
              }}
            >
              <FaClipboard />
            </button>
          </div>
          {copied && <div className="pin-copied-feedback">Copied!</div>} */}

            <div className="OrderDetailsView-pinCardHeader">
              <FaLock className="OrderDetailsView-pinIcon" />
              <h3>{t("orderDetailsView.verificationPin.title")}</h3>
            </div>
            <p>{t("orderDetailsView.verificationPin.description")}</p>
            <div className="OrderDetailsView-pinContainer">
              <div className="OrderDetailsView-pinDisplay">
                {order.verification_pin}
              </div>
              <button
                className={`OrderDetailsView-copyBtn ${copied ? "copied" : ""}`}
                onClick={handleCopyPin}
              >
                {copied ? (
                  <>
                    <FaCheck className="OrderDetailsView-copyIcon" />
                    {t("orderDetailsView.verificationPin.copied")}
                  </>
                ) : (
                  <>
                    <FaCopy className="OrderDetailsView-copyIcon" />
                    {t("orderDetailsView.verificationPin.copy")}
                  </>
                )}
              </button>
            </div>
          </div>
        )}

      <div className="OrderDetailsView-buttonRow">
        <button
          className="OrderDetailsView-backBtn"
          onClick={() => navigate("/profile/orderhistory")}
        >
          {/* ← Back */}← {t("orderDetailsView.buttons.back")}
        </button>
        <div className="OrderDetailsView-actionGroup">
          {(order.status === "pending" ||
            order.status === "Accepted") 
            // ||  order.status === "In-Progress") 
            && (
            <button
              className="OrderDetailsView-cancelBtn"
              onClick={handleCancelClick}
            >
              {/* Cancel Order */}
              {t("orderDetailsView.buttons.cancelOrder")}
            </button>
          )}

          {!isTutor && (order.status === "pending" || order.status === "Accepted" || order.status === "In-Progress") && (
            <button
              className="OrderDetailsView-editBtn"
              onClick={() => setShowEditModal(true)}
              // title={t("orderDetailsView.buttons.edit")}
              // title="Add more items/time to this order"
              // style={{ backgroundColor: "#3b82f6", color: "#fff" }}
            >
              {/* Edit */}
              {t("orderDetailsView.buttons.edit")}
            </button>
          )}
          {order.status === "Completed" && (
            <>
              <button
                className="OrderDetailsView-receiptBtn"
                // onClick={() => ReceiptGenerator({ order })}
                onClick={() => setShowReceipt(true)}
              >
                <FaDownload className="OrderDetailsView-receiptIcon" />
                {/* Receipt */}
                {t("orderDetailsView.buttons.receipt")}
              </button>

              <button
                className="OrderDetailsView-rebookBtn"
                onClick={handleRebook}
              >
                <FaRedo className="OrderDetailsView-rebookIcon" />
                {/* Rebook */}
                {t("orderDetailsView.buttons.rebook")}
              </button>
            </>
          )}
          {order.status === "In-Progress" && (
            <button
              className="OrderDetailsView-taskCompleteBtn"
              onClick={handleTaskComplete}
            >
              {/* Task Complete */}
              {/* {t("orderDetailsView.buttons.taskComplete")} */}
              {isTutor
                ? "Tutor Hired"
                : t("orderDetailsView.buttons.taskComplete")}
            </button>
          )}

          {/* Tutor-only: before approval (Accepted) */}
          {isTutor && order.status === "Accepted" && !order.user_approved && (
            <>
              <button
                className="OrderDetailsView-approveBtn"
                onClick={handleApproveTutor}
              >
                {/* {t("tutorFlow.buttons.approve") || "Approve Tutor"} */}
                Approve Tutor
              </button>
              <button
                className="OrderDetailsView-findAnotherBtn"
                onClick={handleFindAnotherTutor}
              >
                {/* {t("tutorFlow.buttons.findAnother") || "Find another tutor"} */}
                Find another tutor
              </button>
            </>
          )}

          {/* {isTutor &&
            order.status === "In-Progress" &&
            !order.hired_confirmed && (
              <button
                className="OrderDetailsView-hiredBtn"
                onClick={handleConfirmTutorHired}
              > */}
          {/* {t("tutorFlow.buttons.hired") || "Confirm Tutor Hired"} */}
          {/* Confirm Tutor Hired
              </button>
            )} */}


            <button
              className="OrderDetailsView-helpBtn"
              onClick={() => navigate(`/profile/support/report/${order.order_number}`, { state: { serviceType: order.service_name } })}
              title="Help & Support"
            >
              <i className="fas fa-life-ring" style={{ marginRight: 6 }} />
              {t("orderDetailsView.buttons.helpSupport") || "Help & Support"}
            </button>
        </div>
      </div>

      {/* Cancel Confirm Modal */}
      <Modal
        show={showCancelConfirm}
        onHide={handleCancelNo}
        centered
        dialogClassName="OrderDetailsView-cancel-confirm-modal"
      >
        <Modal.Header closeButton>
          {/* <Modal.Title>Confirm Cancellation</Modal.Title> */}
          <Modal.Title>
            {t("orderDetailsView.modals.cancelConfirm.title")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <p>Are you sure you want to cancel this order?</p> */}
          <p>{t("orderDetailsView.modals.cancelConfirm.body")}</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCancelNo}>
            {/* No */}
            {t("orderDetailsView.modals.cancelConfirm.no")}
          </Button>
          <Button variant="danger" onClick={handleCancelConfirmYes}>
            {/* Yes, Cancel Order */}
            {t("orderDetailsView.modals.cancelConfirm.yes")}
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={showCancelFeedback}
        onHide={handleFeedbackCancel}
        centered
        dialogClassName="OrderDetailsView-cancel-feedback-modal"
      >
        <Modal.Header closeButton>
          {/* <Modal.Title>Cancellation Feedback</Modal.Title> */}
          <Modal.Title>
            {t("orderDetailsView.modals.cancelFeedback.title")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <p>Please let us know why you are canceling your order:</p> */}
          <p>{t("orderDetailsView.modals.cancelFeedback.body")}</p>
          {/* <Form>
            <Form.Check
              type="radio"
              label="Service is taking too long"
              name="cancellationReason"
              value="Service is taking too long"
              checked={cancellationReason === "Service is taking too long"}
              onChange={(e) => setCancellationReason(e.target.value)}
            />
            <Form.Check
              type="radio"
              label="Found another provider"
              name="cancellationReason"
              value="Found another provider"
              checked={cancellationReason === "Found another provider"}
              onChange={(e) => setCancellationReason(e.target.value)}
            />
            <Form.Check
              type="radio"
              label="No longer need the service"
              name="cancellationReason"
              value="No longer need the service"
              checked={cancellationReason === "No longer need the service"}
              onChange={(e) => setCancellationReason(e.target.value)}
            />
            <Form.Check
              type="radio"
              label="Other"
              name="cancellationReason"
              value="Other"
              checked={cancellationReason === "Other"}
              onChange={(e) => setCancellationReason(e.target.value)}
            />
          </Form> */}

          <Form>
            <Form.Check
              type="radio"
              label={t(
                "orderDetailsView.modals.cancelFeedback.reasons.tooLong"
              )}
              name="cancellationReason"
              value={t(
                "orderDetailsView.modals.cancelFeedback.reasons.tooLong"
              )}
              checked={
                cancellationReason ===
                t("orderDetailsView.modals.cancelFeedback.reasons.tooLong")
              }
              onChange={(e) => setCancellationReason(e.target.value)}
            />
            <Form.Check
              type="radio"
              label={t(
                "orderDetailsView.modals.cancelFeedback.reasons.anotherProvider"
              )}
              name="cancellationReason"
              value={t(
                "orderDetailsView.modals.cancelFeedback.reasons.anotherProvider"
              )}
              checked={
                cancellationReason ===
                t(
                  "orderDetailsView.modals.cancelFeedback.reasons.anotherProvider"
                )
              }
              onChange={(e) => setCancellationReason(e.target.value)}
            />
            <Form.Check
              type="radio"
              label={t("orderDetailsView.modals.cancelFeedback.reasons.noNeed")}
              name="cancellationReason"
              value={t("orderDetailsView.modals.cancelFeedback.reasons.noNeed")}
              checked={
                cancellationReason ===
                t("orderDetailsView.modals.cancelFeedback.reasons.noNeed")
              }
              onChange={(e) => setCancellationReason(e.target.value)}
            />
            <Form.Check
              type="radio"
              label={t("orderDetailsView.modals.cancelFeedback.reasons.other")}
              name="cancellationReason"
              value={t("orderDetailsView.modals.cancelFeedback.reasons.other")}
              checked={
                cancellationReason ===
                t("orderDetailsView.modals.cancelFeedback.reasons.other")
              }
              onChange={(e) => setCancellationReason(e.target.value)}
            />
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleFeedbackCancel}>
            {/* Cancel */}
            {t("orderDetailsView.modals.cancelFeedback.cancel")}
          </Button>
          <Button variant="primary" onClick={handleFeedbackSubmit}>
            {/* Submit */}
            {t("orderDetailsView.modals.cancelFeedback.submit")}
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={showCancelSuccess}
        onHide={handleSuccessOk}
        centered
        dialogClassName="OrderDetailsView-cancel-success-modal"
      >
        <Modal.Header closeButton>
          {/* <Modal.Title>Order Cancelled</Modal.Title> */}
          <Modal.Title>
            {t("orderDetailsView.modals.cancelSuccess.title")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <p>Your order has been cancelled successfully.</p> */}
          <p>{t("orderDetailsView.modals.cancelSuccess.body")}</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleSuccessOk}>
            {/* OK */}
            {t("orderDetailsView.modals.cancelSuccess.ok")}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Added: Modal for account blocked */}
      <Modal
        show={showAccountBlockedModal}
        onHide={handleAccountBlockedClose}
        centered
      >
        <Modal.Header closeButton>
          {/* <Modal.Title>Account Blocked</Modal.Title> */}
          <Modal.Title>
            {t("orderDetailsView.modals.accountBlocked.title")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{blockedMessage}</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleAccountBlockedClose}>
            {/* OK */}
            {t("orderDetailsView.modals.accountBlocked.ok")}
          </Button>
        </Modal.Footer>
      </Modal>


      <Modal
        show={showImageModal}
        onHide={closeImagePreview}
        centered
        dialogClassName="OrderDetailsView-imageModal"
        contentClassName="OrderDetailsView-imageModalContent"
      >
        <Modal.Body className="OrderDetailsView-imageModalBody">
          <button
            type="button"
            className="OrderDetailsView-imageClose"
            onClick={closeImagePreview}
            aria-label="Close image"
            title="Close"
          >
            ×
          </button>

          <img
            src={previewImageSrc}
            alt="Servitor preview"
            className="OrderDetailsView-previewImage"
          />
        </Modal.Body>
      </Modal>


      {showTransactionModal && (
        <TransactionModal
          order={order}
          onClose={handleTransactionModalClose}
          onSuccess={handleTransactionSuccess}
        />
      )}

      {showReceipt && (
        <ReceiptGenerator
          order={order}
          onFinish={() => setShowReceipt(false)}
        />
      )}

      <ServitorDocuments
        show={showDocumentsModal}
        onHide={() => setShowDocumentsModal(false)}
        servitor={order.Servitor}
        servitorId={order.servitor_id}
      />

      <ServiceEditModal
        show={showEditModal}
        onHide={() => setShowEditModal(false)}
        order={order}
        URL={URL}
        onApplied={(serverResult) => {
          // Optional optimistic refresh after apply/submit:
          // If backend returns new totals/deadline, reflect them.
          if (serverResult?.newTotal) {
            setOrder((prev) => ({ ...prev, price: serverResult.newTotal }));
          }
          if (serverResult?.deadline) {
            setOrder((prev) => ({ ...prev, deadline: serverResult.deadline }));
          }
          // If only "submitted for approval", still close the modal
          fetchOrderDetails();
          setShowEditModal(false);
        }}
      />

    </div>
  );
};

export default OrderDetailsView;
